/*
  Italian interface strings. Keys are the English source (see ./index.js);
  a key missing here falls back to English. Generated from the Russian/Spanish key set
  and checked for placeholders and markup; edit by hand like any other map.
*/

const it = {
  "White pages": "White page",
  "Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)": "Pagine statiche per bot e revisione annunci — ospitate qui, servite dallo stesso dominio (cloaking sicuro per Google)",
  "White pages (hosted, same-origin)": "White pages (ospitate, stesso dominio)",
  "Safe page URL (external)": "URL della pagina sicura (esterna)",
  "External safe page — the tracker proxies it same-origin (identity tags stripped). Used when no white page is selected. Must be an absolute http(s) URL. This method already passes Google review on its own; a hosted white page is just an extra-robust alternative served fully on your domain.": "Pagina sicura esterna — il tracker la serve come proxy dallo stesso dominio (tag identificativi rimossi). Usata quando non è selezionata nessuna white page. Deve essere un URL http(s) assoluto. Questo metodo supera già da solo la revisione di Google; una white page ospitata è solo un'alternativa ancora più robusta, servita interamente dal tuo dominio.",
  "Optional — the most robust option for Google/Facebook: served from your own campaign domain (/wp/…), so the final URL stays on-domain. Select several to rotate a random one per request, so one white isn’t reused across hundreds of ads. Manage under White pages.": "Opzionale — l'opzione più robusta per Google/Facebook: viene servita dal tuo dominio di campagna (/wp/…), così l'URL finale resta sul dominio. Selezionane più di una per ruotarne una a caso a ogni richiesta, così una white non viene riutilizzata su centinaia di annunci. Gestiscile in White pages.",
  "selected — rotated per request": "selezionate — ruotate a ogni richiesta",
  "No white pages yet. Upload some under White pages, then pick them here.": "Ancora nessuna white page. Caricane alcune in White pages, poi scegline qui.",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Select several to rotate a random one per request — so one white isn’t reused across hundreds of ads. Manage under White pages.": "Consigliata per Google/Facebook: viene servita dal tuo dominio di campagna (/wp/…), così l'URL finale dell'annuncio resta sul dominio e supera la revisione. Selezionane più di una per ruotarne una a caso a ogni richiesta — così una white non viene riutilizzata su centinaia di annunci. Gestiscile in White pages.",
  "Static pages for bots & ad review": "Pagine statiche per bot e revisione annunci",
  "Compliant static pages served to bots and ad reviewers — same-origin on your campaign domain.": "Pagine statiche conformi mostrate a bot e revisori degli annunci — dallo stesso dominio della tua campagna.",
  "These pages are hosted here and served same-origin at /wp/<slug>/ on any of your verified domains. Pick one in a campaign’s Cloaking settings — bots and Google/Facebook reviewers get this page, real users get the offer.": "Queste pagine sono ospitate qui e servite dallo stesso dominio su /wp/<slug>/ su uno qualsiasi dei tuoi domini verificati. Scegline una nelle impostazioni di Cloaking della campagna — bot e revisori di Google/Facebook vedranno questa pagina, gli utenti reali vedranno l'offerta.",
  "Upload white page": "Carica white page",
  "Upload a static ZIP (index.html + assets). PHP is not allowed. Max 50MB.": "Carica uno ZIP statico (index.html + risorse). PHP non è consentito. Max 50MB.",
  "My white page": "La mia white page",
  "What this white page is for": "A cosa serve questa white page",
  "Static files only (.html/.css/.js/images). No .php.": "Solo file statici (.html/.css/.js/immagini). Niente .php.",
  "Please enter a name for the white page": "Inserisci un nome per la white page",
  "White page uploaded successfully": "White page caricata correttamente",
  "Error uploading white page": "Errore durante il caricamento della white page",
  "Error loading white pages": "Errore durante il caricamento delle white pages",
  "Error deleting white page": "Errore durante l'eliminazione della white page",
  "White page deleted": "White page eliminata",
  "No white pages": "Nessuna white page",
  "Upload a static white page to use for campaign cloaking": "Carica una white page statica da usare per il cloaking della campagna",
  "Search white pages…": "Cerca white page…",
  "Same-origin path": "Percorso stesso dominio",
  "Delete white page": "Elimina white page",
  "This permanently deletes \"{name}\" and its files. Campaigns still pointing at it will fall back to their Safe page URL (or the offer if none).": "Questa operazione elimina definitivamente \"{name}\" e i suoi file. Le campagne che la usano ancora torneranno alla loro URL della pagina sicura (o all'offerta se non è impostata).",
  "Multiple HTML pages detected. Select the main page bots will land on.": "Sono state rilevate più pagine HTML. Seleziona la pagina principale su cui atterreranno i bot.",
  "White page (hosted, same-origin)": "White page (ospitata, stesso dominio)",
  "None — use Safe page URL below": "Nessuna — usa l'URL della pagina sicura qui sotto",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Manage these under White pages.": "Consigliata per Google/Facebook: viene servita dal tuo dominio di campagna (/wp/…), quindi l'URL finale dell'annuncio resta sullo stesso dominio e supera la revisione. Gestiscile in White page.",
  "Safe page URL (external fallback)": "URL pagina sicura (fallback esterno)",
  "Optional fallback, used only when no white page is selected above. Must be an absolute http(s) URL. Note: an external URL lives on another domain — exactly what triggers Google’s “destination mismatch”, so prefer a white page for paid search.": "Fallback facoltativo, usato solo se sopra non è selezionata nessuna white page. Deve essere un URL http(s) assoluto. Nota: un URL esterno si trova su un altro dominio — esattamente ciò che fa scattare il “destination mismatch” di Google, quindi per il paid search preferisci una white page.",
  "Select a white page or enter a valid http(s) Safe page URL for cloaking": "Seleziona una white page o inserisci un URL http(s) valido di pagina sicura per il cloaking",
  "The ready-to-copy tracking link for this campaign. Swap the domain for any verified workspace domain to run several domains on one campaign; the ad network fills the placeholders at click time.": "Il link di tracciamento pronto da copiare per questa campagna. Sostituisci il dominio con qualsiasi dominio verificato del workspace per usare più domini su una campagna; il network pubblicitario compila i placeholder al momento del click.",
  "Secret that authenticates incoming postbacks for this campaign. Paste it as &token=… in the postback URLs you give the network. Keep it private; anyone with it can register conversions.": "Il segreto che autentica i postback in arrivo per questa campagna. Incollalo come &token=… negli URL di postback che fornisci al network. Mantienilo privato: chiunque lo possieda può registrare conversioni.",
  "Translate the raw status words a network sends into our buckets. Priority: inline URL param > this campaign map > the affiliate-network preset > custom types > built-in defaults.": "Converte gli stati grezzi inviati da un network nelle nostre categorie. Priorità: parametro inline nell'URL > mappa di questa campagna > preset del network di affiliazione > tipi personalizzati > valori predefiniti.",
  "Outbound calls that notify another system (your traffic source, another tracker, Telegram) when a conversion arrives. For ad-platform CAPI (Facebook/Google/TikTok) use Conversion forwarders instead — hashed PII and retries.": "Chiamate in uscita che avvisano un altro sistema (la tua sorgente di traffico, un altro tracker, Telegram) quando arriva una conversione. Per la CAPI delle piattaforme pubblicitarie (Facebook/Google/TikTok) usa invece gli inoltri di conversione — dati personali con hash e retry.",
  "The query-string parameter name in your tracking link — keep it URL-safe: letters, digits and _ (no spaces). Spaces are auto-converted to _ so the link never shows %20.": "Il nome del parametro nella query string del tuo link di tracciamento — mantienilo compatibile con gli URL: lettere, cifre e _ (niente spazi). Gli spazi vengono convertiti automaticamente in _ così il link non mostra mai %20.",
  "UA-pattern bots and UAs that fake a search-crawler identity (failed DNS check) get the safe page.": "I bot rilevati tramite pattern di User-Agent e gli UA che fingono di essere un crawler di un motore di ricerca (verifica DNS fallita) ricevono la pagina sicura.",
  "DNS-verified search crawlers (Googlebot/Bingbot/…) get the safe page. Turn off to let them index the real offer.": "I crawler dei motori di ricerca verificati tramite DNS (Googlebot/Bingbot/…) ricevono la pagina sicura. Disattiva per permettere loro di indicizzare l'offerta reale.",
  "Visitors from datacenter or Tor-exit IPs get the safe page.": "I visitatori con IP di datacenter o di uscita Tor ricevono la pagina sicura.",
  "Visitors behind a proxy/VPN get the safe page.": "I visitatori dietro un proxy/VPN ricevono la pagina sicura.",
  "Works only when an active Google Ads forwarder exists (simple mode or with a conversion tag). The AW-…/label can be passed per click via the tm parameter, so one campaign credits conversions to different accounts.": "Funziona solo se esiste un forwarder Google Ads attivo (modalità semplice o con tag di conversione). L'AW-…/label può essere passato per ogni click tramite il parametro tm, così una singola campagna può attribuire le conversioni ad account diversi.",
  "Fire Google Ads gtag on redirect (click-time conversion)": "Invia gtag di Google Ads al redirect (conversione al momento del click)",
  "Fires a Google Ads conversion at the click moment (on /r/, before the offer) from the AW-…/label in the {tm} parameter — no forwarder needed. This optimizes Google on CLICKS, not on registrations/deposits.": "Invia una conversione Google Ads al momento del click (su /r/, prima dell'offerta) usando l'AW-…/label nel parametro {tm} — non serve alcun forwarder. Questo fa sì che Google ottimizzi sui CLICK, non sulle registrazioni/depositi.",
  "Click-time signal: the conversion fires for every clean click, so Google optimizes on clicks. To optimize on real registrations/deposits keep this OFF and use the \"Google Ads\" button under Forwarding — S2S postbacks (fires on the broker postback by {gclid}). Leaving both on double-counts.": "Segnale al momento del click: la conversione si attiva per ogni click pulito, quindi Google ottimizza sui click. Per ottimizzare sulle registrazioni/depositi reali lascia questa opzione DISATTIVATA e usa il pulsante \"Google Ads\" in Forwarding — postback S2S (si attiva al postback del broker tramite {gclid}). Se le lasci entrambe attive, le conversioni vengono conteggiate due volte.",
  "Bot model": "Modello di bot",
  "Member access": "Accesso membri",
  "Scope what each team member can see and edit — per entity, plus which report metrics they may read. Owners and admins are never restricted.": "Definisci cosa può vedere e modificare ciascun membro del team — per entità, oltre a quali metriche dei report può leggere. I proprietari e gli amministratori non sono mai limitati.",
  "Member": "Membro",
  "Choose a member…": "Scegli un membro…",
  "Failed to load members": "Impossibile caricare i membri",
  "Retry": "Riprova",
  "No team members yet": "Ancora nessun membro nel team",
  "Invite teammates from the Workspace page, then configure their access here.": "Invita i colleghi dalla pagina Workspace, poi configura qui il loro accesso.",
  "Pick a member to configure": "Scegli un membro da configurare",
  "Their entity access and allowed report metrics will show up here.": "Qui appariranno il suo accesso alle entità e le metriche dei report consentite.",
  "Failed to load member access": "Impossibile caricare l'accesso del membro",
  "Owners and admins have full, unrestricted access": "I proprietari e gli amministratori hanno accesso completo e senza restrizioni",
  "You can still save these rules, but they stay inert unless the role changes to manager or viewer.": "Puoi comunque salvare queste regole, ma restano inattive finché il ruolo non cambia in manager o viewer.",
  "Entity access": "Accesso alle entità",
  "Full is the default: no restriction. Read-only blocks edits. To selected limits the member to the listed IDs. Created and selected adds anything the member created themselves.": "Completo è il valore predefinito: nessuna restrizione. Sola lettura blocca le modifiche. Ai selezionati limita il membro agli ID elencati. Creati e selezionati aggiunge tutto ciò che il membro ha creato autonomamente.",
  "Entity": "Entità",
  "Access mode": "Modalità di accesso",
  "Allowed IDs": "ID consentiti",
  "Full": "Completo",
  "Read-only": "Sola lettura",
  "To selected": "Ai selezionati",
  "Created and selected": "Creati e selezionati",
  "IDs, comma or space separated": "ID separati da virgola o spazio",
  "IDs of the specific items this member may access": "ID degli elementi specifici a cui questo membro può accedere",
  "No IDs yet — the member will only see items they created themselves.": "Ancora nessun ID: il membro vedrà solo gli elementi che ha creato autonomamente.",
  "No IDs yet — the member will not see any items of this type.": "Ancora nessun ID: il membro non vedrà alcun elemento di questo tipo.",
  "All items": "Tutti gli elementi",
  "Allowed report metrics": "Metriche dei report consentite",
  "Toggle the metrics this member may see in reports and dashboards. Leaving every metric off means no restriction.": "Attiva o disattiva le metriche che questo membro può vedere nei report e nelle dashboard. Se non ne selezioni nessuna, non ci sono restrizioni.",
  "All metrics (no restriction)": "Tutte le metriche (nessuna restrizione)",
  "metrics allowed": "metriche consentite",
  "Clear (allow all)": "Cancella (consenti tutte)",
  "Save access": "Salva accesso",
  "Member access saved": "Accesso del membro salvato",
  "Failed to save member access": "Impossibile salvare l'accesso del membro",
  "Click traces": "Tracce dei clic",
  "Diagnostics": "Diagnostica",
  "Sampled real clicks with the full routing decision behind each one — which streams were evaluated and why the winner matched.": "Clic reali campionati con la decisione completa di instradamento dietro ognuno: quali stream sono stati valutati e perché il vincitore ha corrisposto.",
  "Pick a campaign above to inspect where its real clicks were routed and why.": "Scegli una campagna sopra per vedere dove sono stati instradati i suoi clic reali e perché.",
  "Live-click tracing": "Tracciamento dei clic in tempo reale",
  "Enable live-click tracing": "Attiva il tracciamento dei clic in tempo reale",
  "Off by default. When enabled, a sampled share of real clicks records its full routing trace. Privacy-safe: no IP addresses or user agents are stored, and traces expire automatically.": "Disattivato per impostazione predefinita. Se attivato, una quota campionata di clic reali registra la traccia completa di instradamento. Rispettoso della privacy: non vengono memorizzati indirizzi IP o user agent, e le tracce scadono automaticamente.",
  "Sample rate (%)": "Tasso di campionamento (%)",
  "Share of clicks to trace, from 0 to 100%. Example: 10% traces roughly one click in ten.": "Percentuale di clic da tracciare, da 0 a 100%. Esempio: 10% traccia circa un clic su dieci.",
  "Sample rate must be between 0 and 100": "Il tasso di campionamento deve essere compreso tra 0 e 100",
  "Trace settings saved": "Impostazioni di tracciamento salvate",
  "Error loading click traces": "Errore nel caricamento delle tracce dei clic",
  "Could not load traces": "Impossibile caricare le tracce",
  "Something went wrong while loading click traces for this campaign.": "Si è verificato un errore durante il caricamento delle tracce dei clic per questa campagna.",
  "No traces yet": "Ancora nessuna traccia",
  "Enable tracing above; traces of sampled real clicks will appear here.": "Attiva il tracciamento sopra; le tracce dei clic reali campionati appariranno qui.",
  "Tracing is on — traces of sampled real clicks will appear here as traffic arrives. If nothing shows up, check the sample rate.": "Il tracciamento è attivo: le tracce dei clic reali campionati appariranno qui man mano che arriva traffico. Se non vedi nulla, controlla il tasso di campionamento.",
  "Flags": "Indicatori",
  "Show routing trace": "Mostra la traccia di instradamento",
  "Hide routing trace": "Nascondi la traccia di instradamento",
  "Per-stream verdicts": "Verdetti per stream",
  "No per-stream verdicts were recorded for this click.": "Non sono stati registrati verdetti per stream per questo clic.",
  "Not matched": "Nessuna corrispondenza",
  "Filters evaluated": "Filtri valutati",
  "Relation": "Relazione",
  "Page": "Pagina",
  "entries": "voci",
  "just now": "proprio ora",
  "{n}m ago": "{n} min fa",
  "{n}h ago": "{n} h fa",
  "ML bot model": "Modello ML dei bot",
  "Weak-supervision bot classifier: train it on recent clicks, inspect metrics and score ad-hoc payloads. Shadow-only — it never affects live routing.": "Classificatore di bot a supervisione debole: addestralo sui clic recenti, controlla le metriche e valuta payload ad hoc. Solo in modalità shadow: non influisce mai sul routing live.",
  "Admin access required": "Richiesto accesso amministratore",
  "The ML bot-model panel is only available to workspace admins.": "Il pannello del modello ML dei bot è disponibile solo per gli amministratori del workspace.",
  "Error loading bot-model status": "Errore nel caricamento dello stato del modello di bot",
  "Model status": "Stato del modello",
  "Trained": "Addestrato",
  "Not trained": "Non addestrato",
  "Inference": "Inferenza",
  "Degenerate": "Degenerato",
  "Trained on a single class or too few samples — metrics are not meaningful.": "Addestrato su una singola classe o con troppo pochi campioni: le metriche non sono significative.",
  "Inference is off by default and shadow-only — even when enabled, scores are only recorded on clicks for analysis and never affect routing.": "L'inferenza è disattivata per impostazione predefinita ed è solo in modalità shadow: anche se attivata, i punteggi vengono registrati sui clic solo a scopo di analisi e non influiscono mai sul routing.",
  "Accuracy": "Accuratezza",
  "Positive rate": "Tasso di positivi",
  "Log loss": "Log loss",
  "AUC": "AUC",
  "Training samples": "Campioni di addestramento",
  "Trained at": "Addestrato il",
  "No bot model trained yet. Train one on recent clicks below.": "Nessun modello di bot ancora addestrato. Addestrane uno sui clic recenti qui sotto.",
  "Train model": "Addestra modello",
  "Training…": "Addestramento…",
  "Training pulls up to 5,000 recent clicks, weak-labels them with the existing bot heuristics (user agent, uniqueness, behaviour score) and fits a small logistic-regression model. Retraining replaces the stored model.": "L'addestramento preleva fino a 5.000 clic recenti, li etichetta in modo debole con le euristiche di bot esistenti (user agent, unicità, punteggio di comportamento) e adatta un piccolo modello di regressione logistica. Il riaddestramento sostituisce il modello salvato.",
  "Model trained on {n} clicks — accuracy {acc}": "Modello addestrato su {n} clic — accuratezza {acc}",
  "Model trained on {n} clicks": "Modello addestrato su {n} clic",
  "No click data to train on yet.": "Ancora nessun dato sui clic su cui addestrare.",
  "Training finished": "Addestramento completato",
  "Training failed": "Addestramento non riuscito",
  "Score a sample": "Valuta un campione",
  "Developer tool: paste a click-shaped JSON payload and run it through the trained model. Nothing is stored and live traffic is unaffected.": "Strumento per sviluppatori: incolla un payload JSON in forma di clic e passalo attraverso il modello addestrato. Non viene salvato nulla e il traffico live non viene influenzato.",
  "Click payload (JSON)": "Payload del clic (JSON)",
  "Score": "Valuta",
  "Scoring…": "Valutazione…",
  "Reset example": "Ripristina esempio",
  "Invalid JSON — check the payload and try again.": "JSON non valido: controlla il payload e riprova.",
  "Payload must be a JSON object.": "Il payload deve essere un oggetto JSON.",
  "No trained model — train one first.": "Nessun modello addestrato: addestrane prima uno.",
  "Scoring failed": "Valutazione non riuscita",
  "Likely bot": "Probabile bot",
  "Likely human": "Probabile umano",
  "Threshold 0.5 — scores above are flagged as bots.": "Soglia 0.5: i punteggi superiori vengono segnalati come bot.",
  "Heuristic weak label": "Etichetta debole euristica",
  "Human": "Umano",
  "Feature": "Caratteristica",
  "{n} min ago": "{n} min fa",
  "{n} h ago": "{n} h fa",
  "{n} d ago": "{n} g fa",
  "Archive & restore": "Archivia e ripristina",
  "Access control": "Controllo degli accessi",
  "Offer rotation on daily cap": "Rotazione offerte al raggiungimento del limite giornaliero",
  "No threshold needed. This rule fires when any offer used by the campaign reaches its daily cap and notifies you that traffic is rotating to the fallback / remaining offers. Set the cap and fallback offer on each offer.": "Non serve una soglia. Questa regola scatta quando un'offerta usata dalla campagna raggiunge il suo cap giornaliero e ti avvisa che il traffico sta ruotando verso l'offerta di fallback / le offerte rimanenti. Imposta il cap e l'offerta di fallback su ogni offerta.",
  "Connection types": "Tipi di connessione",
  "Filter by network connection type. 'hosting' (datacenter/cloud) works out of the box; other values like cellular or wifi require the edge proxy to send an X-Connection-Type header.": "Filtra per tipo di connessione di rete. 'hosting' (datacenter/cloud) funziona immediatamente; altri valori come cellular o wifi richiedono che il proxy edge invii l'header X-Connection-Type.",
  "Status mapping": "Mapping degli stati",
  "Add status": "Aggiungi stato",
  "No status mappings added": "Nessun mapping di stato aggiunto",
  "Network status (e.g. ftd)": "Stato del network (es. ftd)",
  "Map the raw status this network sends to a canonical bucket. Applied to inbound postbacks when the campaign status map does not match.": "Mappa lo stato grezzo inviato da questo network a un bucket canonico. Viene applicato ai postback in entrata quando la mappa degli stati della campagna non corrisponde.",
  "Lead": "Lead",
  "Sale": "Vendita",
  "Reject": "Rifiuta",
  "Upsell": "Upsell",
  "Ignore": "Ignora",
  "Split testing": "Split testing",
  "Parameter filters": "Filtri parametri",
  "Params": "Parametri",
  "Split testing enabled": "Split testing attivato",
  "Split testing disabled": "Split testing disattivato",
  "Failed to update campaign": "Impossibile aggiornare la campagna",
  "Flow rotation. On: Normal streams rotate by weight, position is ignored. Off: streams are checked top-down by position and the first match takes all the traffic. Catch streams always intercept first and never rotate by weight.": "Rotazione dei flussi. Attivo: gli stream Normal ruotano per peso, la posizione viene ignorata. Disattivo: gli stream vengono controllati dall'alto verso il basso per posizione e la prima corrispondenza prende tutto il traffico. Gli stream Catch intercettano sempre per primi e non ruotano mai per peso.",
  "Route by URL sub-parameters. One rule per line: name=value1, value2 allows listed values; name!=value1, value2 blocks them (a missing parameter passes a block rule). A rule without values adds no constraint.": "Instrada in base ai sub-parametri dell'URL. Una regola per riga: name=value1, value2 consente i valori elencati; name!=value1, value2 li blocca (un parametro mancante supera una regola di blocco). Una regola senza valori non aggiunge vincoli.",
  "Regions": "Regioni",
  "GeoIP region / state / oblast names (e.g. California, Bavaria). Masks, /regex/ and @empty are supported.": "Nomi di regione / stato / oblast GeoIP (es. California, Bavaria). Sono supportate maschere, /regex/ e @empty.",
  "IP addresses": "Indirizzi IP",
  "Exact IPs, CIDR blocks (10.0.0.0/8) or masks (192.168.*). Handy for allow-listing your own test IPs or blocking a datacenter range.": "IP esatti, blocchi CIDR (10.0.0.0/8) o maschere (192.168.*). Utile per inserire in whitelist i tuoi IP di test o bloccare un range di datacenter.",
  "User agents": "User agent",
  "Substrings, masks or /regex/ matched against the raw User-Agent — e.g. *Chrome/12* targets Chrome 120+, HeadlessChrome catches headless browsers.": "Sottostringhe, maschere o /regex/ confrontate con lo User-Agent grezzo — es. *Chrome/12* intercetta Chrome 120+, HeadlessChrome cattura i browser headless.",
  "Clicks per hour": "Click all'ora",
  "Rolling-window limit: the stream stops taking NEW clicks after this many in the last hour, traffic falls through to the next stream. Empty = no limit.": "Limite a finestra scorrevole: lo stream smette di accettare NUOVI click dopo questo numero nell'ultima ora, il traffico passa allo stream successivo. Vuoto = nessun limite.",
  "Clicks per 24h": "Click per 24h",
  "Rolling-window limit over the last 24 hours. Empty = no limit.": "Limite a finestra mobile sulle ultime 24 ore. Vuoto = nessun limite.",
  "Filter relation": "Relazione tra i filtri",
  "AND: the click must pass every configured filter. OR: any single passing filter admits the click.": "AND: il click deve superare tutti i filtri configurati. OR: basta che superi un solo filtro per essere ammesso.",
  "AND (all)": "AND (tutti)",
  "OR (any)": "OR (uno qualsiasi)",
  "Is": "È",
  "Is not": "Non è",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone. 'Is not' inverts the schedule: the stream accepts clicks EXCEPT at the listed times.": "Giorni della settimana e orari in cui lo stream è attivo. L'orario fa riferimento al fuso orario del proprietario della campagna. 'Non è' inverte la pianificazione: lo stream accetta i click TRANNE negli orari indicati.",
  "A free-text network label for notes and filters only — it has no effect. For a real link use the Affiliate network field or the Affiliate routing block below.": "Un'etichetta di testo libero per il network, usata solo per note e filtri — non ha alcun effetto. Per un collegamento reale usa il campo Network di affiliazione o il blocco Affiliate routing qui sotto.",
  "A reusable partner network from the Affiliate networks section: postback template, offer params and per-network reports. Optional.": "Un network di affiliazione riutilizzabile dalla sezione Affiliate networks: template di postback, parametri dell'offerta e report per network. Opzionale.",
  "Where the click goes for a plain redirect offer. Macros work: {click_id}, {country_code}, {gclid} and more. For form offers (lead to CRM) the URL can be anything.": "Dove viene reindirizzato il click per un'offerta a redirect semplice. Le macro funzionano: {click_id}, {country_code}, {gclid} e altre. Per le offerte con form (lead verso CRM) l'URL può essere qualsiasi.",
  "Max conversions per offer per day. When the cap is hit, traffic goes to the fallback offer. Empty = no limit.": "Numero massimo di conversioni per offerta al giorno. Al raggiungimento del limite, il traffico va all'offerta di fallback. Vuoto = nessun limite.",
  "Time zone in which the daily cap is counted and the counter resets.": "Fuso orario in cui viene conteggiato il limite giornaliero e in cui si azzera il contatore.",
  "Fallback offer: traffic goes here once the main offer hits its daily cap.": "Offerta di fallback: il traffico viene instradato qui quando l'offerta principale raggiunge il suo limite giornaliero.",
  "The partner/CRM the lead is sent to. Set up once in the Integrations section (TrackBox or Custom API).": "Il partner/CRM a cui viene inviato il lead. Si configura una sola volta nella sezione Integrations (TrackBox o Custom API).",
  "The offer's Box/Goal ID at the partner — which product/box receives the lead. The partner provides the value (e.g. 420).": "Il Box/Goal ID dell'offerta presso il partner — indica quale prodotto/box riceve il lead. Il valore è fornito dal partner (es. 420).",
  "Share of leads to this partner when there are several (split/rotation). E.g. 70 and 30 = 70% and 30%.": "Quota di lead destinata a questo partner quando ce ne sono più di uno (split/rotazione). Es. 70 e 30 = 70% e 30%.",
  "Off = the partner is temporarily skipped (e.g. until launch is agreed); its settings are kept.": "Disattivato = il partner viene temporaneamente escluso (es. in attesa di concordare il lancio); le sue impostazioni vengono mantenute.",
  "A per-offer form endpoint for THIS offer only. Usually NOT needed — use the shared /api/lead (see docs). Only for binding a form to one specific offer.": "Un endpoint form dedicato SOLO a questa offerta. Di solito NON è necessario — usa l'endpoint condiviso /api/lead (vedi docs). Serve solo per collegare un form a un'offerta specifica.",
  "Telegram notification on EVERY form submit (accepted/rejected/test). Separate from the campaign Telegram postback (that fires on a confirmed conversion). Bot token from @BotFather; group Chat ID starts with -100…": "Notifica su Telegram per OGNI invio del modulo (accettato/rifiutato/test). Separata dal postback Telegram della campagna (quello che scatta su una conversione confermata). Bot token da @BotFather; il Chat ID del gruppo inizia con -100…",
  "Default URL when no stream matched. Routing is usually driven by Streams — this field is a safety net.": "URL predefinito quando nessuno stream corrisponde. Il routing è di solito gestito dagli Stream — questo campo è una rete di sicurezza.",
  "The ad platform (Google Ads, Facebook…). Defines the set of macros/subs appended to the tracking link to pass click data.": "La piattaforma pubblicitaria (Google Ads, Facebook…). Definisce l'insieme di macro/sub aggiunti al link di tracciamento per passare i dati del click.",
  "How cost is counted: CPC — per click, CPM — per 1000 impressions, CPA — per conversion. Affects Cost / ROI / CPC / CPA in reports.": "Come viene calcolato il costo: CPC — per click, CPM — per 1000 impressioni, CPA — per conversione. Influisce su Costo / ROI / CPC / CPA nei report.",
  "The GET parameter name the tracker uses to append click_id to the offer URL (e.g. click_id → ?click_id=…). Needed so the partner returns this click_id in the postback. Form snippets read both click_id and clickid.": "Il nome del parametro GET usato dal tracker per aggiungere il click_id all'URL dell'offerta (es. click_id → ?click_id=…). Necessario affinché il partner restituisca questo click_id nel postback. Gli snippet del modulo leggono sia click_id che clickid.",
  "Do not set the xpnsr_vid cookie (for networks that forbid cookies). Uniqueness is then by IP+User Agent, and click_id is passed via URL — the Click ID forward parameter field above.": "Non impostare il cookie xpnsr_vid (per i network che vietano i cookie). L'unicità viene allora calcolata per IP+User Agent, e il click_id viene passato via URL — il campo Click ID forward parameter qui sopra.",
  "Hash the IP before storing (for GDPR). GEO is resolved BEFORE hashing, so country/city targeting is unaffected.": "Esegui l'hash dell'IP prima di salvarlo (per il GDPR). Il GEO viene risolto PRIMA dell'hashing, quindi il targeting per paese/città non ne risente.",
  "How to redirect: 302 — a plain fast redirect; Meta refresh / JS — when the network does not follow 302 or gtag is needed; Cloaked (iframe) — hide the offer URL in the address bar.": "Come reindirizzare: 302 — un redirect semplice e veloce; Meta refresh / JS — quando il network non segue il 302 o serve gtag; Cloaked (iframe) — nasconde l'URL dell'offerta nella barra degli indirizzi.",
  "Normal — a regular stream with filters; Catch — catches traffic that matched no Normal stream; Default — the last-resort stream when nothing matched.": "Normal — uno stream regolare con filtri; Catch — cattura il traffico che non ha trovato corrispondenza in nessuno stream Normal; Default — lo stream di ultima istanza quando nulla corrisponde.",
  "Check priority. The lower the number, the earlier the stream is checked. Traffic goes to the first matching one.": "Priorità di controllo. Più basso è il numero, prima viene controllato lo stream. Il traffico va al primo che corrisponde.",
  "When several streams share a type — the split of traffic between them. E.g. 70 and 30 = 70% and 30%.": "Quando più stream condividono lo stesso tipo — la ripartizione del traffico tra loro (split). Es. 70 e 30 = 70% e 30%.",
  "Max clicks for this stream. Once reached, the stream stops taking traffic. Empty = no limit.": "Numero massimo di click per questo stream. Una volta raggiunto, lo stream smette di ricevere traffico. Vuoto = nessun limite.",
  "Redirect — send to the stream's landing/offer; Action — a special response (e.g. 404 / empty response for anti-fraud); Split test — split between variants.": "Redirect — invia alla landing page/offerta dello stream; Action — una risposta speciale (es. 404 / risposta vuota per anti-fraud); Split test — ripartizione tra varianti.",
  "Filter by visit uniqueness: unique only / repeat only / do not filter.": "Filtra in base all'unicità della visita: solo uniche / solo ripetute / non filtrare.",
  "How to handle bots (detected by User-Agent): do not filter / bots only / exclude bots. Handy for an anti-fraud stream.": "Come gestire i bot (rilevati tramite User-Agent): non filtrare / solo bot / escludi bot. Utile per uno stream anti-fraud.",
  "Proxy/VPN filter (datacenter/Tor): do not filter / proxy only / exclude proxy.": "Filtro proxy/VPN (datacenter/Tor): non filtrare / solo proxy / escludi proxy.",
  "Allow only IPv4 or only IPv6, or do not filter.": "Consenti solo IPv4 o solo IPv6, oppure non filtrare.",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone.": "Giorni della settimana e orari in cui lo stream è attivo. L'orario è nel fuso orario del proprietario della campagna.",
  "A ready platform preset (Google Ads, Facebook…) — fills in the name, the standard macros/subs and the S2S postback for this source.": "Un preset già pronto per la piattaforma (Google Ads, Facebook…) — compila il nome, le macro/sub standard e il postback S2S per questa sorgente.",
  "Search templates…": "Cerca modelli…",
  "All categories": "Tutte le categorie",
  "Templates in catalog": "Modelli nel catalogo",
  "Optional. An outbound postback TO the ad network on conversion — so the platform can optimize campaigns on its side (e.g. legacy Facebook CAPI).": "Facoltativo. Un postback in uscita VERSO il network pubblicitario alla conversione — così la piattaforma può ottimizzare le campagne dal proprio lato (es. Facebook CAPI legacy).",
  "Parameters the platform passes into the click (sub1…subN, gclid, tm, etc.). They become macros, appear in reports and are added to the tracking link.": "Parametri che la piattaforma passa nel click (sub1…subN, gclid, tm, ecc.). Diventano macro, compaiono nei report e vengono aggiunti al link di tracciamento.",
  "TrackBox / Tigloo — a typed adapter for their API. Custom API — for any other CRM: you configure the request yourself (URL, headers, body, where to read the redirect).": "TrackBox / Tigloo — un adapter tipizzato per la loro API. Custom API — per qualsiasi altro CRM: configuri tu la richiesta (URL, header, body, da dove leggere il redirect).",
  "The partner's secret Push/Registration key. Get it in the partner dashboard (API / API Testing section) or from your affiliate manager.": "La chiave segreta Push/Registration del partner. La trovi nella dashboard del partner (sezione API / API Testing) o chiedendola al tuo affiliate manager.",
  "Your Affiliate ID at the partner. Provided by the partner.": "Il tuo Affiliate ID presso il partner. Fornito dal partner.",
  "Campaign ID at the partner. Usually 1 unless told otherwise.": "Campaign ID presso il partner. Di solito è 1, salvo indicazioni diverse.",
  "Raw network statuses to treat as a LEAD (registration). Comma-separated. E.g. new, reg, registration.": "Stati grezzi del network da considerare come LEAD (registrazione). Separati da virgola. Es. new, reg, registration.",
  "Raw statuses to treat as a SALE/deposit. E.g. ftd, deposit, approved.": "Stati grezzi da considerare come SALE/deposito. Es. ftd, deposit, approved.",
  "Rejection/bad statuses. E.g. bl, fake, rejected.": "Stati di rifiuto/scarsa qualità. Es. bl, fake, rejected.",
  "These statuses are silently dropped — not recorded as conversions. E.g. spam, junk, test.": "Questi stati vengono scartati silenziosamente — non vengono registrati come conversioni. Es. spam, junk, test.",
  "Dashboard": "Dashboard",
  "Campaigns": "Campagne",
  "Landing pages": "Landing page",
  "Offers": "Offerte",
  "Sources": "Sorgenti",
  "Report": "Report",
  "Group clicks and conversions by any dimension with full metrics.": "Raggruppa click e conversioni per qualsiasi dimensione con metriche complete.",
  "Grouped by": "Raggruppato per",
  "No data for this period.": "Nessun dato per questo periodo.",
  "Empty ref.": "Ref. vuoto",
  "Group": "Gruppo",
  "— no level —": "— nessun livello —",
  "Click a row to drill in": "Fai clic su una riga per vedere il dettaglio",
  "Expand": "Espandi",
  "Collapse": "Comprimi",
  "Open in clicks log": "Apri nel registro click",
  "Failed to load": "Caricamento non riuscito",
  "Card view": "Vista a schede",
  "Table view": "Vista a tabella",
  "Save view": "Salva vista",
  "Save current view": "Salva vista attuale",
  "Saved views": "Viste salvate",
  "Delete view": "Elimina vista",
  "View saved": "Vista salvata",
  "View name": "Nome vista",
  "Remember the current filters, sort and layout under a name for one-click recall.": "Salva filtri, ordinamento e layout attuali con un nome per richiamarli con un clic.",
  "e.g. Tier-1 by revenue": "es. Tier-1 per ricavi",
  "Upload pre-landing (ZIP)": "Carica prelander (ZIP)",
  "Upload a ZIP with your warm-up page. index.html is auto-detected.": "Carica uno ZIP con la tua pagina di warm-up. index.html viene rilevato automaticamente.",
  "ZIP file": "File ZIP",
  "Pre-landing uploaded": "Prelander caricato",
  "Upload failed": "Caricamento non riuscito",
  "Choose a ZIP file": "Scegli un file ZIP",
  "Uploaded": "Caricato",
  "Uploading…": "Caricamento…",
  "Columns": "Colonne",
  "Receiving conversions (incoming postback)": "Ricezione conversioni (postback in entrata)",
  "Paste these URLs into your affiliate network (e.g. TrackBox) so it notifies this campaign on conversions. Pass your click_id in the network parameter and it comes back here.": "Incolla questi URL nel tuo network di affiliazione (es. TrackBox) in modo che notifichi questa campagna alle conversioni. Passa il tuo click_id nel parametro del network e tornerà qui.",
  "Map the network raw statuses to ours (comma-separated). Works for any network and applies to every inbound postback of this campaign. Inline URL params take priority.": "Mappa gli stati grezzi del network ai nostri (separati da virgola). Funziona con qualsiasi network e si applica a ogni postback in entrata di questa campagna. I parametri inline nell'URL hanno la priorità.",
  "Forwarding — S2S postbacks": "Inoltro — postback S2S",
  "Landing click": "Click sulla landing page",
  "Time on landing": "Tempo sulla landing page",
  "sec": "sec",
  "OS": "SO",
  "ISP / provider": "ISP / provider",
  "Proxy": "Proxy",
  "Empty referrer": "Referrer vuoto",
  "Bots": "Bot",
  "Only bots": "Solo bot",
  "Exclude bots": "Escludi bot",
  "Proxy / VPN": "Proxy / VPN",
  "Only proxy": "Solo proxy",
  "Exclude proxy": "Escludi proxy",
  "IP version": "Versione IP",
  "Show 404": "Mostra 404",
  "Do nothing": "Non fare nulla",
  "Schedule": "Pianificazione",
  "Add interval": "Aggiungi intervallo",
  "Every day, all day": "Tutti i giorni, tutto il giorno",
  "Every day": "Tutti i giorni",
  "Error loading affiliate networks": "Errore nel caricamento dei network di affiliazione",
  "Quick start from preset": "Avvio rapido da preset",
  "Affiliate network name": "Nome del network di affiliazione",
  "Vertical": "Verticale",
  "Postback URL template": "Template URL di postback",
  "Outbound postback the tracker calls to notify this network.": "Postback in uscita che il tracker chiama per notificare questo network.",
  "Offer parameters": "Parametri dell'offerta",
  "Key": "Chiave",
  "Notes": "Note",
  "Internal notes": "Note interne",
  "Affiliate networks": "Network di affiliazione",
  "Reusable partner networks: postback template, offer params and inbound URL.": "Network partner riutilizzabili: template di postback, parametri dell'offerta e URL in entrata.",
  "Create network": "Crea network",
  "Create affiliate network": "Crea network di affiliazione",
  "Pick a preset or configure a partner network from scratch.": "Scegli un preset o configura un network partner da zero.",
  "Search networks": "Cerca network",
  "No affiliate networks yet": "Nessun network di affiliazione ancora",
  "Create one from a preset like TrackBox or Adcombo.": "Creane uno da un preset come TrackBox o Adcombo.",
  "Postback copied": "Postback copiato",
  "Inbound postback URL (paste in the network)": "URL di postback in entrata (incollala nel network)",
  "Inbound URL copied": "URL in entrata copiato",
  "conv.": "conv.",
  "offer parameter(s)": "parametro/i dell'offerta",
  "Edit affiliate network": "Modifica network di affiliazione",
  "Update partner network settings": "Aggiorna le impostazioni della rete partner",
  "Delete affiliate network": "Elimina network di affiliazione",
  "This permanently deletes the network. Offers linked to it keep their other settings.": "Questa azione elimina definitivamente il network. Le offerte collegate mantengono le loro altre impostazioni.",
  "Affiliate network created": "Network di affiliazione creato",
  "Error creating affiliate network": "Errore durante la creazione del network di affiliazione",
  "Affiliate network updated": "Network di affiliazione aggiornato",
  "Error updating affiliate network": "Errore durante l'aggiornamento del network di affiliazione",
  "Affiliate network deleted": "Network di affiliazione eliminato",
  "Cannot delete: network is linked to offers": "Impossibile eliminare: il network è collegato a delle offerte",
  "Error deleting affiliate network": "Errore durante l'eliminazione del network di affiliazione",
  "Copy failed": "Copia non riuscita",
  "Network (text label)": "Network (etichetta testuale)",
  "Traffic": "Traffico",
  "A/B Tests": "Test A/B",
  "Anti-fraud": "Anti-frode",
  "Analytics": "Analisi",
  "Automation": "Automazione",
  "Integrations": "Integrazioni",
  "Settings": "Impostazioni",
  "Account": "Account",
  "My account": "Il mio account",
  "Profile": "Profilo",
  "Sign out": "Esci",
  "User": "Utente",
  "Welcome, {name}.": "Benvenuto, {name}.",
  "Welcome,": "Benvenuto,",
  "Real-time overview of your campaigns and stats": "Panoramica in tempo reale delle tue campagne e statistiche",
  "Create campaign": "Crea campagna",
  "Clicks": "Clic",
  "Unique visitors": "Visitatori unici",
  "Conversions": "Conversioni",
  "Total active campaigns": "Campagne attive totali",
  "Total clicks": "Clic totali",
  "Unique clicks": "Clic unici",
  "{rate}% conversion": "{rate}% di conversione",
  "Recent campaigns": "Campagne recenti",
  "Your latest campaigns": "Le tue ultime campagne",
  "You have no campaigns yet": "Non hai ancora campagne",
  "Create your first campaign": "Crea la tua prima campagna",
  "Quick actions": "Azioni rapide",
  "Commonly used features": "Funzioni più usate",
  "Add a new ad campaign": "Aggiungi una nuova campagna",
  "View detailed statistics": "Visualizza statistiche dettagliate",
  "Manage campaigns": "Gestisci campagne",
  "Edit existing campaigns": "Modifica campagne esistenti",
  "Show all campaigns": "Mostra tutte le campagne",
  "More details": "Più dettagli",
  "Active": "Attiva",
  "Paused": "In pausa",
  "No description": "Nessuna descrizione",
  "{n} clicks": "{n} clic",
  "{n} unique": "{n} unici",
  "{n} conversions": "{n} conversioni",
  "Loading workspace": "Caricamento dello spazio di lavoro",
  "Loading your data…": "Caricamento dei tuoi dati…",
  "Sign in": "Accedi",
  "Sign up": "Registrati",
  "Email": "Email",
  "Work email": "Email di lavoro",
  "Password": "Password",
  "Full name": "Nome completo",
  "Jane Doe": "Mario Rossi",
  "Create account": "Crea account",
  "Create new account": "Crea nuovo account",
  "Already have an account?": "Hai già un account?",
  "Don't have an account?": "Non hai un account?",
  "Welcome back": "Bentornato",
  "Sign in to your xpnsr account": "Accedi al tuo account xpnsr",
  "Attribution,": "Attribuzione,",
  "honest": "onesta",
  "Create": "Crea",
  "account": "account",
  "S2S postback · bot shield": "Postback S2S · scudo anti-bot",
  "Remember this device": "Ricorda questo dispositivo",
  "Reset": "Reimposta",
  "Access tracker": "Accedi al tracker",
  "Hide password": "Nascondi password",
  "Show password": "Mostra password",
  "At least 6 characters": "Almeno 6 caratteri",
  "Signing in…": "Accesso in corso…",
  "Creating account…": "Creazione account…",
  "Invalid email or password": "Email o password non validi",
  "Registration failed. Please try again.": "Registrazione non riuscita. Riprova.",
  "New registrations are disabled. Contact your workspace admin for an invitation.": "Le nuove registrazioni sono disabilitate. Contatta l'amministratore del tuo spazio di lavoro per un invito.",
  "Home": "Home",
  "Auth": "Autenticazione",
  "Book Demo": "Prenota demo",
  "Search campaigns, streams…": "Cerca campagne, stream…",
  "One visual language for the xpnsr.tech family.": "Un unico linguaggio visivo per la famiglia xpnsr.tech.",
  "Control": "Controllo",
  "Operations": "Operazioni",
  "Precise tracking": "Tracking preciso",
  "KPIs, sources and leads in one panel.": "KPI, sorgenti e lead in un unico pannello.",
  "Readable reports": "Report leggibili",
  "Data visualization for fast decisions.": "Visualizzazione dei dati per decisioni rapide.",
  "Scale your team": "Fai crescere il tuo team",
  "Organize teams, campaigns and sources without friction.": "Organizza team, campagne e sorgenti senza attriti.",
  "Enter your credentials to continue.": "Inserisci le tue credenziali per continuare.",
  "Create a new xpnsr.tech account.": "Crea un nuovo account xpnsr.tech.",
  "Campaign management": "Gestione campagne",
  "Create, edit and track your ad campaigns in real time": "Crea, modifica e traccia le tue campagne pubblicitarie in tempo reale",
  "Search campaigns…": "Cerca campagne…",
  "Create new campaign": "Crea nuova campagna",
  "Edit campaign": "Modifica campagna",
  "Fill in the details of your new ad campaign": "Inserisci i dettagli della tua nuova campagna pubblicitaria",
  "Update campaign details": "Aggiorna i dettagli della campagna",
  "Campaign name": "Nome campagna",
  "Description (optional)": "Descrizione (opzionale)",
  "Target URL": "URL di destinazione",
  "Traffic source": "Sorgente di traffico",
  "Cost model": "Modello di costo",
  "Select a traffic source (optional)": "Seleziona una sorgente di traffico (opzionale)",
  "CPC (per click)": "CPC (per clic)",
  "CPM (per impression)": "CPM (per impressione)",
  "CPA (per action)": "CPA (per azione)",
  "Cancel": "Annulla",
  "Save changes": "Salva modifiche",
  "Edit": "Modifica",
  "Copy link": "Copia link",
  "Delete": "Elimina",
  "Are you sure you want to delete this campaign?": "Sei sicuro di voler eliminare questa campagna?",
  "Campaign created successfully!": "Campagna creata con successo!",
  "Campaign updated successfully!": "Campagna aggiornata con successo!",
  "Campaign deleted successfully!": "Campagna eliminata con successo!",
  "No campaigns": "Nessuna campagna",
  "Campaigns not found": "Campagne non trovate",
  "Create your first campaign to start tracking traffic": "Crea la tua prima campagna per iniziare a tracciare il traffico",
  "Try adjusting search criteria": "Prova a modificare i criteri di ricerca",
  "Tracking ID": "ID di tracking",
  "Link copied to clipboard!": "Link copiato negli appunti!",
  "Failed to copy link": "Impossibile copiare il link",
  "Error loading campaigns": "Errore nel caricamento delle campagne",
  "Error creating campaign": "Errore nella creazione della campagna",
  "Error updating campaign": "Errore nell'aggiornamento della campagna",
  "Error deleting campaign": "Errore nell'eliminazione della campagna",
  "For example: Product A ad": "Ad esempio: Annuncio prodotto A",
  "Short campaign description": "Breve descrizione della campagna",
  "New landing page": "Nuova landing page",
  "Add landing page": "Aggiungi landing page",
  "Add a landing page for use in campaigns and A/B tests": "Aggiungi una landing page da usare nelle campagne e nei test A/B",
  "Edit landing page": "Modifica landing page",
  "Edit landing page settings": "Modifica le impostazioni della landing page",
  "Search landing pages…": "Cerca landing page…",
  "Create landing pages for use in campaigns": "Crea landing page da usare nelle campagne",
  "No landing pages": "Nessuna landing page",
  "Nothing found": "Nessun risultato trovato",
  "Landing page created": "Landing page creata",
  "Landing page updated": "Landing page aggiornata",
  "Landing page deleted": "Landing page eliminata",
  "Delete this landing page?": "Eliminare questa landing page?",
  "Error loading landing pages": "Errore nel caricamento delle landing page",
  "Error creating landing page": "Errore nella creazione della landing page",
  "Error updating landing page": "Errore nell'aggiornamento della landing page",
  "Error deleting landing page": "Errore nell'eliminazione della landing page",
  "Please fill in name and URL": "Inserisci nome e URL",
  "URL copied": "URL copiato",
  "My landing": "La mia landing",
  "Landing page description": "Descrizione della landing page",
  "Lead generation": "Generazione di lead",
  "Subscription": "Abbonamento",
  "Download": "Download",
  "Other": "Altro",
  "Category": "Categoria",
  "Select category": "Seleziona categoria",
  "Description": "Descrizione",
  "Tags": "Tag",
  "Add tag": "Aggiungi tag",
  "Status": "Stato",
  "Inactive": "Inattivo",
  "Visits": "Visite",
  "CR": "CR",
  "Actions": "Azioni",
  "Name": "Nome",
  "URL": "URL",
  "Save": "Salva",
  "Unique": "Univoco",
  "Add offer": "Aggiungi offerta",
  "New offer": "Nuova offerta",
  "Edit offer": "Modifica offerta",
  "Add an offer to use in campaigns": "Aggiungi un'offerta da usare nelle campagne",
  "Change offer parameters": "Modifica i parametri dell'offerta",
  "Search offers…": "Cerca offerte…",
  "No offers": "Nessuna offerta",
  "Create offers to monetize your traffic": "Crea offerte per monetizzare il tuo traffico",
  "Offer created": "Offerta creata",
  "Offer updated": "Offerta aggiornata",
  "Offer deleted": "Offerta eliminata",
  "Delete this offer?": "Eliminare questa offerta?",
  "Error loading offers": "Errore nel caricamento delle offerte",
  "Error creating offer": "Errore nella creazione dell'offerta",
  "Error updating offer": "Errore nell'aggiornamento dell'offerta",
  "Error deleting offer": "Errore nell'eliminazione dell'offerta",
  "My offer": "La mia offerta",
  "Offer URL": "URL dell'offerta",
  "Offer description": "Descrizione dell'offerta",
  "Affiliate network": "Network di affiliazione",
  "Network": "Network",
  "Payout": "Payout",
  "Currency": "Valuta",
  "Geo": "Geo",
  "Countries (ISO codes, e.g. US, RU)": "Paesi (codici ISO, es. US, RU)",
  "Nutra": "Nutra",
  "Gambling": "Scommesse",
  "Dating": "Dating",
  "Finance": "Finanza",
  "Crypto": "Crypto",
  "Sweepstakes": "Sweepstakes",
  "Back": "Indietro",
  "Streams": "Stream",
  "Open target URL": "Apri URL di destinazione",
  "Copy tracking link": "Copia link di tracciamento",
  "Tracking link copied!": "Link di tracciamento copiato!",
  "Campaign not found": "Campagna non trovata",
  "Successful conversions": "Conversioni riuscite",
  "Conversion rate": "Tasso di conversione",
  "Conversion percentage": "Percentuale di conversione",
  "Campaign info": "Informazioni sulla campagna",
  "Tracking link": "Link di tracciamento",
  "Created": "Creato",
  "Updated": "Aggiornato",
  "Recent clicks": "Click recenti",
  "Recent activity for this campaign": "Attività recente per questa campagna",
  "No clicks for this campaign yet": "Ancora nessun click per questa campagna",
  "Showing latest 10 clicks": "Visualizzazione degli ultimi 10 click",
  "Device breakdown": "Suddivisione per dispositivo",
  "Browser breakdown": "Suddivisione per browser",
  "No data to display": "Nessun dato da visualizzare",
  "Unknown": "Sconosciuto",
  "Traffic sources": "Sorgenti di traffico",
  "Create source": "Crea sorgente",
  "Create traffic source": "Crea sorgente di traffico",
  "Edit traffic source": "Modifica sorgente di traffico",
  "Update traffic source settings": "Aggiorna impostazioni sorgente di traffico",
  "Configure a traffic source for UTM tags and conversion postbacks": "Configura una sorgente di traffico per tag UTM e postback di conversione",
  "Source template": "Modello di sorgente",
  "Pick a template or create your own": "Scegli un modello o creane uno tuo",
  "Traffic source name": "Nome della sorgente di traffico",
  "Traffic source description": "Descrizione della sorgente di traffico",
  "Postback URL": "URL di postback",
  "Postback URL copied": "URL di postback copiato",
  "UTM parameters": "Parametri UTM",
  "Add parameter": "Aggiungi parametro",
  "Enter parameter name:": "Inserisci il nome del parametro:",
  "Parameter": "Parametro",
  "Alias": "Alias",
  "Placeholder": "Placeholder",
  "Action": "Azione",
  "Source macro": "Macro sorgente",
  "No parameters added": "Nessun parametro aggiunto",
  "Search traffic sources…": "Cerca sorgenti di traffico…",
  "Sources not found": "Sorgenti non trovate",
  "No traffic sources": "Nessuna sorgente di traffico",
  "Create sources to integrate with ad networks": "Crea sorgenti per integrarti con i network pubblicitari",
  "Spend": "Spesa",
  "Parameters configured:": "Parametri configurati:",
  "Traffic source created": "Sorgente di traffico creata",
  "Traffic source updated": "Sorgente di traffico aggiornata",
  "Traffic source deleted": "Sorgente di traffico eliminata",
  "Are you sure you want to delete this traffic source?": "Sei sicuro di voler eliminare questa sorgente di traffico?",
  "Cannot delete: source is in use by campaigns": "Impossibile eliminare: la sorgente è in uso in alcune campagne",
  "Error loading traffic sources": "Errore nel caricamento delle sorgenti di traffico",
  "Error creating traffic source": "Errore nella creazione della sorgente di traffico",
  "Error updating traffic source": "Errore nell'aggiornamento della sorgente di traffico",
  "Error deleting traffic source": "Errore nell'eliminazione della sorgente di traffico",
  "Preferences": "Preferenze",
  "Notifications": "Notifiche",
  "System": "Sistema",
  "Profile information": "Informazioni profilo",
  "Manage your basic account information": "Gestisci le informazioni di base del tuo account",
  "Enter your full name": "Inserisci il tuo nome completo",
  "Enter your email": "Inserisci la tua email",
  "Save profile": "Salva profilo",
  "Change password": "Cambia password",
  "Update your password to keep your account secure": "Aggiorna la tua password per mantenere sicuro il tuo account",
  "Current password": "Password attuale",
  "New password": "Nuova password",
  "Confirm new password": "Conferma nuova password",
  "Enter current password": "Inserisci la password attuale",
  "Enter new password": "Inserisci la nuova password",
  "New passwords do not match": "Le nuove password non corrispondono",
  "New password must be at least 6 characters": "La nuova password deve contenere almeno 6 caratteri",
  "Password changed successfully": "Password cambiata con successo",
  "Profile updated successfully": "Profilo aggiornato con successo",
  "Error updating profile": "Errore nell'aggiornamento del profilo",
  "Error changing password": "Errore nel cambio password",
  "Error loading settings": "Errore nel caricamento delle impostazioni",
  "Error saving settings": "Errore nel salvataggio delle impostazioni",
  "Error saving system settings": "Errore durante il salvataggio delle impostazioni di sistema",
  "User settings saved": "Impostazioni utente salvate",
  "System settings saved": "Impostazioni di sistema salvate",
  "Interface preferences": "Preferenze interfaccia",
  "Customize the look and behavior of the app": "Personalizza l'aspetto e il comportamento dell'app",
  "Timezone": "Fuso orario",
  "Moscow (UTC+3)": "Mosca (UTC+3)",
  "Kyiv (UTC+2)": "Kiev (UTC+2)",
  "New York (UTC-5)": "New York (UTC-5)",
  "Language": "Lingua",
  "Date format": "Formato data",
  "Dashboard refresh rate (sec)": "Frequenza di aggiornamento dashboard (sec)",
  "Save settings": "Salva impostazioni",
  "Configure how you receive notifications": "Configura come ricevere le notifiche",
  "Email notifications": "Notifiche email",
  "SMS notifications": "Notifiche SMS",
  "Get email notifications about important events": "Ricevi notifiche email sugli eventi importanti",
  "Get SMS for critical events": "Ricevi SMS per eventi critici",
  "Save notification settings": "Salva impostazioni notifiche",
  "Tracking domains": "Domini di tracking",
  "Configure domains for campaign tracking": "Configura i domini per il tracking delle campagne",
  "Primary tracking domain": "Dominio di tracking principale",
  "Additional domains": "Domini aggiuntivi",
  "Add domain": "Aggiungi dominio",
  "Add": "Aggiungi",
  "Save domain settings": "Salva impostazioni dominio",
  "Security": "Sicurezza",
  "Security and access settings": "Impostazioni di sicurezza e accesso",
  "Security settings": "Impostazioni di sicurezza",
  "Coming in upcoming releases": "In arrivo nei prossimi aggiornamenti",
  "Active campaigns": "Campagne attive",
  "Clicks today": "Clic oggi",
  "For the current day": "Per il giorno corrente",
  "Confirmed": "Confermato",
  "Refresh": "Aggiorna",
  "Export": "Esporta",
  "Report exported": "Report esportato",
  "Period:": "Periodo:",
  "Today": "Oggi",
  "7 days": "7 giorni",
  "14 days": "14 giorni",
  "30 days": "30 giorni",
  "90 days": "90 giorni",
  "Campaign:": "Campagna:",
  "All campaigns": "Tutte le campagne",
  "Overview": "Panoramica",
  "Devices": "Dispositivi",
  "Clicks and conversions": "Clic e conversioni",
  "No data for the selected period": "Nessun dato per il periodo selezionato",
  "No data": "Nessun dato",
  "Hourly activity": "Attività oraria",
  "CR% by day": "CR% per giorno",
  "Campaign stats": "Statistiche campagna",
  "Revenue": "Ricavi",
  "No campaign data": "Nessun dato di campagna",
  "Total revenue": "Ricavi totali",
  "Total spend": "Spesa totale",
  "Profit": "Profitto",
  "Net positive": "Netto positivo",
  "Net loss": "Perdita netta",
  "Advanced notification preferences": "Preferenze avanzate di notifica",
  "Push notifications, webhook URL, alert categories": "Notifiche push, URL webhook, categorie di avviso",
  "Configure": "Configura",
  "All values shown in": "Tutti i valori sono mostrati in",
  "FX rates unavailable — non-USD revenue is excluded from the totals.": "Tassi di cambio non disponibili — i ricavi non in USD sono esclusi dai totali.",
  "ROI by campaigns": "ROI per campagna",
  "No ROI data": "Nessun dato ROI",
  "Clicks by country": "Clic per paese",
  "Geo table": "Tabella GEO",
  "No geo data": "Nessun dato geografico",
  "Country": "Paese",
  "Devices table": "Tabella dispositivi",
  "Device type": "Tipo di dispositivo",
  "Share": "Quota",
  "No device data": "Nessun dato sui dispositivi",
  "Failed to load campaign": "Errore nel caricamento della campagna",
  "Failed to load streams": "Errore nel caricamento degli stream",
  "Stream created": "Stream creato",
  "Failed to create stream": "Errore nella creazione dello stream",
  "Stream updated": "Stream aggiornato",
  "Failed to update stream": "Errore nell'aggiornamento dello stream",
  "Delete this stream?": "Eliminare questo stream?",
  "Stream deleted": "Stream eliminato",
  "Failed to delete stream": "Errore nell'eliminazione dello stream",
  "Catch": "Catch",
  "Fallback": "Fallback",
  "Normal": "Normale",
  "Stream name": "Nome stream",
  "Stream type": "Tipo di stream",
  "Position": "Posizione",
  "Weight (%)": "Peso (%)",
  "Click limit": "Limite di clic",
  "No limit": "Nessun limite",
  "Stream action": "Azione dello stream",
  "Action type": "Tipo di azione",
  "Redirect": "Reindirizzamento",
  "Split test": "Split test",
  "Redirect URL": "URL di reindirizzamento",
  "Landings and offers": "Landing page e offerte",
  "Landings": "Landing page",
  "No landings available": "Nessuna landing page disponibile",
  "No offers available": "Nessuna offerta disponibile",
  "Traffic filters": "Filtri di traffico",
  "Countries (ISO codes)": "Paesi (codici ISO)",
  "Cities": "Città",
  "Browsers": "Browser",
  "Operating systems": "Sistemi operativi",
  "Languages": "Lingue",
  "Don't filter": "Non filtrare",
  "Accept only unique": "Accetta solo unici",
  "Filter unique": "Filtra unici",
  "Campaign streams": "Stream della campagna",
  "Create stream": "Crea stream",
  "Configure stream for traffic distribution by conditions": "Configura lo stream per la distribuzione del traffico in base a condizioni",
  "No streams": "Nessuno stream",
  "Create streams to distribute traffic by conditions": "Crea stream per distribuire il traffico in base a condizioni",
  "Weight": "Peso",
  "Bots filtered": "Bot filtrati",
  "Countries": "Paesi",
  "Limit": "Limite",
  "Edit stream": "Modifica stream",
  "Modify stream settings": "Modifica le impostazioni dello stream",
  "Failed to load data": "Impossibile caricare i dati",
  "Failed to load traffic rules": "Impossibile caricare le regole di traffico",
  "Select a campaign": "Seleziona una campagna",
  "Traffic rule created": "Regola di traffico creata",
  "Failed to create rule": "Impossibile creare la regola",
  "Rule updated": "Regola aggiornata",
  "Failed to update rule": "Impossibile aggiornare la regola",
  "Rule deleted": "Regola eliminata",
  "Failed to delete rule": "Impossibile eliminare la regola",
  "Landing created": "Landing page creata",
  "Failed to create landing": "Impossibile creare la landing page",
  "Failed to create offer": "Impossibile creare l'offerta",
  "Traffic management": "Gestione del traffico",
  "Select campaign": "Seleziona campagna",
  "Traffic rules": "Regole di traffico",
  "Traffic distribution rules": "Regole di distribuzione del traffico",
  "Create rule": "Crea regola",
  "Create traffic rule": "Crea regola di traffico",
  "Edit rule": "Modifica regola",
  "Configure conditions and actions for traffic distribution": "Configura condizioni e azioni per la distribuzione del traffico",
  "Rule name": "Nome della regola",
  "Priority": "Priorità",
  "Rule description": "Descrizione della regola",
  "Conditions (leave empty for any value)": "Condizioni (lascia vuoto per qualsiasi valore)",
  "Update": "Aggiorna",
  "No traffic rules": "Nessuna regola di traffico",
  "Create rules to distribute traffic by conditions": "Crea regole per distribuire il traffico in base a condizioni",
  "Stopped": "Fermato",
  "Any": "Qualsiasi",
  "Redirects": "Reindirizzamenti",
  "Select a campaign to manage traffic rules": "Seleziona una campagna per gestire le regole di traffico",
  "Add landing": "Aggiungi landing page",
  "Add a new landing to the library": "Aggiungi una nuova landing page alla libreria",
  "Landing name": "Nome della landing page",
  "Landing description": "Descrizione della landing page",
  "No landings": "Nessuna landing page",
  "Add landings to use in traffic rules": "Aggiungi landing page da usare nelle regole di traffico",
  "Add a new offer to monetize traffic": "Aggiungi una nuova offerta per monetizzare il traffico",
  "Offer name": "Nome dell'offerta",
  "Add offers to monetize traffic": "Aggiungi offerte per monetizzare il traffico",
  "A/B Testing": "Test A/B",
  "Create A/B test": "Crea test A/B",
  "Set up split testing to optimize conversions": "Configura lo split testing per ottimizzare le conversioni",
  "Test name": "Nome del test",
  "Landing page test": "Test landing page",
  "Test description": "Descrizione del test",
  "Test type": "Tipo di test",
  "Traffic paths": "Percorsi di traffico",
  "Confidence level (%)": "Livello di confidenza (%)",
  "Minimum sample size": "Dimensione minima del campione",
  "Test variants": "Varianti del test",
  "Add variant": "Aggiungi variante",
  "Variant {n}": "Variante {n}",
  "Variant name": "Nome della variante",
  "URL (or pick below)": "URL (o scegli qui sotto)",
  "Pick landing page": "Scegli landing page",
  "Pick offer": "Scegli offerta",
  "Traffic weight (%)": "Peso del traffico (%)",
  "Total weight": "Peso totale",
  "Create test": "Crea test",
  "No A/B tests": "Nessun test A/B",
  "Create split tests to optimize conversions": "Crea split test per ottimizzare le conversioni",
  "Visitors": "Visitatori",
  "Significance": "Significatività",
  "Variants": "Varianti",
  "Progress to minimum sample": "Progresso verso il campione minimo",
  "A/B test results": "Risultati del test A/B",
  "Variant performance analysis": "Analisi delle prestazioni delle varianti",
  "Conversion": "Conversione",
  "Confidence interval": "Intervallo di confidenza",
  "Not enough data for analysis": "Dati insufficienti per l'analisi",
  "Close": "Chiudi",
  "Running": "In esecuzione",
  "Completed": "Completato",
  "Draft": "Bozza",
  "Delete this A/B test?": "Eliminare questo test A/B?",
  "A/B test deleted": "Test A/B eliminato",
  "Failed to delete test": "Impossibile eliminare il test",
  "A/B test created": "Test A/B creato",
  "Failed to create A/B test": "Impossibile creare il test A/B",
  "A/B test started": "Test A/B avviato",
  "Failed to start test": "Impossibile avviare il test",
  "A/B test paused": "Test A/B messo in pausa",
  "Failed to pause test": "Impossibile mettere in pausa il test",
  "Failed to load results": "Impossibile caricare i risultati",
  "Failed to load A/B tests": "Impossibile caricare i test A/B",
  "At least 2 variants required": "Sono richieste almeno 2 varianti",
  "Webhooks": "Webhook",
  "Import costs and conversions": "Importa costi e conversioni",
  "Sync campaigns and conversions": "Sincronizza campagne e conversioni",
  "Import ad statistics": "Importa statistiche pubblicitarie",
  "VKontakte integration": "Integrazione VKontakte",
  "Automatic traffic import": "Importazione automatica del traffico",
  "Server-to-server postbacks": "Postback server-to-server",
  "Custom API integration": "Integrazione API personalizzata",
  "Telegram notifications": "Notifiche Telegram",
  "Click": "Click",
  "Campaign paused": "Campagna messa in pausa",
  "Campaign started": "Campagna avviata",
  "Fraud detected": "Frode rilevata",
  "Threshold reached": "Soglia raggiunta",
  "Fill in type and name": "Compila tipo e nome",
  "Integration created": "Integrazione creata",
  "Error creating": "Errore durante la creazione",
  "Integration updated": "Integrazione aggiornata",
  "Error updating": "Errore durante l'aggiornamento",
  "Delete integration?": "Eliminare l'integrazione?",
  "Integration deleted": "Integrazione eliminata",
  "Error deleting": "Errore durante l'eliminazione",
  "Fill in name and URL": "Compila nome e URL",
  "Webhook created": "Webhook creato",
  "Error creating webhook": "Errore durante la creazione del webhook",
  "Webhook updated": "Webhook aggiornato",
  "Delete webhook?": "Eliminare il webhook?",
  "Webhook deleted": "Webhook eliminato",
  "Test succeeded (HTTP {code})": "Test riuscito (HTTP {code})",
  "Test error: {detail}": "Errore nel test: {detail}",
  "Error testing webhook": "Errore durante il test del webhook",
  "Integration type": "Tipo di integrazione",
  "Select type": "Seleziona tipo",
  "Configuration (key-value)": "Configurazione (chiave-valore)",
  "Key (e.g. api_key)": "Chiave (es. api_key)",
  "Value": "Valore",
  "My webhook": "Il mio webhook",
  "Secret (optional)": "Segreto (opzionale)",
  "Events": "Eventi",
  "Retry attempts": "Tentativi di retry",
  "Timeout (sec)": "Timeout (sec)",
  "Add integration": "Aggiungi integrazione",
  "New integration": "Nuova integrazione",
  "Configure connection to an external service": "Configura la connessione a un servizio esterno",
  "No integrations": "Nessuna integrazione",
  "Connect external services to automate workflows": "Collega servizi esterni per automatizzare i flussi di lavoro",
  "Connected": "Connesso",
  "Disconnected": "Disconnesso",
  "Last sync": "Ultima sincronizzazione",
  "Add webhook": "Aggiungi webhook",
  "New webhook": "Nuovo webhook",
  "Configure a webhook to receive notifications": "Configura un webhook per ricevere notifiche",
  "No webhooks": "Nessun webhook",
  "Create webhooks to send events to external systems": "Crea webhook per inviare eventi a sistemi esterni",
  "Success": "Successo",
  "Errors": "Errori",
  "Test": "Test",
  "Edit integration": "Modifica integrazione",
  "Edit webhook": "Modifica webhook",
  "Anti-fraud system": "Sistema antifrode",
  "Filter created": "Filtro creato",
  "Failed to create filter": "Impossibile creare il filtro",
  "Filter updated": "Filtro aggiornato",
  "Failed to update filter": "Impossibile aggiornare il filtro",
  "Filter deleted": "Filtro eliminato",
  "Failed to delete filter": "Impossibile eliminare il filtro",
  "IP added to blacklist": "IP aggiunto alla blacklist",
  "IP added to whitelist": "IP aggiunto alla whitelist",
  "Failed to add IP": "Impossibile aggiungere l'IP",
  "IP removed from blacklist": "IP rimosso dalla blacklist",
  "IP removed from whitelist": "IP rimosso dalla whitelist",
  "Failed to remove IP": "Impossibile rimuovere l'IP",
  "Activity marked as resolved": "Attività contrassegnata come risolta",
  "Failed to update activity": "Impossibile aggiornare l'attività",
  "Filters": "Filtri",
  "IP lists": "Liste IP",
  "Suspicious activity": "Attività sospetta",
  "Statistics": "Statistiche",
  "Fraud filters": "Filtri antifrode",
  "Create filter": "Crea filtro",
  "Edit filter": "Modifica filtro",
  "Create fraud filter": "Crea filtro antifrode",
  "Configure automatic filters to block suspicious traffic": "Configura filtri automatici per bloccare il traffico sospetto",
  "Filter name": "Nome del filtro",
  "Filter type": "Tipo di filtro",
  "Bot detection": "Rilevamento bot",
  "Click frequency": "Frequenza click",
  "Country block": "Blocco per paese",
  "ASN block": "Blocco per ASN",
  "Datacenter / hosting block": "Blocco datacenter / hosting",
  "Proxy / VPN / Tor block": "Blocco proxy / VPN / Tor",
  "External risk score": "Punteggio di rischio esterno",
  "Filter description": "Descrizione del filtro",
  "Max clicks per minute": "Click massimi al minuto",
  "Blocked countries (ISO codes)": "Paesi bloccati (codici ISO)",
  "ASN numbers": "Numeri ASN",
  "ASN name substrings": "Sottostringhe del nome ASN",
  "Comma-separated AS numbers (e.g. 16509 = AWS, 24940 = Hetzner).": "Numeri AS separati da virgola (es. 16509 = AWS, 24940 = Hetzner).",
  "Case-insensitive substring match against the ASN label.": "Corrispondenza di sottostringa senza distinzione tra maiuscole e minuscole rispetto all'etichetta ASN.",
  "Allowed ASNs (whitelist)": "ASN consentiti (whitelist)",
  "Optional. Datacenter IPs that match these ASNs / labels are not blocked.": "Opzionale. Gli IP di datacenter che corrispondono a questi ASN / etichette non vengono bloccati.",
  "Block Tor exit nodes": "Blocca i nodi di uscita Tor",
  "Block proxies (requires API key)": "Blocca i proxy (richiede API key)",
  "Block VPNs (requires API key)": "Blocca le VPN (richiede API key)",
  "External provider": "Provider esterno",
  "Set IPQS_API_KEY or FRAUDSCORE_API_KEY in the backend environment.": "Imposta IPQS_API_KEY o FRAUDSCORE_API_KEY nell'ambiente del backend.",
  "Risk score threshold (0-100)": "Soglia del punteggio di rischio (0-100)",
  "Block when the provider returns a score >= this threshold (default 85).": "Blocca quando il provider restituisce un punteggio >= a questa soglia (predefinito 85).",
  "Block": "Blocca",
  "Log only": "Solo registra",
  "No active filters": "Nessun filtro attivo",
  "Create filters for automatic fraud protection": "Crea filtri per la protezione automatica dalle frodi",
  "Blocked": "Bloccato",
  "False positives": "Falsi positivi",
  "IP blacklist": "Blacklist IP",
  "IP whitelist": "Whitelist IP",
  "Blacklist is empty": "La blacklist è vuota",
  "Whitelist is empty": "La whitelist è vuota",
  "Blocked: {n} times": "Bloccato: {n} volte",
  "View blocked samples": "Visualizza campioni bloccati",
  "Blocked samples": "Campioni bloccati",
  "Blocked samples: {name}": "Campioni bloccati: {name}",
  "Most recent traffic caught by this filter. Use it to spot false positives.": "Traffico più recente intercettato da questo filtro. Usalo per individuare i falsi positivi.",
  "No blocked samples yet": "Nessun campione bloccato ancora",
  "Failed to load blocked samples": "Impossibile caricare i campioni bloccati",
  "(empty UA)": "(UA vuoto)",
  "Add IP to blacklist": "Aggiungi IP alla blacklist",
  "Add IP to whitelist": "Aggiungi IP alla whitelist",
  "IP address": "Indirizzo IP",
  "Reason": "Motivo",
  "Reason for adding": "Motivo dell'aggiunta",
  "Notes (optional)": "Note (opzionale)",
  "Additional information": "Informazioni aggiuntive",
  "No suspicious activity detected": "Nessuna attività sospetta rilevata",
  "The system automatically tracks suspicious actions": "Il sistema monitora automaticamente le azioni sospette",
  "Resolved": "Risolto",
  "Mark as resolved": "Segna come risolto",
  "User Agent": "User Agent",
  "Time": "Ora",
  "Details": "Dettagli",
  "Active filters": "Filtri attivi",
  "Blocked IPs": "IP bloccati",
  "Failed to load automation rules": "Impossibile caricare le regole di automazione",
  "Automation rule created": "Regola di automazione creata",
  "Failed to create automation rule": "Impossibile creare la regola di automazione",
  "Automation rule updated": "Regola di automazione aggiornata",
  "Failed to update automation rule": "Impossibile aggiornare la regola di automazione",
  "Are you sure you want to delete this rule?": "Sei sicuro di voler eliminare questa regola?",
  "Automation rule deleted": "Regola di automazione eliminata",
  "Failed to delete automation rule": "Impossibile eliminare la regola di automazione",
  "Rule activated": "Regola attivata",
  "Rule deactivated": "Regola disattivata",
  "Failed to change rule status": "Impossibile modificare lo stato della regola",
  "Notification settings saved": "Impostazioni di notifica salvate",
  "Failed to save notification settings": "Impossibile salvare le impostazioni di notifica",
  "Pause campaign": "Metti in pausa la campagna",
  "Budget alert": "Avviso di budget",
  "Performance alert": "Avviso di performance",
  "Rules": "Regole",
  "Automation rules": "Regole di automazione",
  "Create automation rule": "Crea regola di automazione",
  "Configure automatic actions based on conditions": "Configura azioni automatiche in base a condizioni",
  "Rule type": "Tipo di regola",
  "Trigger conditions": "Condizioni di attivazione",
  "Maximum cost per click": "Costo massimo per clic",
  "Minimum CR (%)": "CR minimo (%)",
  "Budget percentage for alert": "Percentuale di budget per l'avviso",
  "Execution settings": "Impostazioni di esecuzione",
  "Interval between executions (min)": "Intervallo tra le esecuzioni (min)",
  "Maximum executions per day": "Esecuzioni massime al giorno",
  "No automation rules": "Nessuna regola di automazione",
  "Create rules to automatically manage campaigns": "Crea regole per gestire automaticamente le campagne",
  "Executions": "Esecuzioni",
  "Interval": "Intervallo",
  "{n} min": "{n} min",
  "Daily limit": "Limite giornaliero",
  "Last execution": "Ultima esecuzione",
  "Notification channels": "Canali di notifica",
  "Receive notifications by email": "Ricevi notifiche via email",
  "Receive SMS for critical events": "Ricevi SMS per eventi critici",
  "Push notifications": "Notifiche push",
  "Browser notifications": "Notifiche del browser",
  "Webhook URL": "URL webhook",
  "Manage how and when you receive alerts": "Gestisci come e quando ricevere gli avvisi",
  "Save preferences": "Salva preferenze",
  "Saving…": "Salvataggio…",
  "Delivery channels": "Canali di consegna",
  "Choose how to receive notifications": "Scegli come ricevere le notifiche",
  "Receive alerts via email": "Ricevi avvisi via email",
  "Critical alerts via SMS": "Avvisi critici via SMS",
  "In-app and browser push": "Push in-app e browser",
  "POST JSON payloads to your endpoint": "Invia payload JSON POST al tuo endpoint",
  "Alert categories": "Categorie di avvisi",
  "Choose which types of events trigger notifications": "Scegli quali tipi di eventi attivano le notifiche",
  "Campaign alerts": "Avvisi campagna",
  "Paused, resumed, daily cap reached": "In pausa, ripresa, limite giornaliero raggiunto",
  "Performance alerts": "Avvisi di performance",
  "ROI drop, conversion rate change, EPC decline": "Calo del ROI, variazione del tasso di conversione, calo dell'EPC",
  "Fraud alerts": "Avvisi di frode",
  "Suspicious clicks, bot traffic, IP blacklist hits": "Click sospetti, traffico bot, IP in blacklist",
  "System alerts": "Avvisi di sistema",
  "Domain verification, TLS expiry, billing": "Verifica dominio, scadenza TLS, fatturazione",
  "Notification preferences saved": "Preferenze di notifica salvate",
  "Failed to load notification settings": "Errore nel caricamento delle impostazioni di notifica",
  "CSV exported": "CSV esportato",
  "Export campaigns to CSV": "Esporta campagne in CSV",
  "Export offers to CSV": "Esporta offerte in CSV",
  "No domains yet": "Nessun dominio ancora",
  "Add a custom domain to serve tracking links from your own branded URL.": "Aggiungi un dominio personalizzato per servire i link di tracciamento dal tuo URL con marchio.",
  "Create streams to split traffic by geo, device, OS, or custom conditions.": "Crea stream per suddividere il traffico per GEO, dispositivo, sistema operativo o condizioni personalizzate.",
  "Create rules to automatically pause, resume, or adjust campaigns based on performance thresholds.": "Crea regole per mettere in pausa, riprendere o modificare automaticamente le campagne in base a soglie di performance.",
  "No members yet": "Nessun membro ancora",
  "Invite teammates above to collaborate.": "Invita i tuoi collaboratori qui sopra per collaborare.",
  "URL for receiving notifications in JSON format": "URL per ricevere le notifiche in formato JSON",
  "Alert types": "Tipi di avviso",
  "Campaign start, pause, completion": "Avvio, pausa e completamento della campagna",
  "Changes in CR, ROI, cost": "Variazioni di CR, ROI, costo",
  "Suspicious traffic detection": "Rilevamento traffico sospetto",
  "Updates and technical information": "Aggiornamenti e informazioni tecniche",
  "Execution history": "Cronologia esecuzioni",
  "Execution history is empty": "La cronologia esecuzioni è vuota",
  "Records of automatic rule executions will appear here": "Qui appariranno i registri delle esecuzioni automatiche delle regole",
  "Edit automation rule": "Modifica regola di automazione",
  "Change automation rule settings": "Modifica le impostazioni della regola di automazione",
  "Geographic statistics": "Statistiche geografiche",
  "Loading geographic data...": "Caricamento dati geografici...",
  "By country": "Per paese",
  "By city": "Per città",
  "No country data": "Nessun dato per paese",
  "No city data": "Nessun dato per città",
  "Click map": "Mappa dei click",
  "No data to display on map": "Nessun dato da mostrare sulla mappa",
  "Geographic data will appear after the first clicks with resolvable coordinates": "I dati geografici appariranno dopo i primi click con coordinate risolvibili",
  "Signed in successfully!": "Accesso effettuato con successo!",
  "Sign in failed": "Accesso non riuscito",
  "Registration successful!": "Registrazione completata!",
  "Registration failed": "Registrazione non riuscita",
  "Signed out": "Disconnesso",
  "One moment…": "Un momento…",
  "Documentation": "Documentazione",
  "Help": "Aiuto",
  "Step-by-step guide for every feature": "Guida passo passo per ogni funzione",
  "Search sections...": "Cerca sezioni...",
  "Loading documentation...": "Caricamento documentazione...",
  "Back to top": "Torna su",
  "Domains": "Domini",
  "Tracker domains": "Domini del tracker",
  "Custom domains": "Domini personalizzati",
  "Bind your own domain to mask tracking links. Point a CNAME to our edge and verify ownership via TXT record.": "Collega il tuo dominio per mascherare i link di tracking. Punta un CNAME al nostro edge e verifica la proprietà tramite record TXT.",
  "After adding, configure DNS for your domain (TXT record for verification, CNAME or A record to route traffic), then press Verify.": "Dopo averlo aggiunto, configura il DNS del tuo dominio (record TXT per la verifica, record CNAME o A per instradare il traffico), poi premi Verifica.",
  "Verified": "Verificato",
  "Failed": "Fallito",
  "Pending": "In attesa",
  "Default": "Predefinito",
  "Set default": "Imposta come predefinito",
  "Verify": "Verifica",
  "TXT verification record": "Record di verifica TXT",
  "Routing record (CNAME)": "Record di instradamento (CNAME)",
  "Copy value": "Copia valore",
  "Copied": "Copiato",
  "Tracking links will use": "I link di tracking useranno",
  "Domain added": "Dominio aggiunto",
  "Failed to add domain": "Errore nell'aggiunta del dominio",
  "Domain verified": "Dominio verificato",
  "Verification failed": "Verifica fallita",
  "Default domain updated": "Dominio predefinito aggiornato",
  "Domain deleted": "Dominio eliminato",
  "Delete this domain?": "Eliminare questo dominio?",
  "Enable HTTPS": "Abilita HTTPS",
  "HTTPS active": "HTTPS attivo",
  "Check TLS": "Controlla TLS",
  "TLS validation records": "Record di convalida TLS",
  "TLS provisioning started": "Provisioning TLS avviato",
  "TLS provisioning failed": "Provisioning TLS fallito",
  "Action failed": "Azione fallita",
  "Loading…": "Caricamento…",
  "Conversion API": "API di conversione",
  "Conversion forwarders": "Forwarder di conversione",
  "Forward conversions server-to-server to ad networks (FB CAPI, Google Ads, TikTok). Fires automatically on every postback.": "Inoltra le conversioni server-to-server ai network pubblicitari (FB CAPI, Google Ads, TikTok). Si attiva automaticamente a ogni postback.",
  "New forwarder": "Nuovo forwarder",
  "Edit forwarder": "Modifica forwarder",
  "No forwarders yet": "Nessun forwarder ancora",
  "Forwarder created": "Forwarder creato",
  "Forwarder updated": "Forwarder aggiornato",
  "Forwarder deleted": "Forwarder eliminato",
  "Delete forwarder?": "Eliminare il forwarder?",
  "Send test": "Invia test",
  "Test event sent": "Evento di test inviato",
  "Test failed": "Test fallito",
  "No events yet": "Nessun evento ancora",
  "Provider": "Provider",
  "Event name": "Nome evento",
  "Name is required": "Il nome è obbligatorio",
  "Missing fields": "Campi mancanti",
  "Sent": "Inviato",
  "Event": "Evento",
  "Last sent": "Ultimo invio",
  "Public API": "API pubblica",
  "API keys": "Chiavi API",
  "New key": "Nuova chiave",
  "New API key": "Nuova chiave API",
  "Use API keys to call the public /v1 REST API. Pass the key as": "Usa le chiavi API per chiamare la REST API pubblica /v1. Passa la chiave come",
  "or": "o",
  "Copy your key now — it will not be shown again": "Copia la tua chiave ora — non verrà più mostrata",
  "Copy": "Copia",
  "Dismiss": "Chiudi",
  "Quick start": "Guida rapida",
  "Docs": "Documentazione",
  "No API keys yet": "Nessuna chiave API ancora",
  "Scopes": "Ambiti",
  "Delete this key?": "Eliminare questa chiave?",
  "Key deleted": "Chiave eliminata",
  "last used": "ultimo utilizzo",
  "never used": "mai utilizzata",
  "Team": "Team",
  "Workspace": "Spazio di lavoro",
  "Invite teammates with roles. Owner sees everything; manager/admin can edit; viewer is read-only.": "Invita i membri del team con dei ruoli. Il proprietario vede tutto; manager/admin possono modificare; viewer è di sola lettura.",
  "Invite member": "Invita membro",
  "Invite": "Invita",
  "Invite sent": "Invito inviato",
  "Share this link with the invitee:": "Condividi questo link con l'invitato:",
  "Role": "Ruolo",
  "Members": "Membri",
  "Revoke access?": "Revocare l'accesso?",
  "Revoke access": "Revoca accesso",
  "Access revoked": "Accesso revocato",
  "Reset 2FA": "Reimposta 2FA",
  "Reset this member's 2FA?": "Reimpostare la 2FA di questo membro?",
  "2FA reset — member can re-enrol": "2FA reimpostata — il membro può registrarsi di nuovo",
  "Member had no 2FA configured": "Il membro non aveva 2FA configurata",
  "2FA reset failed": "Reimpostazione 2FA fallita",
  "Workspace currency": "Valuta dello spazio di lavoro",
  "Display currency": "Valuta di visualizzazione",
  "Reports and dashboards will be normalised to this currency. FX rates are refreshed hourly.": "Report e dashboard verranno normalizzati in questa valuta. I tassi di cambio vengono aggiornati ogni ora.",
  "Workspace currency saved": "Valuta dello spazio di lavoro salvata",
  "Could not save currency": "Impossibile salvare la valuta",
  "Invited": "Invitato",
  "Shared with me": "Condiviso con me",
  "No shared workspaces": "Nessuno spazio di lavoro condiviso",
  "Audit log": "Registro di controllo",
  "Workspace-scoped trail of privileged actions. Retained for 90 days.": "Cronologia delle azioni privilegiate nell'ambito del workspace. Conservata per 90 giorni.",
  "Target type": "Tipo di destinazione",
  "Actor ID": "ID attore",
  "Since": "Da",
  "Until": "A",
  "Apply": "Applica",
  "Actor": "Attore",
  "Target": "Destinazione",
  "Payload": "Payload",
  "IP": "IP",
  "Load more": "Carica altro",
  "No audit entries match the current filters.": "Nessuna voce di controllo corrisponde ai filtri attuali.",
  "Failed to load audit log": "Impossibile caricare il registro di controllo",
  "CAPI DLQ": "CAPI DLQ",
  "CAPI dead-letter queue": "Coda dead-letter CAPI",
  "Conversions that exhausted the retry budget. Replay re-attempts the forwarder; discard drops the entry permanently.": "Conversioni che hanno esaurito il budget di tentativi. Riprova esegue nuovamente il forwarder; scarta elimina la voce in modo permanente.",
  "Forwarder ID": "ID forwarder",
  "Conversion ID": "ID conversione",
  "Since (ISO)": "Da (ISO)",
  "Until (ISO)": "A (ISO)",
  "Apply filters": "Applica filtri",
  "No DLQ entries match these filters.": "Nessuna voce DLQ corrisponde a questi filtri.",
  "Forwarder": "Forwarder",
  "Attempts": "Tentativi",
  "Last error": "Ultimo errore",
  "Replay": "Riprova",
  "Discard": "Scarta",
  "CAPI replay succeeded": "Riprova CAPI riuscita",
  "Replay failed:": "Riprova non riuscita:",
  "Replay failed": "Riprova non riuscita",
  "DLQ entry discarded": "Voce DLQ scartata",
  "Discard failed": "Eliminazione non riuscita",
  "Permanently discard this DLQ entry?": "Eliminare definitivamente questa voce della DLQ?",
  "Failed to load CAPI DLQ": "Impossibile caricare CAPI DLQ",
  "Activated {n}": "Attivate {n}",
  "Paused {n}": "In pausa: {n}",
  "Deleted {n}": "Eliminate {n}",
  "Skipped {n} (no access or not found)": "Saltate {n} (nessun accesso o non trovate)",
  "Bulk update failed": "Aggiornamento massivo non riuscito",
  "Bulk delete failed": "Eliminazione massiva non riuscita",
  "System health": "Salute del sistema",
  "System status": "Stato del sistema",
  "S2S log": "Registro S2S",
  "TLS fingerprints": "Impronte TLS",
  "Aggregated CAPI / postback / FX / cost-sync state across the workspaces you administer.": "Stato aggregato di CAPI / postback / FX / sincronizzazione costi negli spazi di lavoro che amministri.",
  "CAPI delivery": "Consegna CAPI",
  "Conversion API dispatches in the last window.": "Invii Conversion API nell'ultima finestra.",
  "Total": "Totale",
  "Success rate": "Tasso di successo",
  "No CAPI events in window.": "Nessun evento CAPI nella finestra.",
  "Retry queue": "Coda di retry",
  "Pending CAPI re-attempts.": "Nuovi tentativi CAPI in sospeso.",
  "Due now": "In scadenza ora",
  "Oldest": "Più vecchio",
  "Dead-letter queue": "Coda dead-letter",
  "Conversions that exhausted the retry budget.": "Conversioni che hanno esaurito il budget di tentativi.",
  "Postback delivery": "Consegna postback",
  "S2S postback callouts in the last window.": "Chiamate postback S2S nell'ultima finestra.",
  "FX cache": "Cache FX",
  "Per-base exchange-rate snapshot freshness.": "Aggiornamento dello snapshot dei tassi di cambio per valuta base.",
  "Base": "Base",
  "Refreshed": "Aggiornato",
  "FX cache is empty.": "La cache FX è vuota.",
  "stale": "obsoleto",
  "fresh": "aggiornato",
  "Ad cost sync": "Sincronizzazione costi pubblicitari",
  "Active connections, last sync time, and recent errors.": "Connessioni attive, ultima sincronizzazione ed errori recenti.",
  "No active ad-cost connections.": "Nessuna connessione attiva per i costi pubblicitari.",
  "error": "errore",
  "ok": "ok",
  "Generated at": "Generato il",
  "Window": "Finestra",
  "Failed to load admin health": "Impossibile caricare lo stato di salute dell'admin",
  "Export CSV": "Esporta CSV",
  "Audit log exported": "Registro di controllo esportato",
  "Audit export failed": "Esportazione del registro non riuscita",
  "Billing": "Fatturazione",
  "Plans & usage": "Piani e utilizzo",
  "Current plan": "Piano attuale",
  "Current": "Attuale",
  "Clicks this month": "Clic questo mese",
  "Plans & billing": "Piani e fatturazione",
  "Five editions: every plan includes the full tracker — pick your team size, domain scale and automation surface. Clicks are never limited.": "Cinque edizioni: ogni piano include il tracker completo — scegli la dimensione del tuo team, la scala dei domini e il livello di automazione. I clic non sono mai limitati.",
  "Billing is not activated on this server yet — all features are open. Plans below show what will apply once payments go live.": "La fatturazione non è ancora attivata su questo server — tutte le funzioni sono sbloccate. I piani qui sotto mostrano cosa si applicherà quando i pagamenti saranno attivi.",
  "Trial": "Prova",
  "day(s) left": "giorno/i rimanente/i",
  "choose a plan to keep your traffic flowing without interruption.": "scegli un piano per far scorrere il tuo traffico senza interruzioni.",
  "Your subscription is inactive: click processing and entity creation are paused. Choose a plan to resume instantly.": "Il tuo abbonamento è inattivo: l'elaborazione dei click e la creazione di entità sono in pausa. Scegli un piano per riprendere subito.",
  "Last payment failed — the tracker keeps working while Stripe retries. Update your card in Manage billing.": "L'ultimo pagamento non è andato a buon fine — il tracker continua a funzionare mentre Stripe riprova. Aggiorna la tua carta in Gestisci fatturazione.",
  "cancels at period end": "si annulla a fine periodo",
  "unlimited": "illimitato",
  "months": "mesi",
  "month": "mese",
  "billed every": "addebito ogni",
  "user(s)": "utente/i",
  "domain(s)": "dominio/i",
  "Choose plan": "Scegli piano",
  "Full tracker core": "Core completo del tracker",
  "Unlimited clicks": "Click illimitati",
  "Landing page editor": "Editor di landing page",
  "Online support": "Supporto online",
  "Click API + API keys": "Click API + chiavi API",
  "Facebook CAPI": "Facebook CAPI",
  "All 9 CAPI providers": "Tutti i 9 provider CAPI",
  "Report by conversion date": "Report per data di conversione",
  "White label branding": "Branding white label",
  "Personal manager": "Manager personale",
  "Priority support": "Supporto prioritario",
  "Onboarding call": "Chiamata di onboarding",
  "trialing": "in prova",
  "active": "attivo",
  "past_due": "pagamento scaduto",
  "expired": "scaduto",
  "canceled": "annullato",
  "exempt": "esente",
  "Manage billing": "Gestisci fatturazione",
  "Manage": "Gestisci",
  "Upgrade": "Aggiorna piano",
  "Free forever": "Gratis per sempre",
  "clicks/mo": "click/mese",
  "campaigns": "campagne",
  "team members": "membri del team",
  "Campaign parameters": "Parametri campagna",
  "Declare the URL parameters you pass through ad networks. Each row becomes a macro like {key} available in postbacks and CAPI payloads.": "Dichiara i parametri URL che passi attraverso i network pubblicitari. Ogni riga diventa una macro come {key} disponibile nei postback e nei payload CAPI.",
  "URL key": "Chiave URL",
  "Placeholder / default": "Placeholder / valore predefinito",
  "Google Ads tag": "Tag Google Ads",
  "No parameters yet": "Ancora nessun parametro",
  "Parameters have unsaved changes — clicks keep using the saved set until you save.": "I parametri hanno modifiche non salvate — i click continuano a usare il set salvato finché non salvi.",
  "Value written into the tracking link for this key: an ad-network macro such as {campaignid}, or a fixed value such as MCLV. A fixed value is also stored on clicks that arrive without the key; a macro in braces is not. Leave empty for keys the ad sets per account, such as tm and tml.": "Valore scritto nel link di tracciamento per questa chiave: una macro del network pubblicitario come {campaignid}, oppure un valore fisso come MCLV. Un valore fisso viene salvato anche sui click che arrivano senza la chiave; una macro tra parentesi graffe no. Lascia vuoto per le chiavi che l'annuncio imposta per account, come tm e tml.",
  "Macro: filled by the ad network, not stored on clicks without this key": "Macro: compilata dal network pubblicitario; non viene salvata sui click senza questa chiave",
  "Google Ads conversion keys": "Chiavi di conversione Google Ads",
  "Break down clicks and conversions by sub1–sub30 or any parameter declared in a campaign": "Suddividi click e conversioni per sub1–sub30 o per qualsiasi parametro dichiarato in una campagna",
  "Sub slot": "Slot sub",
  "Optional: the value is also stored as sub1…sub30 or a named field (external_id, creative_id…). Map the same thing to the same slot in every campaign (e.g. team -> sub8) and one report column and the {sub_id_8} macro cover all buyers; external_id feeds {external_id} in the source postback.": "Facoltativo: il valore viene salvato anche come sub1…sub30 o in un campo con nome (external_id, creative_id…). Mappa la stessa cosa sullo stesso slot in ogni campagna (es. team -> sub8): così una sola colonna del report e la macro {sub_id_8} coprono tutti i buyer; external_id alimenta {external_id} nel postback della sorgente.",
  "Source postback": "Postback della sorgente",
  "This source postback is already added": "Questo postback della sorgente è già stato aggiunto",
  "Source postback added — check its placeholders (REPLACE, XXXX…) and press Save": "Postback della sorgente aggiunto: controlla i suoi placeholder (REPLACE, XXXX…) e premi Salva",
  "Sale also fires for deposits (ftd, dep, deposit) and Lead also for registrations (reg, signup), whatever the broker calls them.": "Sale si attiva anche per i depositi (ftd, dep, deposit) e Lead anche per le registrazioni (reg, signup), comunque le chiami il broker.",
  "Keys without a default value (tm, tml, a…) are left out of the link: pass them in the ad, e.g. in the Google Ads Final URL suffix.": "Le chiavi senza valore predefinito (tm, tml, a…) vengono escluse dal link: passale nell'annuncio, ad es. nel suffisso URL finale di Google Ads.",
  "= Submit Lead Form label — set this conversion as Primary. Fired from the visitor’s browser after a successful lead.": "= etichetta di invio del modulo lead: imposta questa conversione come Primaria. Viene inviata dal browser del visitatore dopo un lead andato a buon fine.",
  "= Purchase / deposit label — set this conversion as Secondary. Sent by the \"Deposit → Purchase\" S2S rule; do not add an S2S rule for lead.": "= etichetta di acquisto / deposito: imposta questa conversione come Secondaria. Viene inviata dalla regola S2S \"Deposito → Acquisto\"; non aggiungere una regola S2S per il lead.",
  "Put both in the Final URL suffix of each Google Ads account (tml=AW-…/lead-label&tm=AW-…/purchase-label) and leave their default empty here.": "Inserisci entrambe nel suffisso URL finale di ogni account Google Ads (tml=AW-…/lead-label&tm=AW-…/purchase-label) e lascia qui vuoto il loro valore predefinito.",
  "Keys are case-sensitive. Any key (a, b, s, c…) is stored on the click, works as a {key} macro and can be picked as a grouping in Reports and Sub-ID reports, next to sub1…sub30. Map it to a sub slot to line it up across campaigns.": "Le chiavi distinguono maiuscole e minuscole. Qualsiasi chiave (a, b, s, c…) viene salvata sul click, funziona come macro {key} e può essere scelta come raggruppamento in Report e nei report Sub-ID, insieme a sub1…sub30. Mappala su uno slot sub per allinearla tra le campagne.",
  "Use lowercase keys — the tracker does not read:": "Usa chiavi minuscole: il tracker non legge:",
  "Tracking URL preview": "Anteprima URL di tracking",
  "Paste this as Final URL (Google Ads) or tracking link (Facebook). Replace {key} placeholders with real ad-network macros as needed.": "Incolla questo come URL finale (Google Ads) o link di tracking (Facebook). Sostituisci i placeholder {key} con le macro reali del network pubblicitario quando necessario.",
  "Fire Google Ads gtag on redirect": "Attiva gtag di Google Ads al redirect",
  "When on, /r/ returns a tiny HTML page that calls gtag(\"event\",\"conversion\", …) with your simple-mode tag before redirecting. Use this if you do not configure the Final URL suffix on the Google Ads side.": "Quando attivo, /r/ restituisce una piccola pagina HTML che chiama gtag(\"event\",\"conversion\", …) con il tuo tag in modalità semplice prima di reindirizzare. Usalo se non configuri il suffisso URL finale lato Google Ads.",
  "S2S postbacks": "Postback S2S",
  "Outbound HTTP calls fired whenever a conversion postback is received. Supports macros like {click_id}, {payout}, and every campaign parameter declared above.": "Chiamate HTTP in uscita inviate ogni volta che viene ricevuto un postback di conversione. Supporta macro come {click_id}, {payout} e tutti i parametri di campagna dichiarati sopra.",
  "No postbacks yet": "Nessun postback ancora",
  "Method": "Metodo",
  "Statuses": "Stati",
  "Add postback": "Aggiungi postback",
  "Show recent log": "Mostra log recente",
  "Available macros": "Macro disponibili",
  "Campaign saved": "Campagna salvata",
  "Postback fired": "Postback inviato",
  "Mode": "Modalità",
  "Simple": "Semplice",
  "Advanced": "Avanzata",
  "Conversion tag": "Tag di conversione",
  "Conversion tag is required": "Il tag di conversione è obbligatorio",
  "Paste the \"send_to\" value from your Google Ads conversion snippet (e.g. AW-123456789/AbCdEf). No OAuth needed. The tracker stores it and fires it via Final URL suffix or on-redirect gtag.": "Incolla il valore \"send_to\" dallo snippet di conversione di Google Ads (es. AW-123456789/AbCdEf). Non serve OAuth. Il tracker lo salva e lo invia tramite il suffisso dell'URL finale o con gtag al momento del redirect.",
  "OAuth-based Click Conversions Upload — requires developer token, customer ID and a refresh token. Use only if you need server-side uploads with gclid.": "Caricamento delle conversioni da clic basato su OAuth — richiede developer token, customer ID e un refresh token. Usalo solo se ti servono caricamenti lato server con gclid.",
  "Campaign": "Campagna",
  "Create a new xpnsr.tech account": "Crea un nuovo account xpnsr.tech",
  "Already have an account? Sign in": "Hai già un account? Accedi",
  "Only ZIP files are supported": "Sono supportati solo file ZIP",
  "Please enter a name for the landing page": "Inserisci un nome per la landing page",
  "Please select a ZIP file": "Seleziona un file ZIP",
  "Landing page uploaded successfully": "Landing page caricata con successo",
  "Error uploading landing page": "Errore nel caricamento della landing page",
  "Upload ZIP": "Carica ZIP",
  "Upload Landing Page": "Carica landing page",
  "Upload a ZIP file containing your landing page files (max 50MB)": "Carica un file ZIP con i file della tua landing page (max 50MB)",
  "My landing page": "La mia landing page",
  "tag1, tag2, tag3": "tag1, tag2, tag3",
  "Separate tags with commas": "Separa i tag con virgole",
  "ZIP File": "File ZIP",
  "Drag & drop or click to select": "Trascina qui o clicca per selezionare",
  "Select ZIP File": "Seleziona file ZIP",
  "Uploading...": "Caricamento in corso...",
  "Upload": "Carica",
  "History": "Cronologia",
  "Notification settings": "Impostazioni notifiche",
  "Please fill in name and select ZIP file": "Compila il nome e seleziona un file ZIP",
  "Offer uploaded successfully": "Offerta caricata con successo",
  "Error uploading offer": "Errore nel caricamento dell'offerta",
  "Upload Offer ZIP": "Carica ZIP dell'offerta",
  "Upload a ZIP file containing offer files": "Carica un file ZIP con i file dell'offerta",
  "Countries (comma-separated ISO codes, e.g. US,RU,DE)": "Paesi (codici ISO separati da virgola, es. US,RU,DE)",
  "ZIP File (max 100MB)": "File ZIP (max 100MB)",
  "Change": "Cambia",
  "Select ZIP file": "Seleziona file ZIP",
  "Upload a ZIP file containing HTML pages, images, and other assets. Supported: _preview.png for preview, PHP scripts for processing.": "Carica un file ZIP con pagine HTML, immagini e altri file. Supportati: _preview.png per l'anteprima, script PHP per l'elaborazione.",
  "Upload Offer": "Carica offerta",
  "pages": "pagine",
  "Choose entry point": "Scegli il punto di ingresso",
  "Multiple HTML pages detected. Select the main page visitors will land on.": "Rilevate più pagine HTML. Seleziona la pagina principale su cui atterreranno i visitatori.",
  "Skip (use auto-detected)": "Salta (usa quella rilevata automaticamente)",
  "Confirm": "Conferma",
  "Edit files": "Modifica file",
  "File editor": "Editor di file",
  "Edit HTML, CSS, JS and other text files inside the uploaded archive": "Modifica file HTML, CSS, JS e altri file di testo all'interno dell'archivio caricato",
  "Files": "File",
  "Select a file from the sidebar to edit": "Seleziona un file dalla barra laterale per modificarlo",
  "Binary file — not editable": "File binario — non modificabile",
  "File saved": "File salvato",
  "Error loading files": "Errore nel caricamento dei file",
  "Error loading file": "Errore nel caricamento del file",
  "Error saving file": "Errore nel salvataggio del file",
  "Discard unsaved changes?": "Scartare le modifiche non salvate?",
  "Saving...": "Salvataggio in corso...",
  "Bulk create": "Creazione in massa",
  "Bulk create Google Ads forwarders": "Crea forwarder Google Ads in massa",
  "Conversion tags (one per line)": "Tag di conversione (uno per riga)",
  "Paste AW-XXX/YYY tags, one per line. Each creates a separate forwarder.": "Incolla i tag AW-XXX/YYY, uno per riga. Ognuno crea un forwarder separato.",
  "Bind to campaigns": "Collega alle campagne",
  "Leave empty to fire on all campaigns": "Lascia vuoto per attivarlo su tutte le campagne",
  "Add campaign…": "Aggiungi campagna…",
  "Create all": "Crea tutti",
  "Creating…": "Creazione in corso…",
  "{count} forwarders created": "{count} forwarder creati",
  "campaign": "campagna",
  "Linked forwarders": "Forwarder collegati",
  "Conversion forwarders that fire for this campaign": "Forwarder di conversione attivi per questa campagna",
  "Heatmap": "Mappa di calore",
  "Funnel": "Funnel",
  "Activity heatmap": "Mappa di calore dell'attività",
  "Day-of-week x hour-of-day breakdown": "Ripartizione per giorno della settimana e ora del giorno",
  "Less": "Meno",
  "More": "Più",
  "Peak": "Picco",
  "No heatmap data": "Nessun dato per la mappa di calore",
  "Conversion funnel": "Funnel di conversione",
  "Click-to-conversion pipeline with status breakdown": "Pipeline dal click alla conversione con ripartizione per stato",
  "Status breakdown": "Ripartizione per stato",
  "No funnel data": "Nessun dato per il funnel",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mer",
  "Thu": "Gio",
  "Fri": "Ven",
  "Sat": "Sab",
  "Sun": "Dom",
  "Ad-Account Connections": "Connessioni account pubblicitari",
  "Connect FB / Google Ads accounts so cost data is pulled into campaigns automatically.": "Collega gli account FB / Google Ads per importare automaticamente i dati sui costi nelle campagne.",
  "Connect with Facebook": "Connetti con Facebook",
  "Connect with Google Ads": "Connetti con Google Ads",
  "Ad account connected via OAuth": "Account pubblicitario connesso tramite OAuth",
  "OAuth error: ": "Errore OAuth: ",
  "Failed to start OAuth": "Impossibile avviare OAuth",
  "Token refreshed": "Token aggiornato",
  "Refresh failed": "Aggiornamento non riuscito",
  "Refresh token": "Token di aggiornamento",
  "Connect ad account": "Collega account pubblicitario",
  "Tokens are encrypted at rest. Use OAuth buttons above for FB / Google, or enter tokens manually below.": "I token sono criptati a riposo. Usa i pulsanti OAuth sopra per FB / Google, oppure inserisci i token manualmente qui sotto.",
  "Sync now": "Sincronizza ora",
  "Connect": "Connetti",
  "Failed to load connections": "Errore nel caricamento delle connessioni",
  "Connection created": "Connessione creata",
  "Connection deleted": "Connessione eliminata",
  "Delete this connection?": "Eliminare questa connessione?",
  "Delete failed": "Eliminazione non riuscita",
  "Sync complete": "Sincronizzazione completata",
  "Sync failed": "Sincronizzazione non riuscita",
  "No connections yet. Connect FB or Google Ads to start importing cost.": "Nessuna connessione ancora. Collega FB o Google Ads per iniziare a importare i costi.",
  "Refresh token (optional)": "Token di aggiornamento (opzionale)",
  "Display name": "Nome visualizzato",
  "Account ID": "ID account",
  "Access token": "Token di accesso",
  "Save failed": "Salvataggio non riuscito",
  "Permissions": "Permessi",
  "Permission matrix": "Matrice dei permessi",
  "Permission matrix saved": "Matrice dei permessi salvata",
  "Failed to load permission matrix": "Errore nel caricamento della matrice dei permessi",
  "Failed to save permission matrix": "Errore nel salvataggio della matrice dei permessi",
  "Override the minimum role required for each action in this workspace. Only cells that differ from the default are persisted.": "Sostituisci il ruolo minimo richiesto per ogni azione in questo workspace. Vengono salvate solo le celle diverse dal valore predefinito.",
  "overrides": "sostituzioni",
  "Read-only — only the workspace owner can edit the matrix.": "Sola lettura — solo il proprietario del workspace può modificare la matrice.",
  "Reset all to defaults": "Ripristina tutto ai valori predefiniti",
  "Custom": "Personalizzato",
  "Reset to default": "Ripristina al valore predefinito",
  "owner": "proprietario",
  "admin": "admin",
  "manager": "manager",
  "viewer": "visualizzatore",
  "Landings & offers": "Landing page e offerte",
  "Reports": "Report",
  "Audit": "Audit",
  "Toggle navigation hints": "Attiva/disattiva suggerimenti di navigazione",
  "Show hints": "Mostra suggerimenti",
  "Hide hints": "Nascondi suggerimenti",
  "Tools": "Strumenti",
  "Admin": "Amministratore",
  "Resources": "Risorse",
  "Pre-landings": "Prelander",
  "Book demo": "Prenota demo",
  "Overview of clicks, conversions and active campaigns": "Schermata principale: riepilogo di click, conversioni e campagne attive",
  "Create ad campaigns and get tracking links": "Crea campagne pubblicitarie e ottieni link di tracciamento",
  "Upload landing pages (ZIP) or set a URL for split-tests": "Carica landing page (ZIP) o imposta un URL per gli split-test",
  "Warm-up pages shown before the offer": "Prelander mostrate prima dell'offerta per scaldare il traffico",
  "Connect Facebook, Google, TikTok ad accounts": "Collega gli account pubblicitari Facebook, Google, TikTok",
  "Two-factor auth, sessions and password": "Autenticazione a due fattori, sessioni e password",
  "Uploaded offers/funnels + API routing to partners (weights, failover) + lead forms": "Offerte/funnel caricati + instradamento API verso i partner (pesi, failover) + moduli lead",
  "Traffic sources with presets (Google Ads with tm & macros, etc.)": "Sorgenti di traffico con preset (Google Ads con tm e macro, ecc.)",
  "Manage flows and traffic distribution rules": "Gestisci stream e regole di distribuzione del traffico",
  "Split-test landings and offers with auto-distribution": "Split-test di landing page e offerte con distribuzione automatica",
  "Block bots, fraud and suspicious clicks": "Blocca bot, frodi e click sospetti",
  "Detailed reports: charts, geo, devices, ROI": "Report dettagliati: grafici, GEO, dispositivi, ROI",
  "Full click log with IP, UserAgent, GEO and time": "Log completo dei click con IP, UserAgent, GEO e orario",
  "Auto-rules: pause campaigns on low ROI, etc.": "Regole automatiche: metti in pausa le campagne con ROI basso, ecc.",
  "Partner CRMs (TrackBox, Custom API) for API lead injection + notifications": "CRM dei partner (TrackBox, Custom API) per l'invio dei lead via API + notifiche",
  "Add your own domains for tracking links": "Aggiungi i tuoi domini per i link di tracciamento",
  "Online conversions to Google/FB/TikTok (S2S). Google — simple, no OAuth": "Conversioni online verso Google/FB/TikTok (S2S). Google — modalità semplice, senza OAuth",
  "Keys to access the tracker REST API": "Chiavi per accedere alla REST API del tracker",
  "Invite your team, assign roles and permissions": "Invita il tuo team, assegna ruoli e permessi",
  "Action log of all users for 90 days": "Log delle azioni di tutti gli utenti per 90 giorni",
  "Cookie consent banner for GDPR compliance": "Banner di consenso cookie per la conformità GDPR",
  "Ready-made templates and integrations": "Template e integrazioni pronti all'uso",
  "Swagger REST API docs (opens in new tab)": "Documentazione Swagger della REST API (si apre in una nuova scheda)",
  "Failed conversion dispatches — can be retried": "Invii di conversione falliti — puoi riprovare",
  "Server, queue and database status": "Stato di server, code e database",
  "Plan, payment and usage limits": "Piano, pagamento e limiti di utilizzo",
  "Profile, language, timezone and notifications": "Profilo, lingua, fuso orario e notifiche",
  "(no label)": "(nessuna etichetta)",
  "180 days": "180 giorni",
  "2FA disabled": "2FA disattivata",
  "2FA enabled": "2FA attivata",
  "2FA is currently enabled": "La 2FA è attualmente attiva",
  "302 redirect (default)": "Redirect 302 (predefinito)",
  "365 days": "365 giorni",
  "A campaign groups your traffic sources and tracking links under one name.": "Una campagna raggruppa le tue sorgenti di traffico e i link di tracciamento sotto un unico nome.",
  "AI Optimizer": "Ottimizzatore IA",
  "Accept button label": "Testo del pulsante Accetta",
  "Accepted": "Accettato",
  "Accepting invitation…": "Accettazione invito in corso…",
  "Action on trigger": "Azione al trigger",
  "Activate": "Attiva",
  "Activate 2FA": "Attiva la 2FA",
  "Add a forwarder to push conversions to ad networks automatically.": "Aggiungi un forwarder per inviare automaticamente le conversioni ai network pubblicitari.",
  "Add forwarder": "Aggiungi forwarder",
  "Add the CNAME record shown on the Domains page, then click verify.": "Aggiungi il record CNAME mostrato nella pagina Domini, poi clicca su verifica.",
  "Add vendor": "Aggiungi fornitore",
  "Aggressive: blocks any click whose JA3/JA4 is missing or not yet classified. Tag corporate-proxy hashes first via Workspace Overrides.": "Aggressivo: blocca qualsiasi clic il cui JA3/JA4 sia mancante o non ancora classificato. Prima etichetta gli hash dei proxy aziendali tramite le sostituzioni dell'area di lavoro.",
  "Alert if ROI drops below this %": "Avvisa se il ROI scende sotto questa %",
  "Algorithm": "Algoritmo",
  "All groups": "Tutti i gruppi",
  "All statuses": "Tutti gli stati",
  "Allowed metrics": "Metriche consentite",
  "Always block these JA3 / JA4 hashes regardless of classification.": "Blocca sempre questi hash JA3 / JA4, indipendentemente dalla classificazione.",
  "Anonymous": "Anonimo",
  "Any type": "Qualsiasi tipo",
  "Anyone with this link will lose access to the shared dashboard immediately.": "Chiunque abbia questo link perderà immediatamente l'accesso alla dashboard condivisa.",
  "Applied {n} weight changes": "Applicate {n} modifiche al peso",
  "Archive": "Archivia",
  "Archived": "Archiviato",
  "Auto": "Auto",
  "Auto-refresh every 30s": "Aggiornamento automatico ogni 30s",
  "Available on enterprise plans. Hides the \"Powered by xpnsr\" footer.": "Disponibile nei piani enterprise. Nasconde il piè di pagina \"Powered by xpnsr\".",
  "Back to sign-in": "Torna al login",
  "Backup codes (save now)": "Codici di backup (salvali ora)",
  "Bangkok (UTC+7)": "Bangkok (UTC+7)",
  "Banned": "Bannato",
  "Banner copy": "Testo del banner",
  "Banner status": "Stato del banner",
  "Berlin (UTC+1)": "Berlino (UTC+1)",
  "Best cohort": "Miglior coorte",
  "Block classification": "Classificazione da bloccare",
  "Block fingerprints classified as bad": "Blocca le fingerprint classificate come dannose",
  "Block unknown fingerprints": "Blocca le fingerprint sconosciute",
  "Block when the blended TLS+UA+IP risk score exceeds this threshold. Default 0.7.": "Blocca quando il punteggio di rischio combinato TLS+UA+IP supera questa soglia. Predefinito 0.7.",
  "Body": "Corpo",
  "Body (JSON)": "Corpo (JSON)",
  "Body copied to clipboard.": "Corpo copiato negli appunti.",
  "Body must be valid JSON.": "Il corpo deve essere JSON valido.",
  "Branding": "Branding",
  "Branding cleared": "Branding ripristinato",
  "Branding saved": "Branding salvato",
  "Break down clicks and conversions by sub-ID parameters (sub1–sub15)": "Suddividi clic e conversioni per parametri sub-ID (sub1–sub15)",
  "Browse and install community-contributed templates for postbacks, macros, anti-fraud rules, and pre-landings. Submissions auto-publish — the community self-polices via the delete action.": "Sfoglia e installa template contribuiti dalla community per postback, macro, regole antifrode e pre-landing. Gli invii vengono pubblicati automaticamente — la community si autoregola tramite l'azione di eliminazione.",
  "Browser": "Browser",
  "Build traffic rules, rotate landings and split-test offers for any campaign.": "Crea regole di traffico, ruota le landing page e fai split-test delle offerte per qualsiasi campagna.",
  "Bundle verified domains into a pool and rotate tracking links across them. Pull a banned domain out of rotation in one click without redeploying ad copies.": "Raggruppa i domini verificati in un pool e ruota i link di tracciamento tra di essi. Rimuovi un dominio bannato dalla rotazione con un clic, senza dover ripubblicare gli annunci.",
  "By browser": "Per browser",
  "By device": "Per dispositivo",
  "By {author}": "Di {author}",
  "CR %": "CR %",
  "CR%": "CR%",
  "Campaign ID": "ID campagna",
  "Campaign activated": "Campagna attivata",
  "Campaign archived": "Campagna archiviata",
  "Campaign cloned successfully!": "Campagna clonata con successo!",
  "Campaign comparison": "Confronto campagne",
  "Campaign created": "Campagna creata",
  "Campaign dashboard": "Dashboard della campagna",
  "Campaign restored": "Campagna ripristinata",
  "Cap": "Cap",
  "Cap timezone": "Fuso orario del cap",
  "Catalog": "Catalogo",
  "Chicago (UTC-6)": "Chicago (UTC-6)",
  "Choose a preset and optionally extend it with extra ISO-3166 country codes (comma-separated, e.g. BR, MX, AR).": "Scegli un preset e, se vuoi, estendilo con codici paese ISO-3166 aggiuntivi (separati da virgola, es. BR, MX, AR).",
  "Clear": "Cancella",
  "Click ID forward parameter": "Parametro di inoltro del click ID",
  "Click detail": "Dettaglio clic",
  "Click to activate": "Clicca per attivare",
  "Click to pause": "Clicca per mettere in pausa",
  "Clicks log": "Registro dei clic",
  "Clipboard unavailable — copy the URL manually": "Appunti non disponibili — copia l'URL manualmente",
  "Cloaked (iframe)": "Cloaked (iframe)",
  "Cloaked iframe keeps the tracker domain in the address bar — only works for destinations that allow framing.": "L'iframe cloaked mantiene il dominio del tracker nella barra degli indirizzi — funziona solo con destinazioni che consentono il framing.",
  "Clone": "Clona",
  "Close navigation": "Chiudi navigazione",
  "Cohort": "Coorte",
  "Cohort retention": "Retention per coorte",
  "Comma-separated list of IPs allowed to send postbacks. Leave empty to allow all.": "Elenco di IP separati da virgola autorizzati a inviare postback. Lascia vuoto per consentirli tutti.",
  "Compare": "Confronta",
  "Compare current to proposed weights. Apply persists the proposed column to the streams.": "Confronta i pesi attuali con quelli proposti. Applica salva la colonna proposta sugli stream.",
  "Comparing…": "Confronto in corso…",
  "Compliance": "Conformità",
  "Configure UTM templates and conversion postbacks for every ad network you run.": "Configura i template UTM e i postback di conversione per ogni network pubblicitario che utilizzi.",
  "Configure offers, payouts and target geos. Upload ZIPs or link external networks.": "Configura offerte, payout e GEO target. Carica ZIP o collega network esterni.",
  "Configure stream": "Configura stream",
  "Configure the GDPR / CCPA cookie banner that runs on your tracker landing pages. The banner is region-aware — visitors outside the configured regions never see it.": "Configura il banner cookie GDPR / CCPA attivo sulle landing page del tuo tracker. Il banner riconosce la regione — i visitatori al di fuori delle regioni configurate non lo vedranno mai.",
  "Confirm action": "Conferma azione",
  "Connect external services and webhooks": "Collega servizi esterni e webhook",
  "Connect external services and webhooks to automate workflows.": "Collega servizi esterni e webhook per automatizzare i flussi di lavoro.",
  "Connection restored": "Connessione ripristinata",
  "Connections": "Connessioni",
  "Consent banner": "Banner di consenso",
  "Consent banner saved": "Banner di consenso salvato",
  "Conv": "Conv",
  "Conv.": "Conv.",
  "Conversion rate comparison": "Confronto tasso di conversione",
  "Cookieless mode (skip xpnsr_vid first-party cookie)": "Modalità cookieless (salta il cookie first-party xpnsr_vid)",
  "Copied to clipboard.": "Copiato negli appunti.",
  "Copy link (/r/)": "Copia link (/r/)",
  "Copy link (/{alias}/)": "Copia link (/{alias}/)",
  "Cost": "Costo",
  "Cost value": "Valore del costo",
  "Could not accept invitation": "Impossibile accettare l'invito",
  "Could not copy — please copy the link manually.": "Impossibile copiare — copia il link manualmente.",
  "Could not create public link": "Impossibile creare il link pubblico",
  "Could not load branding": "Impossibile caricare il branding",
  "Could not load marketplace templates.": "Impossibile caricare i template del marketplace.",
  "Could not load template detail.": "Impossibile caricare il dettaglio del template.",
  "Could not load the shared dashboard.": "Impossibile caricare la dashboard condivisa.",
  "Could not reset branding": "Impossibile ripristinare il branding",
  "Could not save branding": "Impossibile salvare il branding",
  "Country (ISO-2)": "Paese (ISO-2)",
  "Create a campaign first": "Crea prima una campagna",
  "Create key": "Crea chiave",
  "Create landing page": "Crea landing page",
  "Create link": "Crea link",
  "Create new landing page": "Crea nuova landing page",
  "Create new offer": "Crea nuova offerta",
  "Create offer": "Crea offerta",
  "Create pool": "Crea pool",
  "Custom domain": "Dominio personalizzato",
  "Custom range": "Intervallo personalizzato",
  "Customise the dashboard for your agency or sub-account": "Personalizza la dashboard per la tua agenzia o sub-account",
  "Daily cap": "Cap giornaliero",
  "Dashboard hostname": "Hostname della dashboard",
  "Decision": "Decisione",
  "Default offer URL": "URL predefinito dell'offerta",
  "Defense": "Difesa",
  "Delete A/B test": "Elimina test A/B",
  "Delete API key": "Elimina chiave API",
  "Delete automation rule": "Elimina regola di automazione",
  "Delete campaign": "Elimina campagna",
  "Delete campaigns": "Elimina campagne",
  "Delete connection": "Elimina connessione",
  "Delete domain": "Elimina dominio",
  "Delete domain pool": "Elimina pool di domini",
  "Delete failed.": "Eliminazione non riuscita.",
  "Delete forwarder": "Elimina forwarder",
  "Delete integration": "Elimina integrazione",
  "Delete landing page": "Elimina landing page",
  "Delete offer": "Elimina offerta",
  "Delete pre-landing": "Elimina prelander",
  "Delete stream": "Elimina stream",
  "Delete traffic source": "Elimina sorgente di traffico",
  "Delete webhook": "Elimina webhook",
  "Delete {n} selected campaign(s)? This cannot be undone.": "Eliminare {n} campagna/e selezionata/e? L'operazione non può essere annullata.",
  "Denver (UTC-7)": "Denver (UTC-7)",
  "Deselect all": "Deseleziona tutto",
  "Device": "Dispositivo",
  "Disable 2FA": "Disattiva 2FA",
  "Disable 2FA — enter a current code": "Disattiva 2FA — inserisci un codice attuale",
  "Disable auto-refresh": "Disattiva l'aggiornamento automatico",
  "Disable failed": "Disattivazione non riuscita",
  "Disabled": "Disattivato",
  "Discard DLQ entry": "Scarta voce DLQ",
  "Dismissed": "Ignorato",
  "Do not block by classification": "Non bloccare per classificazione",
  "Domain marked healthy": "Dominio contrassegnato come sano",
  "Domain not verified yet — check the DNS record.": "Dominio non ancora verificato — controlla il record DNS.",
  "Domain pool created": "Pool di domini creato",
  "Domain pool deleted": "Pool di domini eliminato",
  "Domain pools": "Pool di domini",
  "Domain pulled from rotation": "Dominio rimosso dalla rotazione",
  "Domain registered. Add the DNS record, then verify.": "Dominio registrato. Aggiungi il record DNS, poi verifica.",
  "Done": "Fatto",
  "Dubai (UTC+4)": "Dubai (UTC+4)",
  "EPC": "EPC",
  "Each row is a day's first-time visitors. Columns track cumulative conversion rate by day-offset.": "Ogni riga rappresenta i visitatori al primo accesso di un giorno. Le colonne mostrano il tasso di conversione cumulativo per scarto di giorni.",
  "Earnings per click": "Guadagno per clic",
  "Edit pre-landing": "Modifica prelander",
  "Enable 2FA": "Attiva 2FA",
  "Enabled": "Attivato",
  "Enter a code from the app to confirm": "Inserisci un codice dall'app per confermare",
  "Enter a hostname": "Inserisci un hostname",
  "Enter an offer URL": "Inserisci l'URL dell'offerta",
  "Enter the 6-digit code from your authenticator app, or one of your backup codes.": "Inserisci il codice a 6 cifre dalla tua app di autenticazione, oppure uno dei tuoi codici di backup.",
  "Epsilon (ε)": "Epsilon (ε)",
  "Error archiving campaign": "Errore durante l'archiviazione della campagna",
  "Error cloning campaign": "Errore durante la clonazione della campagna",
  "Expires": "Scade",
  "Expires after (days)": "Scade dopo (giorni)",
  "Explicit blocked fingerprints (comma-separated)": "Fingerprint bloccati espliciti (separati da virgola)",
  "Export JSON": "Esporta JSON",
  "Export XLSX": "Esporta XLSX",
  "Extra countries (ISO-3166 alpha-2)": "Paesi aggiuntivi (ISO-3166 alpha-2)",
  "Failed to accept invite": "Impossibile accettare l'invito",
  "Failed to apply optimization": "Impossibile applicare l'ottimizzazione",
  "Failed to compare": "Impossibile confrontare",
  "Failed to copy tracking link": "Impossibile copiare il link di tracking",
  "Failed to create campaign": "Impossibile creare la campagna",
  "Failed to create pool": "Impossibile creare il pool",
  "Failed to delete key": "Impossibile eliminare la chiave",
  "Failed to load campaigns": "Impossibile caricare le campagne",
  "Failed to load clicks log": "Impossibile caricare il log dei clic",
  "Failed to load consent config": "Impossibile caricare la configurazione del consenso",
  "Failed to load conversions": "Impossibile caricare le conversioni",
  "Failed to load pre-landings": "Impossibile caricare i prelander",
  "Failed to load profile": "Impossibile caricare il profilo",
  "Failed to load sub-ID report": "Impossibile caricare il report per sub ID",
  "Failed to preview optimization": "Impossibile visualizzare l'anteprima dell'ottimizzazione",
  "Failed to register domain": "Impossibile registrare il dominio",
  "Failed to revoke access": "Impossibile revocare l'accesso",
  "Failed to save": "Impossibile salvare",
  "Failed to update status": "Impossibile aggiornare lo stato",
  "Fallback offer": "Offerta di riserva",
  "Filter junk traffic, block malicious IPs and review suspicious activity in one place.": "Filtra il traffico spazzatura, blocca gli IP malevoli e rivedi l'attività sospetta in un unico posto.",
  "From (ISO-8601)": "Da (ISO-8601)",
  "GDPR: pseudonymize visitor IPs (hash before storage)": "GDPR: pseudonimizza gli IP dei visitatori (hash prima della memorizzazione)",
  "Generate a key to call the public REST API.": "Genera una chiave per chiamare l'API REST pubblica.",
  "Go back": "Torna indietro",
  "Go to Workspace": "Vai allo Spazio di lavoro",
  "Group (optional)": "Gruppo (opzionale)",
  "Group by:": "Raggruppa per:",
  "Healthy": "Sano",
  "Hide xpnsr branding": "Nascondi il branding xpnsr",
  "Hosted pages and uploads": "Pagine hosted e file caricati",
  "Hostname": "Hostname",
  "Install": "Installa",
  "Install failed.": "Installazione non riuscita.",
  "Invalid 2FA code": "Codice 2FA non valido",
  "Invalid SSO session": "Sessione SSO non valida",
  "Invitation accepted!": "Invito accettato!",
  "JS redirect (location.replace)": "Redirect JS (location.replace)",
  "Keyboard shortcuts": "Scorciatoie da tastiera",
  "Keyboard shortcuts (?)": "Scorciatoie da tastiera (?)",
  "Keyword exclude": "Esclusione parole chiave",
  "Keyword include": "Inclusione parole chiave",
  "Label (operator-only)": "Etichetta (solo operatore)",
  "Last 200 consent records in this workspace. Used as the audit trail for DSAR / regulator inquiries.": "Ultimi 200 record di consenso in questo workspace. Usati come traccia di audit per richieste DSAR / autorità di controllo.",
  "Last viewed": "Visualizzato l'ultima volta",
  "Layout": "Layout",
  "Layout & retention": "Layout e conservazione",
  "Live": "Live",
  "Live KPIs and breakdowns across campaigns, geos, devices.": "KPI live e suddivisioni per campagne, GEO e dispositivi.",
  "Loading marketplace…": "Caricamento marketplace…",
  "Loading...": "Caricamento...",
  "Login page subtitle": "Sottotitolo pagina di accesso",
  "Logo URL": "URL del logo",
  "London (UTC+0)": "Londra (UTC+0)",
  "Lookback (days)": "Lookback (giorni)",
  "Los Angeles (UTC-8)": "Los Angeles (UTC-8)",
  "Make sure your tracking URLs include {key}=... parameter": "Assicurati che i tuoi URL di tracking includano il parametro {key}=...",
  "Manage profile, preferences, notifications and system configuration.": "Gestisci profilo, preferenze, notifiche e configurazione di sistema.",
  "Manage your offers and creatives": "Gestisci le tue offerte e i creativi",
  "Manual entry secret": "Secret per l'inserimento manuale",
  "Mark all read": "Segna tutto come letto",
  "Mark read": "Segna come letto",
  "Marketplace": "Marketplace",
  "Match if referrer/params contain a keyword": "Corrisponde se il referrer/i parametri contengono una parola chiave",
  "Meta refresh": "Meta refresh",
  "Metric": "Metrica",
  "Min clicks per stream": "Click minimi per stream",
  "Minimum ROI (%)": "ROI minimo (%)",
  "Missing SSO session token": "Token di sessione SSO mancante",
  "Missing invite token": "Token di invito mancante",
  "Most clicks": "Più click",
  "Most revenue": "Più ricavi",
  "Mumbai (UTC+5:30)": "Mumbai (UTC+5:30)",
  "Must be an https:// URL. Leave blank to fall back to the xpnsr logo.": "Deve essere un URL https://. Lascia vuoto per usare il logo di xpnsr.",
  "Name A→Z": "Nome A→Z",
  "Name Z→A": "Nome Z→A",
  "Name and target URL are required": "Nome e URL di destinazione sono obbligatori",
  "Name is required.": "Il nome è obbligatorio.",
  "New": "Nuovo",
  "New pre-landing": "Nuova pre-landing",
  "New public dashboard link": "Nuovo link pubblico alla dashboard",
  "Newest first": "Più recenti prima",
  "Next": "Avanti",
  "No active streams to optimize.": "Nessuno stream attivo da ottimizzare.",
  "No clicks match these filters.": "Nessun click corrisponde a questi filtri.",
  "No cohort data": "Nessun dato di coorte",
  "No consent records yet.": "Ancora nessun record di consenso.",
  "No conversions yet": "Ancora nessuna conversione",
  "No data found for {key}": "Nessun dato trovato per {key}",
  "No data yet.": "Ancora nessun dato.",
  "No description provided.": "Nessuna descrizione fornita.",
  "No internet connection": "Nessuna connessione a internet",
  "No notifications yet": "Ancora nessuna notifica",
  "No performance data yet": "Ancora nessun dato di performance",
  "No pre-landings yet. Create one to start chaining traffic.": "Ancora nessuna pre-landing. Creane una per iniziare a concatenare il traffico.",
  "No public links yet. Create one to share read-only stats with advertisers.": "Ancora nessun link pubblico. Creane uno per condividere statistiche in sola lettura con gli inserzionisti.",
  "No results.": "Nessun risultato.",
  "No templates match these filters.": "Nessun template corrisponde a questi filtri.",
  "No vendors disclosed.": "Nessun fornitore dichiarato.",
  "No verified custom domains. Add one in Domains → Settings.": "Nessun dominio personalizzato verificato. Aggiungine uno in Domini → Impostazioni.",
  "None": "Nessuno",
  "Notify only": "Solo notifica",
  "Oldest first": "Meno recenti prima",
  "Onboarding complete!": "Onboarding completato!",
  "Only match if referrer contains one of these": "Corrisponde solo se il referrer contiene uno di questi",
  "Open Campaigns": "Apri Campagne",
  "Open Domains page": "Apri la pagina Domini",
  "Open command palette": "Apri la command palette",
  "Open landing pages": "Apri le landing page",
  "Open my tracking link": "Apri il mio link di tracking",
  "Operators host the static page; the tracker just routes clicks here first.": "Gli operatori ospitano la pagina statica; il tracker si limita a instradare qui i click per primi.",
  "Optimization": "Ottimizzazione",
  "Optional": "Facoltativo",
  "Pages library": "Libreria delle pagine",
  "Parameter name, e.g. sub1": "Nome del parametro, es. sub1",
  "Pause": "Metti in pausa",
  "Performance": "Performance",
  "Performance overview": "Panoramica performance",
  "Permanently discard this dead-letter entry? This cannot be undone.": "Vuoi eliminare definitivamente questa voce dead-letter? L'azione non può essere annullata.",
  "Please sign in first, then open the invite link again.": "Accedi prima, poi riapri il link di invito.",
  "Please wait…": "Attendi…",
  "Point this hostname at the tracker via DNS. Visitors hitting it will see your branding before they sign in.": "Punta questo hostname al tracker tramite DNS. I visitatori che lo raggiungono vedranno il tuo branding prima di accedere.",
  "Pool name": "Nome del pool",
  "Postback IP whitelist": "Whitelist IP per i postback",
  "Pre-Landings": "Pre-Landing",
  "Pre-landing created": "Prelander creata",
  "Pre-landing deleted": "Prelander eliminata",
  "Pre-landing updated": "Prelander aggiornata",
  "Pre-landings give you a faster, more compliant entry page before sending visitors to the offer. You can add one any time.": "I prelander ti offrono una pagina d'ingresso più veloce e conforme prima di inviare i visitatori all'offerta. Puoi aggiungerne uno in qualsiasi momento.",
  "Preview": "Anteprima",
  "Previous": "Precedente",
  "Primary colour": "Colore primario",
  "Privacy policy URL": "URL dell'informativa sulla privacy",
  "Products": "Prodotti",
  "Proposed": "Proposto",
  "Proposed drift": "Drift proposto",
  "Proposed weights": "Pesi proposti",
  "Protect your account with a TOTP code from an authenticator app. Backup codes let you log in if you lose your device.": "Proteggi il tuo account con un codice TOTP generato da un'app di autenticazione. I codici di backup ti permettono di accedere se perdi il dispositivo.",
  "Public link created — copy it now, it won't be shown again.": "Link pubblico creato — copialo subito, non verrà mostrato di nuovo.",
  "Public link revoked.": "Link pubblico revocato.",
  "Public read-only links": "Link pubblici in sola lettura",
  "Publish": "Pubblica",
  "Publishing…": "Pubblicazione…",
  "Pull out of rotation": "Rimuovi dalla rotazione",
  "Purpose (e.g. Analytics)": "Scopo (es. Analytics)",
  "Quick start from template": "Avvio rapido da modello",
  "Quiz / review / bonus pages that intercept the click before the final landing or offer.": "Pagine quiz / recensione / bonus che intercettano il click prima della landing page finale o dell'offerta.",
  "ROI": "ROI",
  "ROI alert": "Avviso ROI",
  "Random seed (optional)": "Seed casuale (facoltativo)",
  "Read-only public view — generated by xpnsr-tracker.": "Vista pubblica in sola lettura — generata da xpnsr-tracker.",
  "Rebalance stream weights based on historical conversion rate using a multi-armed bandit.": "Ribilancia i pesi degli stream in base al tasso di conversione storico usando un multi-armed bandit.",
  "Recent decisions": "Decisioni recenti",
  "Record retention (days)": "Conservazione dei record (giorni)",
  "Redirect method": "Metodo di redirect",
  "Redirect mode": "Modalità di redirect",
  "Referrer / Keyword filters": "Filtri referrer / parola chiave",
  "Referrer exclude": "Escludi referrer",
  "Referrer include": "Includi referrer",
  "Region preset": "Preset di regione",
  "Region scope": "Ambito regionale",
  "Register a custom hostname so your tracking links resolve under your own brand.": "Registra un hostname personalizzato in modo che i tuoi link di tracking risolvano sotto il tuo stesso brand.",
  "Register hostname": "Registra hostname",
  "Reject button label": "Etichetta del pulsante di rifiuto",
  "Rejected": "Rifiutato",
  "Remove": "Rimuovi",
  "Remove template": "Rimuovi modello",
  "Remove this template? This cannot be undone.": "Vuoi rimuovere questo modello? L'azione non può essere annullata.",
  "Reset branding": "Ripristina branding",
  "Reset to defaults": "Ripristina valori predefiniti",
  "Resetting…": "Ripristino in corso…",
  "Restore": "Ripristina",
  "Restore to rotation": "Ripristina in rotazione",
  "Return on investment": "Ritorno sull'investimento",
  "Rev.": "Ric.",
  "Revenue comparison": "Confronto ricavi",
  "Revoke": "Revoca",
  "Revoke failed": "Revoca non riuscita",
  "Revoke public link": "Revoca link pubblico",
  "Risk score threshold (0.0 – 1.0)": "Soglia del punteggio di rischio (0.0 – 1.0)",
  "Round robin": "Round robin",
  "Routing": "Routing",
  "Row-level drill-down into incoming clicks: country, device, stream, and variant.": "Analisi dettagliata riga per riga dei click in entrata: paese, dispositivo, stream e variante.",
  "Run a preview to see proposed weights.": "Esegui un'anteprima per vedere i pesi proposti.",
  "SSO failed": "SSO non riuscito",
  "SSO is not configured": "SSO non configurato",
  "SSO sign-in failed": "Accesso SSO non riuscito",
  "Save branding": "Salva branding",
  "Scan the QR code with your authenticator app": "Scansiona il codice QR con la tua app di autenticazione",
  "Search": "Cerca",
  "Search by name, description, or slug. Filter by type or tag.": "Cerca per nome, descrizione o slug. Filtra per tipo o tag.",
  "Search…": "Cerca…",
  "Secondary colour": "Colore secondario",
  "Select all": "Seleziona tutto",
  "Select at least 2 campaigns": "Seleziona almeno 2 campagne",
  "Select campaigns (2–10)": "Seleziona campagne (2–10)",
  "Sending…": "Invio in corso…",
  "Set up rules, notifications and triggered actions for your campaigns.": "Configura regole, notifiche e azioni automatiche per le tue campagne.",
  "Set up your tracker": "Configura il tuo tracker",
  "Setup failed": "Configurazione non riuscita",
  "Share a token-gated dashboard URL with advertisers without giving them an account.": "Condividi con gli inserzionisti una URL della dashboard protetta da token, senza creare un account.",
  "Shareable URL": "URL condivisibile",
  "Shared dashboard": "Dashboard condivisa",
  "Side-by-side metrics for selected campaigns": "Metriche a confronto per le campagne selezionate",
  "Sign in with Google": "Accedi con Google",
  "Sign in with Microsoft": "Accedi con Microsoft",
  "Singapore (UTC+8)": "Singapore (UTC+8)",
  "Size": "Dimensione",
  "Skip for now": "Salta per ora",
  "Skip if referrer contains one of these": "Salta se il referrer contiene uno di questi",
  "Skip if referrer/params contain a keyword": "Salta se referrer/parametri contengono una parola chiave",
  "Skip this step until you have a campaign — you can finish setup from the Campaigns page.": "Salta questo passaggio finché non hai una campagna — potrai completare la configurazione dalla pagina Campagne.",
  "Skipped (below min_clicks_per_stream)": "Saltato (sotto min_clicks_per_stream)",
  "Smoothed CR": "CR smussato",
  "Sort by": "Ordina per",
  "Split traffic across variants to find what converts best.": "Dividi il traffico tra le varianti per scoprire quale converte meglio.",
  "Step {step} of {total}": "Passaggio {step} di {total}",
  "Sticky (per-visitor)": "Persistente (per visitatore)",
  "Stream": "Stream",
  "Stream ID": "ID dello stream",
  "Stream configured": "Stream configurato",
  "Streams decide which offer each visitor lands on. Configure your default stream and you\\'ll have a working tracking link.": "Gli stream decidono su quale offerta atterra ogni visitatore. Configura il tuo stream predefinito e avrai un link di tracciamento funzionante.",
  "Sub-ID drill-down": "Analisi dettagliata per Sub ID",
  "Submission failed.": "Invio non riuscito.",
  "Submissions auto-publish. The slug is derived from the name; if it collides with an existing template, a numeric suffix is appended.": "Gli invii vengono pubblicati automaticamente. Lo slug deriva dal nome; se coincide con un modello esistente, viene aggiunto un suffisso numerico.",
  "Submit a template": "Invia un modello",
  "Submit template": "Invia modello",
  "Sydney (UTC+11)": "Sydney (UTC+11)",
  "São Paulo (UTC-3)": "San Paolo (UTC-3)",
  "TLS fingerprint (JA3 / JA4)": "Impronta TLS (JA3 / JA4)",
  "Tags (comma-separated)": "Tag (separati da virgola)",
  "Tags:": "Tag:",
  "Template": "Modello",
  "Template body copied to clipboard.": "Corpo del modello copiato negli appunti.",
  "Template installed. Body shown in detail dialog.": "Modello installato. Il corpo è mostrato nella finestra dei dettagli.",
  "Template marketplace": "Marketplace dei modelli",
  "Template published as {slug}.": "Modello pubblicato come {slug}.",
  "Template removed.": "Modello rimosso.",
  "The token will only be shown once after creation — copy it immediately.": "Il token verrà mostrato una sola volta dopo la creazione — copialo subito.",
  "Third-party processors disclosed to the visitor (max 50).": "Elaboratori terzi dichiarati al visitatore (max 50).",
  "This link is unauthenticated. Anyone with it can view the selected metrics until it expires or is revoked.": "Questo link non richiede autenticazione. Chiunque lo possieda può visualizzare le metriche selezionate finché non scade o viene revocato.",
  "This member will lose access to this workspace immediately.": "Questo membro perderà l'accesso a questo workspace immediatamente.",
  "This shared link has expired or been revoked.": "Questo link condiviso è scaduto o è stato revocato.",
  "This shared link is not valid.": "Questo link condiviso non è valido.",
  "This will permanently delete \"{name}\" and all associated clicks, conversions and postback events. This cannot be undone.": "Questo eliminerà definitivamente \"{name}\" e tutti i click, le conversioni e gli eventi di postback associati. Questa azione non può essere annullata.",
  "This will permanently delete \"{name}\" and all its variants.": "Questo eliminerà definitivamente \"{name}\" e tutte le sue varianti.",
  "This will permanently delete \"{name}\" and remove it from all campaigns.": "Questo eliminerà definitivamente \"{name}\" e lo rimuoverà da tutte le campagne.",
  "This will permanently delete \"{name}\".": "Questo eliminerà definitivamente \"{name}\".",
  "This will permanently delete \"{name}\". Campaigns using this domain will fall back to the default domain.": "Questo eliminerà definitivamente \"{name}\". Le campagne che usano questo dominio torneranno al dominio predefinito.",
  "This will permanently delete \"{name}\". Campaigns using this source will lose their tracking parameters.": "Questo eliminerà definitivamente \"{name}\". Le campagne che usano questa sorgente di traffico perderanno i loro parametri di tracking.",
  "This will permanently delete pool \"{name}\".": "Questo eliminerà definitivamente il pool \"{name}\".",
  "This will permanently delete rule \"{name}\".": "Questo eliminerà definitivamente la regola \"{name}\".",
  "This will permanently delete stream \"{name}\".": "Questo eliminerà definitivamente lo stream \"{name}\".",
  "This will permanently delete this ad account connection. Cost syncing will stop.": "Questo eliminerà definitivamente questa connessione all'account pubblicitario. La sincronizzazione dei costi si interromperà.",
  "This will permanently delete this conversion forwarder.": "Questo eliminerà definitivamente questo inoltro di conversioni.",
  "This will permanently delete webhook \"{name}\". Events will no longer be forwarded.": "Questo eliminerà definitivamente il webhook \"{name}\". Gli eventi non verranno più inoltrati.",
  "This will permanently revoke this API key. Any integrations using it will stop working.": "Questo revocherà definitivamente questa chiave API. Le integrazioni che la usano smetteranno di funzionare.",
  "This will reset all branding settings to defaults. Logo, colors, and custom domain will be removed.": "Questo ripristinerà tutte le impostazioni di branding ai valori predefiniti. Logo, colori e dominio personalizzato verranno rimossi.",
  "This will reset two-factor authentication for this member. They will need to re-enrol.": "Questo ripristinerà l'autenticazione a due fattori per questo membro. Dovrà configurarla di nuovo.",
  "Title": "Titolo",
  "Title, body, and button labels shown to the visitor.": "Titolo, testo e etichette dei pulsanti mostrati al visitatore.",
  "To (ISO-8601)": "A (ISO-8601)",
  "Toggle navigation": "Attiva/disattiva navigazione",
  "Tokyo (UTC+9)": "Tokyo (UTC+9)",
  "Too many requests — please retry in a moment.": "Troppe richieste — riprova tra un momento.",
  "Track click usage and switch plans. Billing renews monthly.": "Monitora l'utilizzo dei click e cambia piano. La fatturazione si rinnova mensilmente.",
  "Tracking domain": "Dominio di tracking",
  "Tracking link copied to clipboard": "Link di tracking copiato negli appunti",
  "Tune the bandit before running a preview. Apply only writes weights to active streams.": "Regola il bandit prima di eseguire un'anteprima. Applica scrive i pesi solo sugli stream attivi.",
  "Two-factor authentication": "Autenticazione a due fattori",
  "Two-factor code": "Codice a due fattori",
  "Type": "Tipo",
  "Type a command or search…": "Digita un comando o cerca…",
  "Ungrouped": "Non raggruppato",
  "Unlimited": "Illimitato",
  "Upload a landing-page bundle (.zip) or pick a hosted pre-landing template from the library.": "Carica un pacchetto di landing page (.zip) oppure scegli un template di prelander ospitato dalla libreria.",
  "Upload, organize and reuse landing pages across your campaigns.": "Carica, organizza e riutilizza le landing page nelle tue campagne.",
  "Uses the seed list (Python requests, Go net/http, curl, headless Chrome) plus your workspace overrides.": "Usa la lista seed (Python requests, Go net/http, curl, Chrome headless) più le sovrascritture del tuo workspace.",
  "Vendor list": "Elenco fornitori",
  "Vendor name (e.g. Google Analytics)": "Nome del fornitore (es. Google Analytics)",
  "Verify now": "Verifica ora",
  "Verifying…": "Verifica in corso…",
  "View": "Visualizza",
  "Views": "Visualizzazioni",
  "Visible metrics": "Metriche visibili",
  "Visitor": "Visitatore",
  "Visual identity": "Identità visiva",
  "Weight floor (%)": "Peso minimo (%)",
  "Weighted": "Ponderato",
  "Welcome to ACME Tracker — sign in to continue": "Benvenuto su ACME Tracker — accedi per continuare",
  "When disabled, the public widget responds with required:false so landing pages skip rendering entirely.": "Quando è disattivato, il widget pubblico risponde con required:false, così le landing page saltano completamente il rendering.",
  "When set, the tracker auto-appends ?<param>=<click_id> to redirect URLs. Leave empty to disable. Use {click_id} in the target URL for full control.": "Quando è impostato, il tracker aggiunge automaticamente ?<param>=<click_id> agli URL di redirect. Lascia vuoto per disattivare. Usa {click_id} nell'URL di destinazione per il controllo completo.",
  "Workflows": "Flussi di lavoro",
  "Workspace default domain": "Dominio predefinito del workspace",
  "Your tracking link": "Il tuo link di tracking",
  "clear tag": "rimuovi tag",
  "clicks": "clic",
  "connections": "connessioni",
  "domains": "domini",
  "e.g. 185.45.12.1, 91.108.0.0": "es. 185.45.12.1, 91.108.0.0",
  "e.g. Facebook, Google, Tier 1": "es. Facebook, Google, Tier 1",
  "e.g. MaxBounty CPA": "es. MaxBounty CPA",
  "e.g. adcombo, cpa, status": "es. adcombo, cpa, status",
  "group.<key>": "group.<key>",
  "installs": "installazioni",
  "live": "live",
  "logo": "logo",
  "max change": "variazione max",
  "no": "no",
  "or continue with": "oppure continua con",
  "revoked": "revocato",
  "rows": "righe",
  "to close": "per chiudere",
  "to navigate": "per navigare",
  "to select": "per selezionare",
  "weight units": "unità di peso",
  "yes": "sì",
  "{count} conversions": "{count} conversioni",
  "{key} breakdown": "Suddivisione per {key}",
  "{n} selected": "{n} selezionati",
  "Δ": "Δ",
  "Sub-ID reports": "Report Sub-ID",
  "Ad accounts": "Account pubblicitari",
  "API docs": "Documentazione API",
  "Drill-down by sub1–sub15: clicks, conversions, CR": "Analisi per sub1–sub15: clic, conversioni, CR",
  "Side-by-side metrics for multiple campaigns": "Metriche a confronto per più campagne",
  "Step-by-step user guide for every feature": "Guida utente passo passo per ogni funzione",
  "Switch to dark theme": "Passa al tema scuro",
  "Switch to light theme": "Passa al tema chiaro",
  "Page not found": "Pagina non trovata",
  "The page you are looking for does not exist or has been moved.": "La pagina che cerchi non esiste o è stata spostata.",
  "Access denied": "Accesso negato",
  "You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.": "Non hai i permessi per visualizzare questa pagina. Contatta l'amministratore del tuo workspace se pensi che sia un errore.",
  "Server error": "Errore del server",
  "Something went wrong on our end. Please try again later or contact support.": "Qualcosa è andato storto da parte nostra. Riprova più tardi o contatta il supporto.",
  "View campaigns": "Visualizza campagne",
  "List and open campaigns and their stats.": "Elenca e apri le campagne e le loro statistiche.",
  "Create campaigns": "Crea campagne",
  "Add new campaigns and their default streams.": "Aggiungi nuove campagne e i relativi stream predefiniti.",
  "Edit campaigns": "Modifica campagne",
  "Change campaign settings, target URL, status.": "Modifica le impostazioni della campagna, l'URL di destinazione e lo stato.",
  "Permanently remove a campaign and its history.": "Rimuove definitivamente una campagna e la sua cronologia.",
  "View landings": "Visualizza landing page",
  "Browse the landing-page library.": "Sfoglia la libreria delle landing page.",
  "Edit landings": "Modifica landing page",
  "Upload, edit, and delete landings.": "Carica, modifica ed elimina landing page.",
  "View offers": "Visualizza offerte",
  "Browse the offer library.": "Sfoglia la libreria delle offerte.",
  "Edit offers": "Modifica offerte",
  "Create, edit, and delete offers.": "Crea, modifica ed elimina offerte.",
  "View anti-fraud": "Visualizza antifrode",
  "Read filter list, blocked samples, audit feed.": "Leggi la lista dei filtri, i campioni bloccati e il feed di audit.",
  "Edit anti-fraud filters": "Modifica filtri antifrode",
  "Create / update / delete fraud filters and IP lists.": "Crea / aggiorna / elimina filtri antifrode e liste IP.",
  "Manage TLS fingerprint overrides": "Gestisci override del fingerprint TLS",
  "Pin JA3 / JA4 hashes per-workspace (overrides the seed list).": "Fissa gli hash JA3 / JA4 per workspace (sostituisce la seed list).",
  "View reports": "Visualizza report",
  "Open the analytics dashboard and saved reports.": "Apri la dashboard di analisi e i report salvati.",
  "Export reports": "Esporta report",
  "Download CSV / JSON report exports.": "Scarica le esportazioni dei report in CSV / JSON.",
  "View automation rules": "Visualizza regole di automazione",
  "Read the rules engine and execution history.": "Leggi il motore delle regole e la cronologia di esecuzione.",
  "Edit automation rules": "Modifica regole di automazione",
  "Create / update / delete automation rules.": "Crea / aggiorna / elimina regole di automazione.",
  "View integrations": "Visualizza integrazioni",
  "Browse integration configurations.": "Sfoglia le configurazioni delle integrazioni.",
  "Edit integrations": "Modifica integrazioni",
  "Connect / disconnect ad accounts and webhooks.": "Collega / scollega account pubblicitari e webhook.",
  "View postbacks": "Visualizza postback",
  "Browse postbacks and the CAPI dead-letter queue.": "Sfoglia i postback e la coda dead-letter (DLQ) della CAPI.",
  "Edit postbacks": "Modifica postback",
  "Configure postbacks, replay / discard CAPI DLQ entries.": "Configura i postback, ripeti / scarta le voci della DLQ della CAPI.",
  "Invite members": "Invita membri",
  "Send invite links to new teammates.": "Invia link di invito ai nuovi membri del team.",
  "Change member role": "Cambia ruolo del membro",
  "Promote / demote existing members.": "Promuovi / retrocedi i membri esistenti.",
  "Remove members": "Rimuovi membri",
  "Revoke a teammate's access.": "Revoca l'accesso di un membro del team.",
  "Edit workspace settings": "Modifica impostazioni dello spazio di lavoro",
  "Change workspace currency, timezone, branding.": "Cambia valuta, fuso orario e branding dello spazio di lavoro.",
  "Edit permission matrix": "Modifica matrice dei permessi",
  "Override the default permission matrix for this workspace.": "Sostituisce la matrice dei permessi predefinita per questo spazio di lavoro.",
  "View billing": "Visualizza fatturazione",
  "See plan, invoices, payment method.": "Consulta piano, fatture e metodo di pagamento.",
  "Change plan, update payment method.": "Cambia piano, aggiorna il metodo di pagamento.",
  "View audit log": "Visualizza registro di audit",
  "Read the workspace audit feed.": "Leggi il feed di audit dello spazio di lavoro.",
  "View tracking domains": "Visualizza domini di tracking",
  "Browse the tracking-domain list.": "Sfoglia la lista dei domini di tracking.",
  "Edit tracking domains": "Modifica domini di tracking",
  "Add / remove tracking domains.": "Aggiungi / rimuovi domini di tracking.",
  "View API keys": "Visualizza chiavi API",
  "List existing API keys (does not reveal the secret).": "Elenca le chiavi API esistenti (non rivela il secret).",
  "Manage API keys": "Gestisci chiavi API",
  "Create / revoke API keys.": "Crea / revoca chiavi API.",
  "Cloaking — send bots to a safe page": "Cloaking — invia i bot a una pagina sicura",
  "Self-hosted cloaking. Bots, ad-network moderators, datacenter/proxy IPs and search crawlers see the safe (white) page; genuine humans go to the real offer. Classification uses the tracker's own bot / IP / crawler-DNS checks — no third-party service.": "Cloaking self-hosted. Bot, moderatori dei network pubblicitari, IP di datacenter/proxy e crawler dei motori di ricerca vedono la pagina sicura (white); gli utenti umani reali vengono indirizzati all'offerta vera. La classificazione usa i controlli interni del tracker su bot / IP / DNS dei crawler — nessun servizio di terze parti.",
  "Safe page URL": "URL della pagina sicura",
  "The compliant page shown to bots/crawlers. Must be an absolute http(s) URL. In SEO mode this is the page verified search crawlers index.": "La pagina conforme mostrata a bot/crawler. Deve essere un URL http(s) assoluto. In modalità SEO è la pagina che i crawler di ricerca verificati indicizzano.",
  "Bots & spoofed crawlers": "Bot e crawler falsificati",
  "Verified search crawlers": "Crawler di ricerca verificati",
  "Datacenter / Tor IPs": "IP datacenter / Tor",
  "Proxy / VPN IPs": "IP proxy / VPN",
  "Enter a valid http(s) Safe page URL for cloaking": "Inserisci un URL http(s) valido della Safe page per il cloaking",
  "Cloaked": "Cloakato",
  "All traffic": "Tutto il traffico",
  "Cloaked only": "Solo cloakati",
  "Real only": "Solo reali",
  "Cloaking": "Cloaking",
  "Bots and crawlers sent to the safe page vs humans to the offer": "Bot e crawler inviati alla safe page vs umani all'offerta",
  "last {n} days": "ultimi {n} giorni",
  "Cloaked → safe page": "Cloakato → safe page",
  "Real → offer": "Reale → offerta",
  "Cloak rate": "Tasso di cloaking",
  "Spoofed crawlers": "Crawler falsificati",
  "Verified crawlers": "Crawler verificati",
  "Datacenter / Tor": "Datacenter / Tor",
  "SEO split (crawlers → index, humans → funnel)": "Split SEO (crawler → index, umani → funnel)",
  "SEO crawler split on: verified crawlers index the page, humans go to the funnel": "Split SEO crawler attivo: i crawler verificati indicizzano la pagina, gli umani vanno al funnel",
  "SEO crawler split off": "Split SEO crawler disattivato",
  "When on, DNS-verified search crawlers get the index page (for ranking) and humans are sent to the bound campaign funnel. Needs an index page + a campaign bound to this domain.": "Quando è attivo, i crawler di ricerca verificati via DNS ricevono la pagina index (per il ranking) e gli umani vengono inviati al funnel della campagna collegata. Richiede una pagina index + una campagna collegata a questo dominio.",
  "Fallback robots/sitemap": "Fallback robots/sitemap",
  "Serve a generated robots.txt / sitemap.xml at the domain root ONLY when your uploaded bundle has none. Your own SEO files always take priority.": "Serve un robots.txt / sitemap.xml generato nella root del dominio SOLO quando il tuo bundle caricato non ne include. I tuoi file SEO hanno sempre la priorità.",
  "Fallback robots.txt/sitemap.xml on (only when your bundle has none)": "Fallback robots.txt/sitemap.xml attivo (solo quando il tuo bundle non ne include)",
  "Fallback robots.txt/sitemap.xml off": "Fallback robots.txt/sitemap.xml disattivato",
  "Root: stable index": "Root: index stabile",
  "Root: SEO split": "Root: split SEO",
  "Root: funnel": "Root: funnel",
  "Root: 404": "Root: 404",
  "own": "proprio",
  "fallback": "fallback",
  "none": "nessuno",
  "indexable": "indicizzabile",
  "no-index": "no-index",
  "Registration": "Registrazione",
  "Deposit": "Deposito",
  "Trash": "Cestino",
  "Hide": "Nascondi",
  "Show": "Mostra",
  "Import from source": "Importa dalla sorgente",
  "Postback token": "Token del postback",
  "Require postback token": "Richiedi token del postback",
  "Network macros": "Macro del network",
  "FTD · Deposit (sale)": "FTD · Deposito (sale)",
  "Chargeback (reject)": "Chargeback (reject)",
  "This campaign has no source with parameters": "Questa campagna non ha nessuna sorgente con parametri",
  "Macros imported from the source — click Save": "Macro importate dalla sorgente — clicca su Salva",
  "Save the campaign once to generate the token.": "Salva la campagna una volta per generare il token.",
  "When ON, incoming postbacks must carry this campaign's token, otherwise they are rejected (401). Turn OFF if the network (e.g. TrackBox) sends ONE shared postback for all campaigns: remove &token=… from this URL and conversions are matched by click_id.": "Quando è ON, i postback in arrivo devono contenere il token di questa campagna, altrimenti vengono rifiutati (401). Disattiva se il network (es. TrackBox) invia UN postback condiviso per tutte le campagne: rimuovi &token=… da questo URL e le conversioni verranno abbinate tramite click_id.",
  "Token check disabled — postbacks are accepted by click_id without a token (remove &token=… from the URL in your network).": "Verifica del token disattivata — i postback vengono accettati tramite click_id senza token (rimuovi &token=… dall'URL nel tuo network).",
  "TrackBox: pass your click_id in the offer link's Affclickid parameter so {affclickid} comes back to this campaign. Method GET.": "TrackBox: passa il tuo click_id nel parametro Affclickid del link dell'offerta in modo che {affclickid} torni a questa campagna. Metodo GET.",
  "Generic: pass your click_id in the offer link so it comes back to this campaign as {click_id}. Method GET.": "Generic: passa il tuo click_id nel link dell'offerta in modo che torni a questa campagna come {click_id}. Metodo GET.",
  "Subid: pass your click_id in the offer link's subid parameter so {subid} comes back to this campaign. Method GET.": "Subid: passa il tuo click_id nel parametro subid del link dell'offerta in modo che {subid} torni a questa campagna. Metodo GET.",
  "Enter the bot token and chat_id — Lead and Deposit postbacks with a ready-made message (Campaign, Sub1..4, Source, Payout) will be added. Then press Save.": "Inserisci il token del bot e il chat_id — verranno aggiunti i postback di Lead e Deposito con un messaggio già pronto (Campagna, Sub1..4, Sorgente, Payout). Poi premi Salva.",
  "What is XPNSR Tracker": "Cos'è XPNSR Tracker",
  "Links & aliases": "Link e alias",
  "Postbacks": "Postback",
  "Macros": "Macro",
  "Redirect modes": "Modalità di reindirizzamento",
  "A/B tests": "Test A/B",
  "Glossary": "Glossario",
  "Partners & lead forms": "Partner e moduli di lead",
  "Google Ads & conversions": "Google Ads e conversioni",
  "Reports (Report Builder)": "Report (Report Builder)",
  "Failed to copy": "Copia non riuscita",
  "Domain opened for indexing": "Dominio aperto all'indicizzazione",
  "Domain closed from indexing": "Dominio chiuso all'indicizzazione",
  "Index page set": "Pagina index impostata",
  "Index page cleared": "Pagina index rimossa",
  "Server migration (admin only)": "Migrazione del server (solo admin)",
  "Current server IP:": "IP attuale del server:",
  "Step 1. Provision a new server": "Passo 1. Avvia un nuovo server",
  "Create an EC2 instance in AWS (Ubuntu, open ports 80 and 443), SSH into it and paste this entire command. It prints the new server IP at the end.": "Crea un'istanza EC2 su AWS (Ubuntu, con le porte 80 e 443 aperte), collegati via SSH e incolla questo comando per intero. Alla fine stamperà l'IP del nuovo server.",
  "Step 2. Enter the new IP": "Passo 2. Inserisci il nuovo IP",
  "Paste the IP from Step 1 and press Save. Every client immediately gets the new IP for their A record — no restart needed.": "Incolla l'IP ottenuto al Passo 1 e premi Salva. Ogni client riceve subito il nuovo IP per il proprio record A — non serve riavviare.",
  "Tip: if you reassign the old Elastic IP to the new server in AWS, nothing needs to change here — nor for clients.": "Suggerimento: se riassegni il vecchio Elastic IP al nuovo server su AWS, qui non devi cambiare nulla — né per i client.",
  "Open for search engines — click to close": "Aperto ai motori di ricerca — clicca per chiudere",
  "Closed from search engines — click to open": "Chiuso ai motori di ricerca — clicca per aprire",
  "Indexable": "Indicizzabile",
  "No-index": "No-index",
  "Index page (SEO, served at the root with 200):": "Pagina index (SEO, servita sulla root con 200):",
  "— none (root opens the funnel) —": "— nessuna (la root apre il funnel) —",
  "Custom API (any CRM)": "Custom API (qualsiasi CRM)",
  "TrackBox account credentials (dashboard → API Testing). Set up once per account — offers will reference this partner.": "Credenziali dell'account TrackBox (dashboard → API Testing). Configurale una volta per account — le offerte faranno riferimento a questo partner.",
  "Username": "Nome utente",
  "Signup path": "Percorso di registrazione",
  "Pull path": "Percorso di pull",
  "Pull type": "Tipo di pull",
  "Auto pull-sync": "Pull-sync automatico",
  "Universal integration for any partner CRM. Describe its lead-registration API request — the tracker will send form data there and redirect using the link from the response.": "Integrazione universale per qualsiasi CRM partner. Descrivi la sua richiesta API di registrazione lead — il tracker invierà lì i dati del modulo e reindirizzerà usando il link ricevuto nella risposta.",
  "API URL (base)": "URL API (base)",
  "Body format": "Formato del body",
  "Headers": "Header",
  "(one \"Key: value\" per line, macros allowed)": "(una coppia \"Key: value\" per riga, sono ammesse le macro)",
  "Body template (JSON)": "Template del body (JSON)",
  "(values are macros in curly braces)": "(i valori sono macro tra parentesi graffe)",
  "Redirect field": "Campo redirect",
  "Success field (optional)": "Campo success (opzionale)",
  "Success value (optional)": "Valore success (opzionale)",
  "plus any form fields and offer parameters. The redirect field is a path in the JSON response (e.g. data.url); if empty, the first http(s) link found in the response is used.": "più eventuali campi del form e parametri dell'offerta. Il campo redirect è un percorso nella risposta JSON (es. data.url); se vuoto, viene usato il primo link http(s) trovato nella risposta.",
  "Set up a partner/CRM here once, then offers reference it. TrackBox / Tigloo is the ready-made adapter; Custom API fits any other CRM. Leads from offer forms are sent to the selected partner.": "Configura qui un partner/CRM una volta sola, poi le offerte lo richiamano. TrackBox / Tigloo è l'adapter già pronto; Custom API va bene per qualsiasi altro CRM. I lead dai form delle offerte vengono inviati al partner selezionato.",
  "Affiliate routing (form offers)": "Routing verso affiliati (offerte con form)",
  "Route this offer to one or more partners with weights (split/rotation). Inactive partners are skipped (e.g. until terms are agreed). The lead goes by weight; on rejection it falls back to the next partner.": "Instrada questa offerta verso uno o più partner con dei pesi (split/rotazione). I partner inattivi vengono saltati (ad es. finché non si concordano i termini). Il lead viene assegnato in base al peso; in caso di rifiuto passa al partner successivo.",
  "Telegram lead alerts": "Avvisi lead su Telegram",
  "(sent on EVERY submit — even test/error)": "(inviato a OGNI submit — anche test/errore)",
  "Every lead captured by your form offers lands here — accepted, rejected and test. Filter, export to CSV and resell. Statuses are updated by postbacks and pull sync.": "Ogni lead catturato dalle tue offerte con form arriva qui — accettati, rifiutati e di test. Filtra, esporta in CSV e rivendi. Gli stati vengono aggiornati tramite postback e sincronizzazione pull.",
  "Hint": "Suggerimento",
  "Cycle language": "Cambia lingua",
  "Switch to {lang}": "Passa a {lang}",
  "Current language: {lang}": "Lingua attuale: {lang}",
  "Scroll to top": "Torna in cima",
  "Something went wrong": "Qualcosa è andato storto",
  "An unexpected error occurred.": "Si è verificato un errore imprevisto.",
  "Reload page": "Ricarica pagina",
  "My first campaign": "La mia prima campagna",
  "CPA Network": "Network CPA",
  "Main FB pixel": "Pixel FB principale",
  "zapier integration": "integrazione zapier",
  "Bot token": "Token del bot",
  "Chat ID": "Chat ID",
  "(no match)": "(nessuna corrispondenza)",
  "+ Upload": "+ Carica",
  "A custom conversion type with its own reporting rules and status transitions.": "Un tipo di conversione personalizzato con proprie regole di reporting e transizioni di stato.",
  "A formula over base metrics rendered as a report column.": "Una formula sulle metriche base, mostrata come colonna del report.",
  "A/B testing": "A/B testing",
  "Add a manual cost, or connect an ad account to sync spend automatically.": "Aggiungi un costo manuale, oppure collega un account pubblicitario per sincronizzare la spesa automaticamente.",
  "Add cost": "Aggiungi costo",
  "Add from preset": "Aggiungi da preset",
  "Add manual cost": "Aggiungi costo manuale",
  "Add partner route": "Aggiungi route partner",
  "Add range": "Aggiungi intervallo",
  "Add value": "Aggiungi valore",
  "Added to blacklist": "Aggiunto alla blacklist",
  "Added to whitelist": "Aggiunto alla whitelist",
  "Adjust the period or campaign filter.": "Modifica il periodo o il filtro campagna.",
  "Affiliate CRM — push leads via API": "CRM di affiliazione — invio lead via API",
  "Affiliate network postback": "Postback del network di affiliazione",
  "All offers": "Tutte le offerte",
  "All rows": "Tutte le righe",
  "Allowed next statuses": "Stati successivi consentiti",
  "Amount": "Importo",
  "Any date": "Qualsiasi data",
  "Any status": "Qualsiasi stato",
  "Arithmetic over base metrics. Supported: + - * / ( ) and numbers.": "Operazioni aritmetiche sulle metriche base. Sono supportati: + - * / ( ) e numeri.",
  "Back to streams": "Torna agli stream",
  "Base metrics": "Metriche base",
  "Bind your own domain to mask tracking links. Point an A record to your tracking server and verify ownership via TXT record.": "Collega un tuo dominio per mascherare i link di tracciamento. Punta un record A al tuo server di tracking e verifica la proprietà tramite un record TXT.",
  "Black": "Nero",
  "Black / white lists": "Liste nere / bianche",
  "Blacklist": "Lista nera",
  "Blacklisted": "In lista nera",
  "Blank referrer (JS)": "Referrer vuoto (JS)",
  "Book spend against a campaign. It is folded into the campaign cost used by ROI and dashboards.": "Registra una spesa su una campagna. Viene inclusa nel costo della campagna usato dal ROI e dalle dashboard.",
  "Bot": "Bot",
  "Bot IP addresses": "Indirizzi IP bot",
  "Bot User-Agent signatures": "Firme User-Agent dei bot",
  "Bot lists": "Liste bot",
  "Bot lists saved": "Liste bot salvate",
  "Breakdown": "Ripartizione",
  "Bucket": "Bucket",
  "Built-in statuses": "Stati integrati",
  "By destination": "Per destinazione",
  "By stream": "Per stream",
  "CPS (per sale)": "CPS (per vendita)",
  "CPuC (per unique click)": "CPuC (per clic unico)",
  "CRM": "CRM",
  "CRM response": "Risposta del CRM",
  "Cadence": "Frequenza",
  "Calendar dates when the stream is active (owner timezone). Leave start or end empty for an open-ended side. 'Is not' inverts the range.": "Date di calendario in cui lo stream è attivo (fuso orario del proprietario). Lascia inizio o fine vuoti per un estremo aperto. 'Non è' inverte l'intervallo.",
  "California, Bavaria, Moscow Oblast": "California, Baviera, Oblast di Mosca",
  "Canonical status stored on each conversion. Auto-generated from the name if left blank.": "Stato canonico memorizzato su ogni conversione. Generato automaticamente dal nome se lasciato vuoto.",
  "Click API (server-to-server)": "API di click (server-to-server)",
  "Code (slug)": "Codice (slug)",
  "Column key in reports. Auto-generated from the name if left blank.": "Chiave della colonna nei report. Generata automaticamente dal nome se lasciata vuota.",
  "Comma-separated email addresses.": "Indirizzi email separati da virgola.",
  "Compensates cost for traffic lost between the source and the tracker: real cost = base / (1 − loss%/100).": "Compensa il costo per il traffico perso tra la sorgente di traffico e il tracker: costo reale = base / (1 − perdita%/100).",
  "Configure any partner CRM lead API": "Configura l'API lead di qualsiasi CRM partner",
  "Conversion date": "Data conversione",
  "Conversion statuses": "Stati conversione",
  "Conversion type created": "Tipo di conversione creato",
  "Conversion type deleted": "Tipo di conversione eliminato",
  "Conversion type updated": "Tipo di conversione aggiornato",
  "Conversion types": "Tipi di conversione",
  "Cookie (default)": "Cookie (predefinito)",
  "Copy blacklist": "Copia lista nera",
  "Copy list": "Copia lista",
  "Copy whitelist": "Copia lista bianca",
  "Cost entries": "Voci di costo",
  "Cost entry added": "Voce di costo aggiunta",
  "Cost entry deleted": "Voce di costo eliminata",
  "Count conversions of this type toward the offer daily cap.": "Conteggia le conversioni di questo tipo nel cap giornaliero dell'offerta.",
  "Counts against offer cap": "Conta nel cap dell'offerta",
  "Counts in conversions": "Conta nelle conversioni",
  "Counts in revenue": "Conta nei ricavi",
  "Counts vs cap": "Conteggio vs cap",
  "Create conversion type": "Crea tipo di conversione",
  "Create custom metric": "Crea metrica personalizzata",
  "Create metric": "Crea metrica",
  "Create one like uCR = conversions / unique_clicks * 100.": "Creane una come uCR = conversions / unique_clicks * 100.",
  "Create one to export campaign performance on demand.": "Creane uno per esportare le performance delle campagne su richiesta.",
  "Create one to map partner statuses like FTD or second deposit.": "Creane uno per mappare gli stati del partner come FTD o secondo deposito.",
  "Create one to receive recurring reports by email.": "Creane uno per ricevere report ricorrenti via email.",
  "Create type": "Crea tipo",
  "Custom bot IPs/CIDRs and UA signatures for the bot-detection filter": "IP/CIDR bot personalizzati e firme UA per il filtro di rilevamento bot",
  "Custom bot IPs/CIDRs and User-Agent signatures used by the bot-detection fraud filter.": "IP/CIDR bot personalizzati e firme User-Agent usati dal filtro antifrode di rilevamento bot.",
  "Custom conversion types: map network statuses, reporting flags and transition rules": "Tipi di conversione personalizzati: mappa gli stati del network, i flag di reportistica e le regole di transizione",
  "Custom metric created": "Metrica personalizzata creata",
  "Custom metric deleted": "Metrica personalizzata eliminata",
  "Custom metric updated": "Metrica personalizzata aggiornata",
  "Custom metrics": "Metriche personalizzate",
  "DSAR erasure completed": "Cancellazione DSAR completata",
  "DSAR export ready": "Esportazione DSAR pronta",
  "Daily": "Giornaliero",
  "Data subject": "Interessato",
  "Data-subject access (Article 15) and erasure (Article 17) by identifier.": "Accesso dell'interessato (Articolo 15) e cancellazione (Articolo 17) per identificatore.",
  "Data-subject export (Art. 15) and erasure (Art. 17) by identifier": "Esportazione dati dell'interessato (Art. 15) e cancellazione (Art. 17) per identificatore",
  "Date": "Data",
  "Date range": "Intervallo di date",
  "Day": "Giorno",
  "Day of month (1-31)": "Giorno del mese (1-31)",
  "Day of week": "Giorno della settimana",
  "Decimals": "Decimali",
  "Define a reusable report and its grouping/metrics.": "Definisci un reporte riutilizzabile e il suo raggruppamento/metriche.",
  "Define custom conversion types, map network statuses and control reporting semantics.": "Definisci tipi di conversione personalizzati, mappa gli stati del network e controlla la semantica dei reportistica.",
  "Define formula-based report columns over base metrics (CR, EPC, ROI variants).": "Definisci colonne di reporte basate su formule sopra le metriche base (CR, EPC, varianti di ROI).",
  "Delete conversion type": "Elimina tipo di conversione",
  "Delete cost entry": "Elimina voce di costo",
  "Delete custom metric": "Elimina metrica personalizzata",
  "Delete file": "Elimina file",
  "Delete report": "Elimina reporte",
  "Delete schedule": "Elimina pianificazione",
  "Delete this file?": "Eliminare questo file?",
  "Desktop, Mobile, Tablet": "Desktop, Mobile, Tablet",
  "Destination": "Destinazione",
  "Distribution": "Distribuzione",
  "Double meta (hide referrer)": "Doppio meta (nascondi referrer)",
  "Dry-run clicks through this campaign to test flow logic and filters — no real traffic is recorded.": "Simula click attraverso questa campagna per testare la logica dei flussi e i filtri — non viene registrato traffico reale.",
  "EPC (sensitive)": "EPC (sensibile)",
  "Edge server updated": "Server edge aggiornato",
  "Edit conversion type": "Modifica tipo di conversione",
  "Edit custom metric": "Modifica metrica personalizzata",
  "Enter a valid amount": "Inserisci un importo valido",
  "Enter at least one identifier": "Inserisci almeno un identificatore",
  "Enter bot token and chat id": "Inserisci il token del bot e il chat id",
  "Enter the text to find": "Inserisci il testo da cercare",
  "Equalize weights": "Equalizza i pesi",
  "Erase": "Cancella",
  "Erase data": "Cancella dati",
  "Erase subject data?": "Cancellare i dati dell'interessato?",
  "Erased": "Cancellato",
  "Erasure is a hard delete and cannot be undone. It requires an admin role.": "La cancellazione è definitiva e non può essere annullata. Richiede un ruolo di amministratore.",
  "Error creating conversion type": "Errore nella creazione del tipo di conversione",
  "Error creating cost entry": "Errore nella creazione della voce di costo",
  "Error creating custom metric": "Errore nella creazione della metrica personalizzata",
  "Error creating report": "Errore nella creazione del reporte",
  "Error creating schedule": "Errore nella creazione della pianificazione",
  "Error deleting conversion type": "Errore nell'eliminazione del tipo di conversione",
  "Error deleting cost entry": "Errore nell'eliminazione della voce di costo",
  "Error deleting custom metric": "Errore nell'eliminazione della metrica personalizzata",
  "Error deleting file": "Errore nell'eliminazione del file",
  "Error deleting report": "Errore nell'eliminazione del reporte",
  "Error deleting schedule": "Errore nell'eliminazione della pianificazione",
  "Error loading bot lists": "Errore nel caricamento delle liste di bot",
  "Error loading conversion types": "Errore nel caricamento dei tipi di conversione",
  "Error loading cost entries": "Errore nel caricamento delle voci di costo",
  "Error loading custom metrics": "Errore nel caricamento delle metriche personalizzate",
  "Error loading reports": "Errore nel caricamento dei reporte",
  "Error loading scheduled reports": "Errore nel caricamento dei reporte pianificati",
  "Error saving bot lists": "Errore nel salvataggio delle liste di bot",
  "Error updating conversion type": "Errore nell'aggiornamento del tipo di conversione",
  "Error updating custom metric": "Errore nell'aggiornamento della metrica personalizzata",
  "Error uploading file": "Errore nel caricamento del file",
  "Every submitted lead is stored here: filter, export (CSV) and resell": "Ogni lead inviato viene salvato qui: filtra, esporta (CSV) e rivendi",
  "Export data": "Esporta dati",
  "Export flows": "Esporta flussi",
  "Exported": "Esportato",
  "Failed to clone stream": "Impossibile clonare lo stream",
  "Failed to equalize weights": "Impossibile equalizzare i pesi",
  "Failed to erase DSAR": "Impossibile cancellare la DSAR",
  "Failed to export DSAR": "Impossibile esportare la DSAR",
  "Failed to export flows": "Impossibile esportare i flussi",
  "Failed to export list": "Impossibile esportare la lista",
  "Failed to export report": "Impossibile esportare il report",
  "Failed to import flows": "Impossibile importare i flussi",
  "Failed to insert flow": "Impossibile inserire il flusso",
  "Failed to load leads": "Impossibile caricare i lead",
  "Failed to remove": "Impossibile rimuovere",
  "Failed to replace URLs": "Impossibile sostituire gli URL",
  "Failed to run report": "Impossibile eseguire il report",
  "Failed to update": "Impossibile aggiornare",
  "Failed to update list": "Impossibile aggiornare la lista",
  "Failed to update schedule": "Impossibile aggiornare la pianificazione",
  "Favourite": "Preferito",
  "Favourite flows": "Flussi preferiti",
  "Favourites": "Preferiti",
  "Fetched": "Recuperato",
  "File deleted": "File eliminato",
  "File uploaded": "File caricato",
  "Filter rule": "Regola di filtro",
  "Find": "Trova",
  "Find and replace a substring in flow redirect URLs (never landing/offer URLs).": "Trova e sostituisci una sottostringa negli URL di redirect dei flussi (mai negli URL di landing page/offerta).",
  "Fire on statuses": "Attiva sugli stati",
  "First 25 simulated clicks and how each was routed.": "I primi 25 click simulati e come ciascuno è stato instradato.",
  "Flag clicks that arrive with no User-Agent header.": "Segnala i click che arrivano senza header User-Agent.",
  "Flow tools": "Strumenti per i flussi",
  "Form submit (POST)": "Invio modulo (POST)",
  "Format": "Formato",
  "Formula": "Formula",
  "Formula is required": "La formula è obbligatoria",
  "Formula-based report columns over base metrics (CR, EPC, ROI variants)": "Colonne di report basate su formule sulle metriche base (CR, EPC, varianti di ROI)",
  "Friday": "Venerdì",
  "From": "Da",
  "GDPR / DSAR": "GDPR / DSAR",
  "Group by": "Raggruppa per",
  "Has label": "Ha etichetta",
  "Headless click registration and the JS adapter for landing pages.": "Registrazione click headless e adattatore JS per le landing page.",
  "Hour": "Ora",
  "Hour (0-23)": "Ora (0-23)",
  "How returning visitors are identified for unique-click detection: Cookie (default), IP, IP+UA, or Parameter — identify by a GET parameter (e.g. external_id) so the same user is recognised across IP/cookie changes.": "Come vengono identificati i visitatori di ritorno per il rilevamento dei click unici: Cookie (predefinito), IP, IP+UA o Parametro — identifica tramite un parametro GET (es. external_id) così lo stesso utente viene riconosciuto anche con cambi di IP/cookie.",
  "IP + User-Agent": "IP + User-Agent",
  "IP of your tracking server": "IP del tuo server di tracking",
  "IPs": "IP",
  "ISP / carrier": "ISP / operatore",
  "Import flows": "Importa flussi",
  "Imported": "Importato",
  "In conversions": "Nelle conversioni",
  "In revenue": "Nei ricavi",
  "Include this type in the conversions column.": "Includi questo tipo nella colonna delle conversioni.",
  "Include this type in the revenue column.": "Includi questo tipo nella colonna dei ricavi.",
  "Insert": "Inserisci",
  "Integration": "Integrazione",
  "JS adapter snippet": "Snippet dell'adattatore JS",
  "Key (e.g. price)": "Chiave (es. price)",
  "Key metrics over time buckets. Toggle to attribute conversions to their arrival date.": "Metriche chiave suddivise per intervalli di tempo. Attiva per attribuire le conversioni alla loro data di arrivo.",
  "Keys": "Chiavi",
  "Label color": "Colore etichetta",
  "Last run": "Ultima esecuzione",
  "Lead export failed": "Esportazione lead non riuscita",
  "Lead storage": "Archiviazione lead",
  "Leads": "Lead",
  "Leads exported": "Lead esportati",
  "Leave empty to count every conversion.": "Lascia vuoto per contare tutte le conversioni.",
  "Leave the period blank to record spend as of now.": "Lascia il periodo vuoto per registrare la spesa a partire da ora.",
  "Lists": "Liste",
  "Manager": "Manager",
  "Manual": "Manuale",
  "Manually record campaign spend the ad-account sync can’t see — flat fees, offline media, corrections.": "Registra manualmente la spesa di campagna che la sincronizzazione dell'account pubblicitario non può vedere — tariffe fisse, media offline, correzioni.",
  "Manually record campaign spend — flat fees, offline media, corrections": "Registra manualmente la spesa della campagna — tariffe fisse, media offline, correzioni",
  "Marked values are reusable as report filters and copyable for ad networks.": "I valori contrassegnati sono riutilizzabili come filtri dei report e copiabili per i network pubblicitari.",
  "Match the X-Requested-With header for webview / in-app browser detection. Substring match — e.g. com.android targets Android webviews; @empty targets clicks with no header.": "Confronta l'header X-Requested-With per rilevare webview / browser in-app. Corrispondenza per sottostringa — es. com.android individua le webview Android; @empty individua i click senza header.",
  "Match the search engine derived from the se / se_referrer params or the referrer host — e.g. google, bing, yandex.": "Confronta il motore di ricerca derivato dai parametri se / se_referrer o dall'host del referrer — es. google, bing, yandex.",
  "Match the visitor's ISP / ASN organisation name (from the offline IP-intel table). Masks, /regex/ and @empty supported — e.g. AMAZON*, *Comcast*.": "Confronta il nome dell'organizzazione ISP / ASN del visitatore (dalla tabella offline di IP-intel). Sono supportate maschere, /regex/ e @empty — es. AMAZON*, *Comcast*.",
  "Matched": "Corrisponde",
  "Metrics": "Metriche",
  "Metrics over time buckets (hour/day/weekday/month) + conversion-date view": "Metriche per intervalli di tempo (ora/giorno/giorno della settimana/mese) + vista per data di conversione",
  "Monday": "Lunedì",
  "Monthly": "Mensile",
  "Moscow, New York": "Mosca, New York",
  "Moscow, New York, London": "Mosca, New York, Londra",
  "Named key/value pairs injected into landing/offer/postback URLs via the {offer_value:NAME} macro.": "Coppie chiave/valore con nome iniettate negli URL di landing page/offerta/postback tramite la macro {offer_value:NAME}.",
  "Network preset…": "Preset network…",
  "Network status values": "Valori di stato del network",
  "New report": "Nuovo report",
  "New saved report": "Nuovo report salvato",
  "New schedule": "Nuova pianificazione",
  "New scheduled report": "Nuovo report pianificato",
  "No cost entries yet": "Ancora nessuna voce di costo",
  "No custom conversion types yet": "Ancora nessun tipo di conversione personalizzato",
  "No custom metrics yet": "Ancora nessuna metrica personalizzata",
  "No data for this period": "Nessun dato per questo periodo",
  "No favourite flows yet. Star a flow to reuse it here.": "Ancora nessun flow preferito. Contrassegna un flow con una stella per riutilizzarlo qui.",
  "No label": "Nessuna etichetta",
  "No leads yet": "Ancora nessun lead",
  "No list entries yet. Use the thumbs buttons on report rows.": "Ancora nessuna voce nella lista. Usa i pulsanti con il pollice sulle righe del report.",
  "No match": "Nessuna corrispondenza",
  "No offer values. Add a key like price, then use {offer_value:price} in URLs.": "Nessun valore dell'offerta. Aggiungi una chiave come price, poi usa {offer_value:price} negli URL.",
  "No partner routes — this is a plain redirect/upload offer.": "Nessuna rotta partner — questa è una semplice offerta di redirect/upload.",
  "No recipients set": "Nessun destinatario impostato",
  "No saved reports yet": "Ancora nessun report salvato",
  "No scheduled reports yet": "Ancora nessun report pianificato",
  "No status values added": "Nessun valore di stato aggiunto",
  "Not accepted": "Non accettato",
  "Note": "Nota",
  "Offer": "Offerta",
  "Offer values": "Valori dell'offerta",
  "One exact IP or CIDR block per line (e.g. 203.0.113.7 or 10.0.0.0/8).": "Un IP esatto o un blocco CIDR per riga (es. 203.0.113.7 o 10.0.0.0/8).",
  "One per line: substring, mask (*) or /regex/.": "Uno per riga: sottostringa, maschera (*) o /regex/.",
  "One value per line (or comma-separated). Each simulated query samples one value from each list.": "Un valore per riga (o separati da virgola). Ogni query simulata campiona un valore da ciascuna lista.",
  "Only these conversion statuses are sent to the ad platform. Default: sale.": "Solo questi stati di conversione vengono inviati alla piattaforma pubblicitaria. Predefinito: sale.",
  "Open Domains": "Apri Domini",
  "Overrides": "Overrides",
  "Owner": "Proprietario",
  "POST /v1/click with an API key (write scope). Returns the routing decision without a browser redirect.": "POST /v1/click con una API key (scope di scrittura). Restituisce la decisione di routing senza redirect del browser.",
  "Parameter name, e.g. external_id": "Nome del parametro, es. external_id",
  "Parameters": "Parametri",
  "Paste on a landing page to auto-append the click id and forward the visitor.": "Incollalo su una landing page per aggiungere automaticamente il click ID e reindirizzare il visitatore.",
  "Per-query trace": "Traccia per query",
  "Period": "Periodo",
  "Period end": "Fine del periodo",
  "Period start": "Inizio del periodo",
  "Phone": "Telefono",
  "Pick a report, cadence and recipients.": "Scegli un report, la frequenza e i destinatari.",
  "Postback added from preset": "Postback aggiunto dal preset",
  "Postback macro": "Macro di postback",
  "Provide at least one identifier. Matching clicks and conversions across your accessible workspaces are affected.": "Fornisci almeno un identificatore. Verranno interessati i click e le conversioni corrispondenti in tutti i tuoi workspace accessibili.",
  "Pull lead statuses and deposits from TrackBox (last 7 days) and update stored leads. Set the Pull x-api-key on the integration first.": "Estrai gli stati dei lead e i depositi da TrackBox (ultimi 7 giorni) e aggiorna i lead salvati. Imposta prima la x-api-key di pull sull'integrazione.",
  "Pull lead statuses from OpenAFF for the number of days set on the integration and update stored leads. Set the status API token on the integration first.": "Estrai gli stati dei lead da OpenAFF per il numero di giorni impostato nell'integrazione e aggiorna i lead salvati. Imposta prima il token dell'API degli stati nell'integrazione.",
  "Pull sync": "Sincronizzazione pull",
  "Pull sync (statuses/deposits)": "Sincronizzazione pull (stati/depositi)",
  "Pull sync done": "Sincronizzazione pull completata",
  "Queries": "Query",
  "ROI %": "ROI %",
  "ROI (sensitive)": "ROI (sensibile)",
  "Raw status strings partner networks send that should map to this type (case-insensitive).": "Stringhe di stato grezze inviate dai network di affiliazione che devono essere mappate a questo tipo (case-insensitive).",
  "Raw statuses to treat as TRASH (recorded but excluded from payouts). E.g. trash, invalid.": "Stati grezzi da trattare come TRASH (registrati ma esclusi dai payout). Es. trash, invalid.",
  "Raw statuses to treat as a DEPOSIT (first-class conversion type). E.g. dep, ftd, deposit.": "Stati grezzi da trattare come DEPOSIT (tipo di conversione di prima classe). Es. dep, ftd, deposit.",
  "Raw statuses to treat as a REGISTRATION (first-class conversion type). E.g. reg, signup.": "Stati grezzi da trattare come REGISTRATION (tipo di conversione di prima classe). Es. reg, signup.",
  "Read-only — only the workspace owner can edit the matrix": "Sola lettura — solo il proprietario del workspace può modificare la matrice",
  "Recipients": "Destinatari",
  "Recurring reports emailed on a daily/weekly/monthly cadence": "Report ricorrenti inviati via email con frequenza giornaliera/settimanale/mensile",
  "Recurring reports emailed to recipients on a daily/weekly/monthly cadence.": "Report ricorrenti inviati via email ai destinatari con frequenza giornaliera/settimanale/mensile.",
  "Removed": "Rimosso",
  "Replace": "Sostituisci",
  "Replace URL": "Sostituisci URL",
  "Replace with": "Sostituisci con",
  "Report deleted": "Report eliminato",
  "Report queued": "Report in coda",
  "Report saved": "Report salvato",
  "Report type": "Tipo di report",
  "Request": "Richiesta",
  "Response sample": "Esempio di risposta",
  "Reusable partner networks: postback, offer params, inbound URL": "Network di affiliazione riutilizzabili: postback, parametri dell'offerta, URL in entrata",
  "Reusable report definitions you can export to CSV or XLSX on demand.": "Definizioni di report riutilizzabili che puoi esportare in CSV o XLSX su richiesta.",
  "Reusable report definitions, exportable to CSV/XLSX on demand": "Definizioni di report riutilizzabili, esportabili in CSV/XLSX su richiesta",
  "RevShare (% of payout)": "RevShare (% del payout)",
  "Revenue (sensitive)": "Ricavi (sensibile)",
  "Routing record (A record)": "Record di instradamento (record A)",
  "Run now": "Esegui ora",
  "Run pull sync": "Esegui sincronizzazione pull",
  "Run simulation": "Esegui simulazione",
  "Runs a rolling 7-day sync. Use this to verify the response before enabling auto pull-sync.": "Esegue una sincronizzazione degli ultimi 7 giorni. Usala per verificare la risposta prima di abilitare la sincronizzazione pull automatica.",
  "Sample datasets": "Set di dati di esempio",
  "Saturday": "Sabato",
  "Saved reports": "Report salvati",
  "Schedule created": "Pianificazione creata",
  "Schedule deleted": "Pianificazione eliminata",
  "Scheduled reports": "Report pianificati",
  "Search conversion types": "Cerca tipi di conversione",
  "Search custom metrics": "Cerca metriche personalizzate",
  "Search engines": "Motori di ricerca",
  "Search presets": "Cerca preset",
  "Send a synthetic lead to the CRM and inspect the response. A throwaway email/phone is used unless you override below.": "Invia un lead sintetico al CRM e controlla la risposta. Viene usata un'email/telefono usa e getta a meno che tu non lo sovrascriva qui sotto.",
  "Send test lead": "Invia lead di prova",
  "Set another entry page first": "Imposta prima un'altra pagina di ingresso",
  "Show shortcuts": "Mostra scorciatoie",
  "Simulate": "Simula",
  "Simulating…": "Simulazione in corso…",
  "Simulation failed": "Simulazione non riuscita",
  "Source": "Sorgente",
  "Starred flows from any campaign. Insert a copy into this campaign.": "Flussi preferiti da qualsiasi campagna. Inserisci una copia in questa campagna.",
  "Stored form leads: name/email/phone/geo/status, filter + CSV export for resale": "Lead da form salvati: nome/email/telefono/GEO/stato, filtro + esportazione CSV per rivendita",
  "Stream cloned": "Stream clonato",
  "Streams changed": "Stream modificati",
  "Streams decide which offer each visitor lands on. Configure your default stream and you'll have a working tracking link.": "Gli stream decidono su quale offerta atterra ogni visitatore. Configura il tuo stream predefinito e avrai un link di tracking funzionante.",
  "Submitted leads from your offer forms will appear here.": "I lead inviati dai form delle tue offerte appariranno qui.",
  "Sunday": "Domenica",
  "Synced": "Sincronizzato",
  "Telegram postbacks added — press Save to apply": "Postback Telegram aggiunti — premi Salva per applicare",
  "Google Ads postbacks added — press Save to apply": "Postback Google Ads aggiunti — premi Salva per applicare",
  "Google Ads preset applied — press Save to apply": "Preset Google Ads applicato — premi Salva per applicare",
  "Also add the standard Google Ads parameters (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) as defaults": "Aggiungi anche i parametri standard di Google Ads (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) come predefiniti",
  "Google Ads postbacks added + click-time gtag turned off — press Save to apply": "Postback Google Ads aggiunti + gtag al momento del click disattivato — premi Salva per applicare",
  "Adding these also turns OFF the click-time gtag (fire on redirect) for this campaign, so the same Google conversion is not counted twice.": "Aggiungendoli si disattiva anche il gtag al momento del click (attivato al redirect) per questa campagna, così la stessa conversione Google non viene conteggiata due volte.",
  "Tracking params (campaignid, adgroupid, keyword, tm, tml, sub1–3) are declared once on the Google Ads traffic source — use \"Import from source\" to add them to a campaign.": "I parametri di tracking (campaignid, adgroupid, keyword, tm, tml, sub1–3) si dichiarano una sola volta sulla sorgente di traffico Google Ads — usa \"Importa dalla sorgente\" per aggiungerli a una campagna.",
  "Google Ads conversions": "Conversioni Google Ads",
  "Outbound only: these HTTP calls notify another system after XPNSR records a conversion. Affiliate-network presets and inbound URLs belong on the Affiliate networks page and must be pasted into the partner dashboard — they are not forwarding rules.": "Solo in uscita: queste chiamate HTTP notificano un altro sistema dopo che XPNSR registra una conversione. I preset dei network di affiliazione e gli URL in entrata vanno inseriti nella pagina Network di affiliazione e incollati nella dashboard del partner — non sono regole di inoltro.",
  "Inbound partner setup: click-ID offer parameters, status mapping, and the postback URL to paste into the partner dashboard. This does not send leads to a CRM and is not campaign S2S forwarding.": "Configurazione in entrata del partner: parametri click ID dell'offerta, mappatura degli stati e l'URL di postback da incollare nella dashboard del partner. Non invia lead a un CRM e non è un inoltro S2S della campagna.",
  "Inbound postback URL template": "Template URL di postback in entrata",
  "Inbound URL for the partner network to call when it reports lead, sale, reject, or another status. Copy this into the partner dashboard; XPNSR does not call this URL as an outgoing campaign postback.": "URL in entrata che il network di affiliazione chiama quando segnala un lead, una vendita, un rifiuto o un altro stato. Copialo nella dashboard del partner; XPNSR non chiama questo URL come postback in uscita della campagna.",
  "Pick an inbound postback preset or configure the partner contract from scratch. For form-to-CRM lead delivery, create an Integration and attach it to the offer instead.": "Scegli un preset di postback in entrata oppure configura l'accordo con il partner da zero. Per l'invio dei lead dal form al CRM, crea invece un'Integrazione e collegala all'offerta.",
  "Google Ads deposit postback added + click-time gtag kept off — press Save to apply": "Postback di deposito Google Ads aggiunto + gtag al momento del click lasciato disattivato — premi Salva per applicare",
  "Legacy click-time conversion: fires on /r/ before any registration or deposit. Keep this disabled for lead/deposit optimization. Real leads are sent automatically from hosted landings after a successful /api/lead response.": "Conversione legacy al momento del click: si attiva su /r/ prima di qualsiasi registrazione o deposito. Tienila disattivata per l'ottimizzazione su lead/deposito. I lead reali vengono inviati automaticamente dalle landing page ospitate dopo una risposta positiva di /api/lead.",
  "Keep this OFF for real conversion optimization. Leads fire online from the hosted landing only after /api/lead succeeds; deposits can be forwarded below by S2S on the broker sale postback. Enabling this makes Google optimize on clicks and can double-count conversions.": "Tienila su OFF per un'ottimizzazione reale delle conversioni. I lead si attivano online dalla landing page ospitata solo dopo che /api/lead va a buon fine; i depositi possono essere inoltrati più sotto via S2S sul postback di vendita del broker. Attivandola, Google ottimizza sui click e può conteggiare le conversioni due volte.",
  "Adds only the deposit/Purchase S2S postback. It fires on the broker sale postback and matches the Google click by {gclid}. The account id and deposit label come from the per-click {tm} tag (AW-<account>/<deposit-label>) in the ad Final URL suffix.": "Aggiunge solo il postback S2S di deposito/Purchase. Si attiva sul postback di vendita del broker e abbina il click Google tramite {gclid}. L'id account e l'etichetta di deposito provengono dal tag {tm} per click (AW-<account>/<deposit-label>) nel suffisso dell'URL finale dell'annuncio.",
  "Deposit → Purchase (with payout value) — fires on sale": "Deposito → Purchase (con valore dell'offerta) — si attiva sulla vendita",
  "Lead S2S is intentionally not added: the hosted landing already sends the Lead conversion online via client-side gtag after the CRM accepts /api/lead. Adding a lead S2S rule would risk double-counting the same lead.": "Il lead S2S non viene aggiunto intenzionalmente: la landing page ospitata invia già la conversione Lead online tramite gtag lato client dopo che il CRM accetta /api/lead. Aggiungere una regola S2S per i lead rischierebbe di conteggiare lo stesso lead due volte.",
  "For online leads, pass tml=AW-<account>/<lead-label> in each ad account Final URL suffix. Keep \"Fire Google Ads gtag on redirect\" OFF: the tracker injects a separate lead gtag into hosted landings and fires it only after a successful lead submission. Configure Lead as Primary when bidding on leads; keep Purchase secondary until deposit reporting is verified, then adjust goals to your bidding strategy.": "Per i lead online, passa tml=AW-<account>/<lead-label> nel suffisso URL finale di ogni account pubblicitario. Lascia DISATTIVATO \"Invia gtag di Google Ads al reindirizzamento\": il tracker inietta un gtag lead separato nelle landing page ospitate e lo invia solo dopo un invio lead riuscito. Imposta Lead come Primario quando fai offerte sui lead; mantieni Acquisto secondario finché il reporting dei depositi non è verificato, poi adatta gli obiettivi alla tua strategia di offerta.",
  "Sends the Google Ads conversion server-side on the broker postback, matched by {gclid} — no gtag on the landing and no API. Account id and label are read from the {tm} tag (AW-<account>/<label>) you already put in the ad Final URL suffix.": "Invia la conversione Google Ads lato server al postback del broker, abbinata tramite {gclid} — nessun gtag sulla landing page e nessuna API. L'id account e la label vengono letti dal tag {tm} (AW-<account>/<label>) già inserito nel suffisso URL finale dell'annuncio.",
  "Deposit → Purchase (primary, with value) — fires on sale": "Deposito → Acquisto (primario, con valore) — si attiva sulla vendita",
  "Registration → Lead (secondary) — fires on lead": "Registrazione → Lead (secondario) — si attiva sul lead",
  "For the Lead tag add its label to the ad Final URL suffix as tml=<label> (same AW account). If tml is empty the Lead beacon is skipped automatically. Keep Lead as Secondary in Google so optimization stays on deposits.": "Per il tag Lead aggiungi la sua label al suffisso URL finale dell'annuncio come tml=<label> (stesso account AW). Se tml è vuoto, il beacon Lead viene saltato automaticamente. Mantieni Lead come Secondario in Google in modo che l'ottimizzazione resti sui depositi.",
  "Test integration": "Testa integrazione",
  "Test lead accepted": "Lead di test accettato",
  "Test lead not accepted": "Lead di test non accettato",
  "This permanently deletes all matching clicks and conversions. This cannot be undone.": "Questo elimina definitivamente tutti i click e le conversioni corrispondenti. L'operazione non può essere annullata.",
  "This permanently deletes the conversion type. Existing conversions keep their stored status.": "Questo elimina definitivamente il tipo di conversione. Le conversioni esistenti mantengono lo stato salvato.",
  "This permanently deletes the metric column from reports.": "Questo elimina definitivamente la colonna della metrica dai report.",
  "This permanently deletes the saved report definition.": "Questo elimina definitivamente la definizione del report salvato.",
  "This permanently deletes the scheduled report.": "Questo elimina definitivamente il report programmato.",
  "This removes the manual cost and reverses its contribution to the campaign spend.": "Questo rimuove il costo manuale e annulla il suo contributo alla spesa della campagna.",
  "Thursday": "Giovedì",
  "To": "A",
  "Total leads": "Lead totali",
  "Tracking domains are managed on the Domains page — add and verify a custom domain there.": "I domini di tracking si gestiscono nella pagina Domini — aggiungi e verifica lì un dominio personalizzato.",
  "Traffic Simulation": "Simulazione del traffico",
  "Traffic loss %": "% di perdita di traffico",
  "Traffic trends": "Tendenze del traffico",
  "Transition rules: which statuses a conversion in this type may move to. Leave all unchecked to allow any transition.": "Regole di transizione: a quali stati può passare una conversione di questo tipo. Lascia tutto deselezionato per permettere qualsiasi transizione.",
  "Treat empty User-Agent as bot": "Tratta lo User-Agent vuoto come bot",
  "Trends": "Tendenze",
  "Tuesday": "Martedì",
  "US, CA, GB": "US, CA, GB",
  "US, CA, GB, RU": "US, CA, GB, RU",
  "US, GB, DE": "US, GB, DE",
  "US,RU,DE": "US,RU,DE",
  "Uniqueness method": "Metodo di unicità",
  "Update reporting semantics and status transitions.": "Aggiorna la semantica dei report e le transizioni di stato.",
  "Update the formula, format or decimals.": "Aggiorna la formula, il formato o i decimali.",
  "Use a negative amount to book a correction.": "Usa un importo negativo per registrare una correzione.",
  "Viewer": "Visualizzatore",
  "Visitor ID": "ID visitatore",
  "Wednesday": "Mercoledì",
  "Weekly": "Settimanale",
  "Weights equalized": "Pesi equalizzati",
  "White": "Bianco",
  "Whitelist": "Lista bianca",
  "Whitelisted": "In lista bianca",
  "X-Requested-With": "X-Requested-With",
  "analyst": "analista",
  "box/goal id": "id di box/goal",
  "buy, cheap, discount": "acquista, economico, sconto",
  "cpa, nutra, en": "cpa, nutra, en",
  "day": "giorno",
  "days": "giorni",
  "e.g. Q3 influencer flat fee": "ad es. Tariffa fissa influencer Q3",
  "e.g. Second deposit": "ad es. Secondo deposito",
  "e.g. Unique CR": "ad es. CR unico",
  "e.g. Weekly digest": "ad es. Riepilogo settimanale",
  "e.g. Weekly performance": "ad es. Performance settimanale",
  "email / phone / name": "email / telefono / nome",
  "free, demo": "gratis, demo",
  "redirect": "redirect",
  "statuses on schedule": "stati in base alla pianificazione",
  "Remove variant": "Rimuovi variante",
  "Start test": "Avvia test",
  "Pause test": "Pausa test",
  "View test results": "Visualizza risultati del test",
  "Remove parameter": "Rimuovi parametro",
  "Remove status mapping": "Rimuovi mappatura di stato",
  "Copy postback URL template": "Copia modello URL postback",
  "Copy inbound postback URL": "Copia URL postback in entrata",
  "Remove IP from blacklist": "Rimuovi IP dalla lista nera",
  "Remove IP from whitelist": "Rimuovi IP dalla lista bianca",
  "Copy curl command": "Copia comando curl",
  "Copy JS snippet": "Copia snippet JS",
  "Copy snippet": "Copia snippet",
  "Remove postback": "Rimuovi postback",
  "Campaign actions": "Azioni campagna",
  "Remove vendor": "Rimuovi fornitore",
  "Remove campaign": "Rimuovi campagna",
  "Remove value": "Rimuovi valore",
  "Remove field": "Rimuovi campo",
  "Copy webhook URL": "Copia URL webhook",
  "Copy landing page URL": "Copia URL della landing page",
  "Open landing page": "Apri landing page",
  "Remove partner route": "Rimuovi route del partner",
  "Copy lead-form URL": "Copia URL del modulo lead",
  "Copy offer URL": "Copia URL dell'offerta",
  "Delete list entry": "Elimina voce dell'elenco",
  "Copy secret": "Copia secret",
  "Remove time range": "Rimuovi intervallo orario",
  "Remove date range": "Rimuovi intervallo di date",
  "Pause stream": "Pausa stream",
  "Resume stream": "Riprendi stream",
  "Open redirect URL": "Apri URL di redirect",
  "Open offer URL": "Apri URL dell'offerta",
  "Copy postback URL": "Copia URL postback",
  "Delete rule": "Elimina regola",
  "Delete filter": "Elimina filtro",
  "Delete traffic rule": "Elimina regola di traffico",
  "This permanently deletes the traffic rule. Traffic will fall through to the remaining rules or the campaign default.": "Questa azione elimina definitivamente la regola di traffico. Il traffico passerà alle regole rimanenti o al valore predefinito della campagna.",
  "Delete fraud filter": "Elimina filtro antifrode",
  "This permanently deletes the fraud filter. Traffic it currently blocks or scores will no longer be evaluated by this rule.": "Questa azione elimina definitivamente il filtro antifrode. Il traffico che attualmente blocca o valuta non sarà più analizzato da questa regola.",
  "Action (no page — hand off to the offer)": "Action (nessuna pagina — passa direttamente all'offerta)",
  "After click (at redirect)": "Dopo il clic (al redirect)",
  "Before click (at landing — enables offer macros)": "Prima del clic (sulla landing page — abilita le macro dell'offerta)",
  "Match the mobile carrier from the edge X-Carrier header. Masks, /regex/ and @empty supported — e.g. Vodafone*, /^T-Mobile/.": "Confronta l'operatore mobile in base all'header X-Carrier dell'edge. Sono supportate maschere, /regex/ e @empty — ad es. Vodafone*, /^T-Mobile/.",
  "Mobile operator / carrier": "Operatore mobile",
  "Offer selection moment": "Momento di selezione dell'offerta",
  "Preload (serve the page from the tracker domain)": "Preload (serve la pagina dal dominio del tracker)",
  "Preload fetches the page server-side and serves it under your tracker domain; Action shows nothing and lets the stream pick an offer.": "Preload recupera la pagina lato server e la serve sotto il tuo dominio del tracker; Action non mostra nulla e lascia che lo stream scelga un'offerta.",
  "QR code": "Codice QR",
  "Redirect (send visitor to the URL)": "Redirect (invia il visitatore all'URL)",
  "Remote rotator (fetch target)": "Rotatore remoto (recupera la destinazione)",
  "Scan to open the tracking link on a device.": "Scansiona per aprire il link di tracking su un dispositivo.",
  "Transparent (server-side fetch)": "Trasparente (recupero lato server)",
  "When to pick the offer for this stream. After (default): at redirect time. Before: at landing-serve time, so {offer_name} / {offer_value:*} macros render on the landing page.": "Quando scegliere l'offerta per questo stream. Dopo (predefinito): al momento del redirect. Prima: al momento della servitura della landing page, così le macro {offer_name} / {offer_value:*} vengono visualizzate sulla landing page.",
  "Added to favourites": "Aggiunto ai preferiti",
  "Credentials and settings for this partner. Fields marked * are required.": "Credenziali e impostazioni per questo partner. I campi contrassegnati con * sono obbligatori.",
  "Key created": "Chiave creata",
  "Removed from favourites": "Rimosso dai preferiti",
  "Affiliate network archived": "Network di affiliazione archiviato",
  "Archive affiliate network": "Archivia network di affiliazione",
  "Archive landing page": "Archivia landing page",
  "Archive offer": "Archivia offerta",
  "Archive stream": "Archivia stream",
  "Archive traffic source": "Archivia sorgente di traffico",
  "Archived at": "Archiviato il",
  "Archived items are hidden from your lists. Restore them or delete them permanently.": "Gli elementi archiviati sono nascosti dalle tue liste. Ripristinali o eliminali definitivamente.",
  "Delete permanently": "Elimina definitivamente",
  "Deleted permanently": "Eliminato definitivamente",
  "Error loading archive": "Errore nel caricamento dell'archivio",
  "Error restoring": "Errore nel ripristino",
  "Landing page archived": "Landing page archiviata",
  "No archived items": "Nessun elemento archiviato",
  "Offer archived": "Offerta archiviata",
  "Restored": "Ripristinato",
  "Stream archived": "Stream archiviato",
  "This will move \"{name}\" to the archive. You can restore it or delete it permanently from the Archive page.": "Questo sposterà \"{name}\" nell'archivio. Puoi ripristinarlo o eliminarlo definitivamente dalla pagina Archivio.",
  "This will permanently delete \"{name}\". This action cannot be undone.": "Questo eliminerà definitivamente \"{name}\". Questa azione non può essere annullata.",
  "Traffic source archived": "Sorgente di traffico archiviata",
  "View archived": "Visualizza archiviati",
  "Start date is required": "La data di inizio è obbligatoria",
  "Enter a valid cost": "Inserisci un costo valido",
  "Updated {n} clicks": "{n} clic aggiornati",
  "Failed to update costs": "Impossibile aggiornare i costi",
  "Statistics deleted": "Statistiche eliminate",
  "Failed to delete statistics": "Impossibile eliminare le statistiche",
  "Maintenance & costs": "Manutenzione e costi",
  "Retroactively rewrite click costs, reset statistics, or grab an alternative tracking link.": "Riscrivi retroattivamente i costi dei clic, azzera le statistiche oppure ottieni un link di tracking alternativo.",
  "Update costs": "Aggiorna costi",
  "Retroactively (re)write per-click cost for clicks in a time range. Total mode spreads the amount across matched clicks; per-click applies it to each.": "(Ri)scrivi retroattivamente il costo per clic per i clic in un intervallo di tempo. La modalità Totale distribuisce l'importo tra i clic corrispondenti; per clic lo applica a ciascuno.",
  "Start date": "Data di inizio",
  "End date": "Data di fine",
  "Total (spread across clicks)": "Totale (distribuito tra i clic)",
  "Per click": "Per clic",
  "Only unique clicks": "Solo clic unici",
  "Skip bot clicks": "Salta i clic dei bot",
  "Clean statistics": "Pulisci statistiche",
  "Alternative link prefixes": "Prefissi di link alternativi",
  "Any of these path prefixes route the same tracking id — rotate them across sources to dodge blocklists.": "Ognuno di questi prefissi di percorso instrada lo stesso tracking id — alternali tra le sorgenti per evitare le blocklist.",
  "Delete statistics": "Elimina statistiche",
  "This permanently deletes all clicks and conversions for this campaign. The campaign configuration is kept. This cannot be undone.": "Questo elimina definitivamente tutti i clic e le conversioni di questa campagna. La configurazione della campagna viene mantenuta. Questa azione non può essere annullata.",
  "Error loading S2S log": "Errore nel caricamento del log S2S",
  "S2S postback log": "Log dei postback S2S",
  "Every outbound conversion postback fired across your campaigns — filter by campaign, status or result.": "Ogni postback di conversione in uscita inviato dalle tue campagne — filtra per campagna, stato o risultato.",
  "Any result": "Qualsiasi risultato",
  "Outbound conversion postbacks will appear here once your campaigns start forwarding conversions.": "I postback di conversione in uscita compariranno qui non appena le tue campagne inizieranno a inoltrare conversioni.",
  "Result": "Risultato",
  "HTTP": "HTTP",
  "Error loading system status": "Errore nel caricamento dello stato del sistema",
  "Paste the Tor exit list first": "Incolla prima la lista dei nodi di uscita Tor",
  "Tor exit list updated": "Lista dei nodi di uscita Tor aggiornata",
  "Failed to update Tor exit list": "Impossibile aggiornare la lista dei nodi di uscita Tor",
  "Process uptime, database size, data-processing queue and host metrics.": "Uptime del processo, dimensione del database, coda di elaborazione dati e metriche dell'host.",
  "Process": "Processo",
  "Uptime": "Uptime",
  "Started": "Avviato",
  "Python": "Python",
  "Platform": "Piattaforma",
  "Database": "Database",
  "Total documents": "Documenti totali",
  "Data processing": "Elaborazione dati",
  "Analytics backend": "Backend di analytics",
  "Ingest mode": "Modalità di ingestione",
  "Queue depth": "Profondità della coda",
  "Click uniqueness": "Unicità dei click",
  "Redis ping": "Ping Redis",
  "Host": "Host",
  "Load average": "Carico medio",
  "Disk used": "Disco usato",
  "Disk free": "Disco libero",
  "Cron": "Cron",
  "Last cost sync": "Ultima sincronizzazione costi",
  "FX rates": "Tassi di cambio",
  "No FX rates cached.": "Nessun tasso di cambio in cache.",
  "Tor exit list": "Lista dei nodi di uscita Tor",
  "Paste a newline-delimited Tor exit-node dump (e.g. from torbulkexitlist) to refresh the in-memory block list.": "Incolla un elenco di nodi di uscita Tor separati da a capo (es. da torbulkexitlist) per aggiornare la block list in memoria.",
  "Replace list": "Sostituisci lista",
  "Error loading fingerprints": "Errore nel caricamento delle fingerprint",
  "Fingerprint updated": "Fingerprint aggiornata",
  "Failed to update fingerprint": "Impossibile aggiornare la fingerprint",
  "JA3 / JA4 fingerprint overrides — mark a fingerprint as good or bad to steer bot detection.": "Override delle fingerprint JA3 / JA4 — contrassegna una fingerprint come buona o cattiva per orientare il rilevamento dei bot.",
  "All classifications": "Tutte le classificazioni",
  "All kinds": "Tutti i tipi",
  "No fingerprint overrides yet": "Ancora nessun override di fingerprint",
  "As traffic arrives, JA3/JA4 fingerprints appear here so you can mark known-good or known-bad clients.": "Man mano che arriva traffico, le fingerprint JA3/JA4 compaiono qui, così puoi contrassegnare i client noti come buoni o cattivi.",
  "Fingerprint": "Fingerprint",
  "Kind": "Tipo",
  "Label": "Etichetta",
  "Hits": "Hit",
  "Last seen": "Ultimo avvistamento",
  "Classification": "Classificazione",
  "Telegram alerts": "Avvisi Telegram",
  "Deploy + server-error notifications for the operator.": "Notifiche di deploy ed errori del server per l'operatore.",
  "Configured": "Configurato",
  "Not configured": "Non configurato",
  "Topic": "Argomento",
  "Topic ID (optional)": "ID del topic (opzionale)",
  "Leave the token empty to keep the saved one.": "Lascia il token vuoto per mantenere quello salvato.",
  "Save & send test": "Salva e invia test",
  "Test message delivered": "Messaggio di test consegnato",
  "Send failed": "Invio non riuscito",
  "Chat ID is required": "Il Chat ID è obbligatorio",
  "Nightly DB backups": "Backup notturni del DB",
  "A full copy of the database every night, kept on the persistent volume.": "Una copia completa del database ogni notte, conservata sul volume persistente.",
  "Daily at": "Ogni giorno alle",
  "Copies kept": "Copie conservate",
  "Stored": "Memorizzato",
  "Latest": "Ultimo",
  "No backups yet": "Ancora nessun backup",
  "Run backup now": "Esegui backup ora",
  "Backup started — the result will arrive in the monitoring topic.": "Backup avviato — il risultato arriverà nel topic di monitoraggio.",
  "Platform admin": "Admin della piattaforma",
  "Operator": "Operatore",
  "Cross-tenant back-office: accounts, access and platform health.": "Back-office cross-tenant: account, accessi e salute della piattaforma.",
  "Accounts": "Account",
  "New sign-ups": "Nuove registrazioni",
  "Last 30 days": "Ultimi 30 giorni",
  "Clicks (24h)": "Click (24h)",
  "Clicks (30d)": "Click (30d)",
  "Conversions (30d)": "Conversioni (30d)",
  "Platform state": "Stato della piattaforma",
  "Self-signup": "Auto-registrazione",
  "Open": "Aperto",
  "Closed": "Chiuso",
  "Controlled by the DISABLE_REGISTRATION variable on Railway.": "Controllato dalla variabile DISABLE_REGISTRATION su Railway.",
  "Root admins": "Admin root",
  "From PLATFORM_ADMIN_EMAILS — manage the list on Railway.": "Da PLATFORM_ADMIN_EMAILS — gestisci l'elenco su Railway.",
  "Granted admins": "Admin concessi",
  "Every registered account. Block access or grant platform admin.": "Tutti gli account registrati. Blocca l'accesso o concedi l'admin di piattaforma.",
  "Search by email or name…": "Cerca per email o nome…",
  "Plan": "Piano",
  "Last click": "Ultimo clic",
  "No accounts found": "Nessun account trovato",
  "Root admin": "Admin root",
  "Client": "Cliente",
  "Managed on Railway": "Gestito su Railway",
  "Grant platform admin": "Concedi admin di piattaforma",
  "Grant platform admin?": "Concedere l'admin di piattaforma?",
  "Make admin": "Rendi admin",
  "Revoke platform admin": "Revoca admin di piattaforma",
  "Revoke platform admin?": "Revocare l'admin di piattaforma?",
  "Revoke admin": "Revoca admin",
  "Block account": "Blocca account",
  "Block this account?": "Bloccare questo account?",
  "The user loses access immediately — every session is rejected until you unblock them. Their campaigns and tracking links keep serving traffic.": "L'utente perde l'accesso immediatamente — ogni sessione viene rifiutata finché non lo sblocchi. Le sue campagne e i link di tracking continuano a servire traffico.",
  "Reason (optional)": "Motivo (facoltativo)",
  "Visible to admins only": "Visibile solo agli admin",
  "Unblock": "Sblocca",
  "Unblock account": "Sblocca account",
  "Unblock this account?": "Sbloccare questo account?",
  "The user will be able to sign in again immediately.": "L'utente potrà accedere di nuovo immediatamente.",
  "This user gets operator access: the platform back-office, every account, and platform settings. The grant is audit-logged.": "Questo utente ottiene l'accesso da operatore: il back-office della piattaforma, tutti gli account e le impostazioni di piattaforma. La concessione viene registrata nel log di audit.",
  "The user keeps their account but loses operator access.": "L'utente mantiene il proprio account ma perde l'accesso da operatore.",
  "Account blocked": "Account bloccato",
  "Account unblocked": "Account sbloccato",
  "Platform admin granted": "Admin di piattaforma concesso",
  "Platform admin revoked": "Admin di piattaforma revocato",
  "Failed to load platform overview": "Impossibile caricare il riepilogo della piattaforma",
  "Failed to load users": "Impossibile caricare gli utenti",
  "{count} accounts": "{count} account",
  "Page {page} of {total}": "Pagina {page} di {total}",
  "Change plan": "Cambia piano",
  "Plan updated": "Piano aggiornato",
  "Sets the edition directly (status \"active\", no trial) — for manual and comp accounts. Accounts with a live Stripe subscription must change plans through Stripe.": "Imposta l'edizione direttamente (stato \"active\", senza prova) — per account manuali e omaggio. Gli account con un abbonamento Stripe attivo devono cambiare piano tramite Stripe.",
  "Account deleted": "Account eliminato",
  "Delete account": "Elimina account",
  "Delete this account permanently?": "Eliminare definitivamente questo account?",
  "This wipes the account and ALL of its data — campaigns, clicks, conversions, offers, landings, domains, reports. It cannot be undone.": "Questo cancella l'account e TUTTI i suoi dati — campagne, clic, conversioni, offerte, landing page, domini, report. Non può essere annullato.",
  "We sent a confirmation link to {email}. Open it to activate your account — the link is valid for 24 hours.": "Abbiamo inviato un link di conferma a {email}. Aprilo per attivare il tuo account — il link è valido per 24 ore.",
  "Check your spam folder if it doesn't arrive within a minute.": "Se non arriva entro un minuto, controlla la cartella spam.",
  "Resend the email": "Invia di nuovo l'email",
  "Sent — check your inbox": "Inviato — controlla la tua casella",
  "Could not resend the email — try again.": "Impossibile inviare di nuovo l'email — riprova.",
  "Back to sign in": "Torna al login",
  "Confirming your email…": "Conferma della tua email…",
  "This takes a second.": "Ci vuole un secondo.",
  "Email confirmed — welcome aboard!": "Email confermata — benvenuto a bordo!",
  "Taking you to your dashboard…": "Ti stiamo portando alla tua dashboard…",
  "Verification failed — the link may have expired.": "Verifica non riuscita — il link potrebbe essere scaduto.",
  "The verification link is incomplete — open the link from the email again.": "Il link di verifica è incompleto — riapri il link dall'email.",
  "Use 8–128 characters; long passphrases are recommended": "Usa da 8 a 128 caratteri; sono consigliate passphrase lunghe",
  "Users": "Utenti",
  "Error": "Errore",
  "Failed to load documentation.": "Impossibile caricare la documentazione.",
  "Production readiness": "Prontezza per la produzione",
  "Ready": "Pronto",
  "Attention required": "Richiede attenzione",
  "Secret-free checks for runtime configuration and isolation controls.": "Controlli senza segreti per la configurazione runtime e i controlli di isolamento.",
  "Environment": "Ambiente",
  "production": "produzione",
  "development": "sviluppo",
  "Rate limiter": "Limitatore di velocità",
  "Access token TTL": "TTL del token di accesso",
  "Backend root": "Backend come root",
  "Blocking checks": "Controlli bloccanti",
  "Failed to load integrity status": "Impossibile caricare lo stato di integrità",
  "Traffic suspended": "Traffico sospeso",
  "Traffic resumed": "Traffico ripreso",
  "Data integrity": "Integrità dei dati",
  "Mandatory unique indexes protect click attribution, conversions and billing idempotency.": "Gli indici univoci obbligatori proteggono l'attribuzione dei click, le conversioni e l'idempotenza della fatturazione.",
  "All mandatory indexes are present and unique.": "Tutti gli indici obbligatori sono presenti e univoci.",
  "Do not ignore this warning. Review backend startup logs before changing indexes.": "Non ignorare questo avviso. Controlla i log di avvio del backend prima di modificare gli indici.",
  "Missing": "Mancante",
  "Not unique": "Non univoco",
  "Resume campaign traffic": "Riprendi il traffico delle campagne",
  "Resume traffic": "Riprendi traffico",
  "Suspend campaign traffic": "Sospendi il traffico delle campagne",
  "Suspend traffic": "Sospendi traffico",
  "Suspend all campaign traffic for this account?": "Vuoi sospendere tutto il traffico delle campagne per questo account?",
  "Public tracking links will return the same inactive-campaign response. Campaign settings stay unchanged, and traffic can be resumed instantly.": "I link di tracciamento pubblici restituiranno la stessa risposta di campagna inattiva. Le impostazioni delle campagne restano invariate e il traffico può essere ripreso all'istante.",
  "Resume campaign traffic for this account?": "Vuoi riprendere il traffico delle campagne per questo account?",
  "Existing active campaigns and tracking links will start serving again.": "Le campagne attive e i link di tracciamento esistenti torneranno a funzionare.",
  "Password changed — other devices have been signed out": "Password cambiata — la sessione è stata chiusa sugli altri dispositivi",
  "Sign out of every device, including this one? You will need to sign in again.": "Vuoi disconnetterti da tutti i dispositivi, incluso questo? Dovrai accedere di nuovo.",
  "All sessions signed out": "Tutte le sessioni sono state chiuse",
  "Error signing out sessions": "Errore durante la chiusura delle sessioni",
  "Changing your password also signs out every other device.": "Cambiare la password chiude anche la sessione su tutti gli altri dispositivi.",
  "Active sessions": "Sessioni attive",
  "Lost a laptop, or think someone else has your password? End every session at once.": "Hai perso un portatile o pensi che qualcun altro conosca la tua password? Chiudi tutte le sessioni in una volta.",
  "This signs out every device, including this one. Signing back in takes one password.": "Questo disconnette tutti i dispositivi, incluso questo. Per rientrare basta la password.",
  "Sign out everywhere": "Disconnetti ovunque",
  "Pages": "Pagine",
  "Copy path": "Copia percorso",
  "Choose your plan": "Scegli il tuo piano",
  "Every plan includes the whole tracker.": "Ogni piano include il tracker completo.",
  "{n} days free": "{n} giorni gratis",
  "Billed today": "Addebitato oggi",
  "Continue": "Continua",
  "Start and Pro: {n} days free, card required. Charged automatically on day {next} unless you cancel. One free trial per account.": "Start e Pro: {n} giorni gratis, carta richiesta. L'addebito avviene automaticamente il giorno {next} salvo disdetta. Una prova gratuita per account.",
  "Could not load plans.": "Impossibile caricare i piani.",
  "Try again": "Riprova",
  "Opening secure payment…": "Apertura del pagamento sicuro…",
  "Could not open the payment page. Choose a plan to continue.": "Non è stato possibile aprire la pagina di pagamento. Scegli un piano per continuare.",
  "Start and Pro come with {n} days free. A card is required up front: Stripe checks it but charges nothing until day {next}, then the plan renews automatically. Cancel any time before the trial ends and you pay nothing. Team and Network are billed on the day you subscribe. One free trial per account.": "Start e Pro includono {n} giorni gratuiti. La carta è richiesta subito: Stripe la verifica ma non addebita nulla fino al giorno {next}, dopodiché il piano si rinnova automaticamente. Annulla in qualsiasi momento prima della fine della prova e non pagherai nulla. Team e Network vengono addebitati il giorno dell'abbonamento. Una prova gratuita per account.",
  "Choose a plan to open your workspace.": "Scegli un piano per aprire il tuo spazio di lavoro.",
  "Payment was not completed. Choose a plan to continue.": "Il pagamento non è stato completato. Scegli un piano per continuare.",
  "Confirming your payment…": "Conferma del pagamento in corso…",
  "Payment received, but confirmation is taking longer than usual. Refresh this page in a minute.": "Pagamento ricevuto, ma la conferma sta richiedendo più tempo del solito. Aggiorna questa pagina tra un minuto.",
  "Payment confirmed. Welcome aboard!": "Pagamento confermato. Benvenuto a bordo!",
  "Free trial until {date}. Your card will be charged automatically on that day — nothing to do. Cancel before then in Manage billing and you pay nothing.": "Prova gratuita fino al {date}. Quel giorno la carta verrà addebitata automaticamente, non devi fare nulla. Annulla prima da Gestisci fatturazione e non pagherai nulla.",
  "Start {n}-day free trial": "Inizia la prova gratuita di {n} giorni",
  "Subscribe": "Abbonati",
  "Your free trial has already been used, so this plan is billed today.": "Hai già utilizzato la tua prova gratuita, quindi questo piano viene addebitato oggi.",
  "To switch plans, contact support — we move you without losing paid days.": "Per cambiare piano, contatta il supporto: ti trasferiamo senza perdere i giorni pagati.",
  "Everything in Network, on your own server or cloud, installed with one command. Unlimited users, domains and history.": "Tutto quello che offre Network, sul tuo server o cloud, installato con un solo comando. Utenti, domini e cronologia illimitati.",
  "After payment you issue your licence key on the page Self-hosted and install the tracker yourself with one command, following the step-by-step guide. If you prefer, we set it up for you or move you off your old tracker. The hosting is billed to you by your provider.": "Dopo il pagamento, genera la tua chiave di licenza nella pagina Self-hosted e installa tu stesso il tracker con un solo comando, seguendo la guida passo passo. Se preferisci, lo configuriamo noi per te oppure ti migriamo dal tuo vecchio tracker. L'hosting ti viene fatturato direttamente dal tuo provider.",
  "Install on your own server": "Installa sul tuo server",
  "Or we set it up for you, on request": "Oppure lo configuriamo noi per te, su richiesta",
  "Your own server or a dedicated cloud, with a licence key.": "Il tuo server o un cloud dedicato, con chiave di licenza.",
  "Monthly or 12 months": "Mensile o 12 mesi",
  "Cannot reach the server. Check your connection and try again.": "Impossibile raggiungere il server. Controlla la connessione e riprova.",
  "Clicks are never counted": "I click non vengono mai conteggiati",
  "However much traffic you send, the invoice does not move.": "Qualunque sia il traffico che invii, la fattura non cambia.",
  "Bots filtered on arrival": "Bot filtrati all'arrivo",
  "Datacenter, VPN and proxy traffic is handled before a page loads.": "Il traffico da datacenter, VPN e proxy viene gestito prima che la pagina si carichi.",
  "First link in five minutes": "Primo link in cinque minuti",
  "Add a source, create a campaign, copy the link.": "Aggiungi una sorgente di traffico, crea una campagna, copia il link.",
  "Your workspace": "Il tuo spazio di lavoro",
  "Everything is already running": "È già tutto attivo",
  "Your workspace, your campaigns, your numbers.": "Il tuo spazio di lavoro, le tue campagne, i tuoi numeri.",
  "Confirm your email": "Conferma la tua email",
  "Open the link we sent and your workspace is ready.": "Apri il link che ti abbiamo inviato e il tuo spazio di lavoro sarà pronto.",
  "Enter your code": "Inserisci il tuo codice",
  "Six digits from your authenticator app.": "Sei cifre dalla tua app di autenticazione.",
  "Create your account": "Crea il tuo account",
  "Two fields and a password. Tracking is live in minutes.": "Due campi e una password. Il tracking è attivo in pochi minuti.",
  "We sent a confirmation link to": "Abbiamo inviato un link di conferma a",
  "Check spam if it is not there within a minute. The link lasts 24 hours.": "Controlla lo spam se non arriva entro un minuto. Il link dura 24 ore.",
  "Sent again. Give it a moment.": "Inviato di nuovo. Dai qualche istante.",
  "Sending": "Invio in corso",
  "Use a different account": "Usa un altro account",
  "Verification code": "Codice di verifica",
  "Checking": "Verifica in corso",
  "Signing in": "Accesso in corso",
  "Your name": "Il tuo nome",
  "At least 8 characters.": "Almeno 8 caratteri.",
  "Creating": "Creazione in corso",
  "Continue with": "Continua con",
  "No account yet?": "Non hai ancora un account?",
  "Create one": "Creane uno",
  "New accounts are closed at the moment.": "Al momento non è possibile creare nuovi account.",
  "Terms": "Termini",
  "and": "e",
  "Privacy": "Privacy",
  "History kept forever": "Cronologia conservata per sempre",
  "Light theme": "Tema chiaro",
  "Dark theme": "Tema scuro",
  "Match system": "Segui il sistema",
  "Theme": "Tema",
  "Navigate": "Naviga",
  "Not included on your plan. Open Billing to upgrade.": "Non incluso nel tuo piano. Apri Fatturazione per effettuare l'upgrade.",
  "Talk to us": "Contattaci",
  "Automatic flow optimiser": "Ottimizzatore automatico dei flussi",
  "Learning bot detection": "Rilevamento bot con apprendimento",
  "Lead forms into a CRM": "Moduli lead verso un CRM",
  "Roles and 31 permissions": "Ruoli e 31 permessi",
  "Single sign on": "Accesso unico (SSO)",
  "We move you off your old tracker": "Ti aiutiamo a migrare dal tuo vecchio tracker",
  "90 days of history": "90 giorni di cronologia",
  "1 year of history": "1 anno di cronologia",
  "2 years of history": "2 anni di cronologia",
  "History kept": "Cronologia conservata",
  "Your first campaigns, with nothing to set up.": "Le tue prime campagne, senza nulla da configurare.",
  "Everything that makes the work run itself.": "Tutto ciò che fa funzionare il lavoro da solo.",
  "A team, with roles and a paper trail.": "Un team, con ruoli e registro delle modifiche.",
  "A network, under your own brand.": "Un network, con il tuo marchio.",
  "Run the tracker on your own server or in a dedicated cloud. Your licence key activates one production server and one test server.": "Esegui il tracker sul tuo server o in un cloud dedicato. La tua chiave di licenza attiva un server di produzione e uno di test.",
  "Self-hosted installs come with the Enterprise plan. Servers activated earlier stop once their current licence runs out.": "L'installazione su server proprio è inclusa nel piano Enterprise. I server attivati in precedenza si fermano allo scadere della licenza attuale.",
  "This is the only time the key is shown. Store it somewhere safe: you enter it when you install the tracker.": "Questa è l'unica volta in cui la chiave viene mostrata. Conservala in un luogo sicuro: la userai per installare il tracker.",
  "A new key replaces the current one at once. Servers that still use the old key cannot renew their licence and stop within {days} days unless you enter the new key on them.": "Una nuova chiave sostituisce subito quella attuale. I server che usano ancora la vecchia chiave non potranno rinnovare la licenza e si fermeranno entro {days} giorni se non inserisci su di essi la nuova chiave.",
  "The server loses its slot right away and stops within {days} days. Use this when you move the tracker to another server.": "Il server perde subito il suo posto e si ferma entro {days} giorni. Usalo quando sposti il tracker su un altro server.",
  "Each server checks in with us once a day and receives a licence valid for {days} days. If it cannot check in, or the subscription ends, it keeps working until that licence runs out and then stops. A test server is limited to {clicks} clicks a day. Only technical data is sent: licence, server id and version, never data about your traffic or your clients.": "Ogni server comunica con noi una volta al giorno e riceve una licenza valida per {days} giorni. Se non riesce a comunicare, o l'abbonamento termina, continua a funzionare finché quella licenza non scade e poi si ferma. Un server di prova è limitato a {clicks} click al giorno. Vengono inviati solo dati tecnici: licenza, id del server e versione, mai dati sul tuo traffico o sui tuoi clienti.",
  "Run this command as root on a fresh server. In about ten minutes it installs everything (Kubernetes, HTTPS certificates, the database and the tracker). Running it again upgrades the install and keeps the data.": "Esegui questo comando come root su un server pulito. In circa dieci minuti installa tutto (Kubernetes, certificati HTTPS, il database e il tracker). Eseguirlo di nuovo aggiorna l'installazione e conserva i dati.",
  "Self-hosted": "Server proprio",
  "Enterprise": "Enterprise",
  "Licence key": "Chiave di licenza",
  "Issue licence key": "Genera chiave di licenza",
  "Rotate key": "Rinnova chiave",
  "Rotate licence key?": "Rinnovare la chiave di licenza?",
  "Licence key issued": "Chiave generata",
  "Server deactivated": "Server disattivato",
  "Deactivate this server?": "Disattivare questo server?",
  "Servers": "Server",
  "Production": "Produzione",
  "Revoked": "Revocata",
  "Deactivated": "Disattivato",
  "Deactivate": "Disattiva",
  "Issued": "Emessa",
  "Version": "Versione",
  "See plans": "Vedi i piani",
  "No servers activated yet.": "Nessun server ancora attivato.",
  "Transfers left (30 days)": "Trasferimenti rimasti (30 giorni)",
  "Could not load this page.": "Impossibile caricare questa pagina.",
  "Licensing is temporarily unavailable. Try again later.": "Le licenze non sono disponibili temporaneamente. Riprova più tardi.",
  "Your server: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu or Debian (x86-64). The tracker installs with one command.": "Il tuo server: 4 core CPU, 8 GB RAM, SSD da 50 GB, Ubuntu o Debian (x86-64). Il tracker si installa con un solo comando.",
  "Put your licence key in place of the X: it is shown once, when you issue or rotate it.": "Metti la tua chiave di licenza al posto delle X: viene mostrata una sola volta, quando la generi o la rinnovi.",
  "The first account signed up with this email gets administrator rights on the server.": "Il primo account registrato con questa email ottiene i diritti di amministratore sul server.",
  "Without --domain the tracker starts on an address like 1-2-3-4.sslip.io. For your own domain, first point tracker.example.com and api.tracker.example.com at the server, then add --domain tracker.example.com.": "Senza --domain il tracker si avvia su un indirizzo come 1-2-3-4.sslip.io. Per usare un tuo dominio, prima punta tracker.example.com e api.tracker.example.com verso il server, poi aggiungi --domain tracker.example.com.",
  "Install on your server": "Installazione sul tuo server",
  "Server requirements": "Requisiti del server",
  "Production server": "Server di produzione",
  "Test server": "Server di prova",
  "Operating system": "Sistema operativo",
  "Disk space": "Spazio su disco",
  "Connection": "Rete",
  "Ubuntu 22.04 / 24.04 or Debian 12, x86-64": "Ubuntu 22.04 / 24.04 o Debian 12, x86-64",
  "4 cores (2 at least)": "4 core (minimo 2)",
  "8 GB (4 GB at least)": "8 GB (minimo 4 GB)",
  "50 GB SSD (30 GB free at least)": "SSD da 50 GB (minimo 30 GB liberi)",
  "Public IP address, ports 80 and 443 open": "IP pubblico, porte 80 e 443 aperte",
  "After the install": "Dopo l'installazione",
  "Server state and licence": "Stato del server e della licenza",
  "Upgrade to the newest signed release": "Aggiorna all'ultima versione firmata",
  "Back up the database to /var/backups/xpnsr": "Backup del database in /var/backups/xpnsr",
  "Copy command": "Copia comando",
  "Install the tracker on your own server in about 15 minutes. You do not need to know Kubernetes or Linux: you copy one command and the installer does the rest.": "Installa il tracker sul tuo server in circa 15 minuti. Non devi conoscere Kubernetes né Linux: copi un comando e l'installer fa il resto.",
  "Install guide": "Guida all'installazione",
  "Step-by-step guide": "Guida passo passo",
  "Back to Self-hosted": "Torna a Server proprio",
  "Step": "Passo",
  "Get a server": "Procurati un server",
  "Optional: your own domain": "Opzionale: il tuo dominio",
  "Issue your licence key": "Emetti la tua chiave di licenza",
  "Connect to the server": "Connettiti al server",
  "Run the install command": "Esegui il comando di installazione",
  "Open your tracker": "Apri il tuo tracker",
  "Keep it running": "Manutenzione",
  "Rent a VPS or cloud server from any provider, for example Hetzner, DigitalOcean, OVH, Vultr or AWS Lightsail: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu 24.04 (x86-64). It usually costs 15–60 USD a month, billed to you by the provider.": "Affitta un VPS o un server cloud da qualsiasi provider, ad esempio Hetzner, DigitalOcean, OVH, Vultr o AWS Lightsail: 4 core CPU, 8 GB RAM, SSD da 50 GB, Ubuntu 24.04 (x86-64). Di solito costa 15–60 USD al mese, fatturati dal provider.",
  "Take a fresh server with nothing else installed, and make sure ports 80 and 443 are open in the provider's firewall.": "Usa un server pulito, senza nient'altro installato, e assicurati che le porte 80 e 443 siano aperte nel firewall del provider.",
  "Note the server's IP address and the root password or SSH key from the provider's panel.": "Annota l'indirizzo IP del server e la password di root o la chiave SSH dal pannello del provider.",
  "For your own address, create two DNS records of type A that point at the server's IP address, for example tracker.example.com and api.tracker.example.com. Skip this to start on a free address like 1-2-3-4.sslip.io; you can switch later.": "Per un indirizzo tuo, crea due record DNS di tipo A che puntino all'indirizzo IP del server, ad esempio tracker.example.com e api.tracker.example.com. Puoi saltare questo passo e iniziare con un indirizzo gratuito come 1-2-3-4.sslip.io; potrai cambiarlo in seguito.",
  "On the page Self-hosted click Issue licence key and save the key somewhere safe: it is shown only once.": "Nella pagina Server proprio clicca su Emetti chiave di licenza e salva la chiave in un posto sicuro: viene mostrata una sola volta.",
  "On Mac or Linux open Terminal, on Windows open PowerShell, and type the command below with your server's IP address. Answer yes to the first question and enter the password.": "Su Mac o Linux apri Terminal, su Windows apri PowerShell, e digita il comando qui sotto con l'indirizzo IP del tuo server. Rispondi yes alla prima domanda e inserisci la password.",
  "Copy the command from the page Self-hosted (your key and email are already in it), paste it into the terminal and press Enter. For your own domain add --domain tracker.example.com to it.": "Copia il comando dalla pagina Server proprio (la tua chiave e la tua email sono già incluse), incollalo nel terminale e premi Invio. Per usare un tuo dominio, aggiungi --domain tracker.example.com.",
  "The install takes about 10 minutes. If the connection drops, the install keeps going: reconnect and follow it with the command below.": "L'installazione richiede circa 10 minuti. Se la connessione si interrompe, l'installazione continua comunque: riconnettiti e seguila con il comando qui sotto.",
  "At the end the installer prints the address of your workspace. Open it and sign up with the administrator email from the command: that account gets administrator rights. The licence activates on its own.": "Alla fine il programma di installazione mostra l'indirizzo del tuo workspace. Aprilo e registrati con l'email amministratore indicata nel comando: quell'account ottiene i diritti di amministratore. La licenza si attiva da sola.",
  "To check everything, run the command below: the licence line should say \"state\":\"active\".": "Per verificare che sia tutto a posto, esegui il comando qui sotto: la riga della licenza deve mostrare \"state\":\"active\".",
  "Updates: the command below installs the newest signed release and keeps your data.": "Aggiornamenti: il comando qui sotto installa l'ultima versione firmata e mantiene i tuoi dati.",
  "Backups: the command below saves the database to /var/backups/xpnsr. Copy it off the server regularly and turn on your provider's snapshots.": "Backup: il comando qui sotto salva il database in /var/backups/xpnsr. Copialo regolarmente fuori dal server e attiva gli snapshot del tuo provider.",
  "Test server: install a second server the same way, choosing Test server on the page Self-hosted.": "Server di test: installa un secondo server allo stesso modo, scegliendo Server di test nella pagina Self-hosted.",
  "If something goes wrong": "Se qualcosa va storto",
  "ports 80/443 are already in use": "ports 80/443 are already in use (porte 80/443 già occupate)",
  "Another web server runs on this machine. Use a fresh server or stop that web server, then run the command again.": "Su questa macchina è già attivo un altro server web. Usa un server pulito oppure ferma quel server web, poi esegui di nuovo il comando.",
  "The browser says the connection is not private": "Il browser dice che la connessione non è privata",
  "The HTTPS certificate is issued a few minutes after DNS points at the server. Wait five minutes; the command below should show READY True.": "Il certificato HTTPS viene rilasciato pochi minuti dopo che il DNS punta al server. Aspetta cinque minuti; il comando qui sotto dovrebbe mostrare READY True.",
  "The licence says the slot is in use": "La licenza dice che lo slot è occupato",
  "The key is already active on another server. Deactivate that server on the page Self-hosted, then enter the key on the licence screen of your workspace, or wait up to an hour.": "La chiave è già attiva su un altro server. Disattiva quel server nella pagina Self-hosted, poi inserisci la chiave nella schermata di licenza del tuo workspace, oppure aspetta fino a un'ora.",
  "licence key not recognised": "licence key not recognised (chiave non riconosciuta)",
  "Paste the key again exactly as saved, or rotate it on the page Self-hosted and use the new one.": "Incolla di nuovo la chiave esattamente come l'hai salvata, oppure rigenerala nella pagina Self-hosted e usa quella nuova.",
  "Anything else": "Qualcos'altro",
  "Run the install command again: it is always safe and continues where it stopped. If that does not help, send us the last lines of /var/log/xpnsr-install.log and the output of xpnsr status.": "Esegui di nuovo il comando di installazione: è sempre sicuro e riprende da dove si era fermato. Se non risolve, inviaci le ultime righe di /var/log/xpnsr-install.log e l'output di xpnsr status.",
  "Prefer that we do it?": "Preferisci che ce ne occupiamo noi?",
  "We install the tracker for you, or move you off your old tracker with your campaigns. You open the server in your own hosting account and give us temporary access; it is included in Enterprise.": "Installiamo il tracker al posto tuo, oppure ti facciamo migrare dal tuo vecchio tracker con tutte le tue campagne. Tu apri il server nel tuo account di hosting e ci dai accesso temporaneo; è incluso nel piano Enterprise.",
  "Write to us": "Scrivici",
  "Fallback rules": "Regole di fallback",
  "Used only when a click matches none of the campaign streams. Set up routing in streams; keep these for rare catch-all cases.": "Usati solo quando un click non corrisponde a nessuno stream della campagna. Configura il routing negli stream e tieni questi per i rari casi catch-all.",
  "Add the banner to your landing page": "Aggiungi il banner alla tua landing page",
  "Paste this line into the <head> of every landing page of the campaign. The banner shows only while it is enabled above, and only to visitors from the chosen regions.": "Incolla questa riga nell'<head> di ogni landing page della campagna. Il banner viene mostrato solo mentre è attivato qui sopra, e solo ai visitatori delle regioni scelte.",
  "Copy code": "Copia codice",
  "No campaigns yet": "Ancora nessuna campagna",
  "Audience": "Audience",
  "Updated at {time}": "Aggiornato alle {time}",
  "Download ZIP": "Scarica ZIP",
  "Download failed": "Download non riuscito",
  "Enter the licence key from your account (page Self-hosted). It activates this server, which then renews its licence once a day on its own.": "Inserisci la chiave di licenza dal tuo account (pagina Self-hosted). Attiva questo server, che poi rinnova la licenza da solo una volta al giorno.",
  "The licence of this installation has run out or is no longer valid, so the tracker is stopped. Check the Enterprise subscription and the key, then activate again.": "La licenza di questa installazione è scaduta o non è più valida, quindi il tracker è stato fermato. Controlla l'abbonamento Enterprise e la chiave, poi riattivalo.",
  "The licence could not be renewed. The tracker keeps working until {date} and then stops unless a renewal succeeds.": "Non è stato possibile rinnovare la licenza. Il tracker continua a funzionare fino al {date} e poi si ferma se il rinnovo non va a buon fine.",
  "Test server: limited to {n} clicks a day.": "Server di prova: limitato a {n} click al giorno.",
  "This installation is not licensed. Ask the administrator to activate it.": "Questa installazione non ha una licenza. Chiedi all'amministratore di attivarla.",
  "Licence activated": "Licenza attivata",
  "Licence expired": "Licenza non valida",
  "Activate this installation": "Attiva questa installazione",
  "Licensed to {who} · licence {id}": "Licenza: {who} · {id}",
  "Live clicks": "Click in tempo reale",
  "Open clicks log": "Apri il log dei click",
  "Could not load clicks": "Impossibile caricare i click",
  "No clicks yet": "Ancora nessun click",
  "Send traffic to a tracking link and every click shows up here as it happens.": "Invia traffico a un link di tracciamento e ogni click comparirà qui in tempo reale.",
  "cloaked": "cloaked",
  "proxy": "proxy",
  "human": "umano",
  "{n}s ago": "{n} s fa",
  "Trend": "Andamento",
  "Clicks, last 14 days": "Click, ultimi 14 giorni",
  "Add level": "Aggiungi livello",
  "Remove level": "Rimuovi livello",
  "Last {n} days": "Ultimi {n} giorni",
  "All time": "Da sempre",
  "JA3 / JA4 fingerprint overrides for bot detection": "Classificazione manuale delle fingerprint JA3 / JA4 per il rilevamento bot",
  "Uptime, DB size, data-processing queue and host metrics": "Uptime, dimensione del DB, coda di elaborazione dati e metriche del server",
  "Outbound conversion postbacks fired across your campaigns": "Postback di conversione in uscita inviati dalle tue campagne",
  "Normal — a regular stream with filters. Catch (intercepting) — checked before Normal streams and takes a matching click first, e.g. bots or a test GEO. Fallback — the last stream; it gets traffic that matched nothing else.": "Normale — uno stream regolare con filtri. Cattura (intercettante) — viene controllato prima degli stream Normali e intercetta per primo un click corrispondente, ad esempio bot o un GEO di test. Fallback — l'ultimo stream; riceve il traffico che non ha trovato corrispondenza altrove.",
  "Interface: search, shortcuts and language": "Interfaccia: ricerca, scorciatoie e lingua",
  "CAPI": "CAPI",
  "FAQ": "FAQ",
  "Cost, integrations & ops": "Costi, integrazioni e operatività",
  "New campaign": "Nuova campagna",
  "Command palette": "Ricerca e comandi",
  "Pre-landing page": "Prelander",
  "good": "buono",
  "bad": "cattivo",
  "unknown": "sconosciuto",
  "Error reports": "Segnalazioni di errore",
  "Server and browser errors grouped by cause. Resolve hides a report until the error happens again; Ignore keeps it quiet.": "Errori del server e del browser raggruppati per causa. Risolvi nasconde un report finché l'errore non si ripete; Ignora lo silenzia.",
  "Unresolved": "Da risolvere",
  "Ignored": "Ignorati",
  "All": "Tutti",
  "All sources": "Tutte le sorgenti",
  "Server": "Server",
  "Search by error text": "Cerca per testo dell'errore",
  "Count": "Conteggio",
  "First seen": "Prima occorrenza",
  "No error reports": "Nessun report di errore",
  "Could not load error reports": "Impossibile caricare i report di errore",
  "Could not load the report": "Impossibile caricare il report",
  "Report updated": "Report aggiornato",
  "Could not update the report": "Impossibile aggiornare il report",
  "Seen {n} times": "Visto {n} volte",
  "Mark resolved": "Segna come risolto",
  "Reopen": "Riapri",
  "Datacenter / hosting VPN / Tor IPs": "IP di datacenter, VPN su hosting e Tor",
  "Visitors from cloud and hosting networks, VPNs that run on them, and Tor exits get the safe page. Residential proxies cannot be recognised without a paid IP database.": "I visitatori da reti cloud e di hosting, le VPN che vi girano sopra e i nodi di uscita Tor ricevono la safe page. I proxy residenziali non possono essere riconosciuti senza un database IP a pagamento.",
  "Offer only with a Google Ads click ID": "Offerta solo con click ID di Google Ads",
  "Real Google Ads clicks always carry gclid, gbraid or wbraid; reviewers and link checkers open the link without one. Visitors without a valid click ID get the safe page. Leave off if auto-tagging is disabled or the campaign gets other traffic.": "I click reali di Google Ads hanno sempre gclid, gbraid o wbraid; i reviewer e i link checker aprono il link senza. I visitatori senza un click ID valido ricevono la safe page. Lascia disattivato se l'auto-tagging è disabilitato o la campagna riceve altro traffico.",
  "Show white page": "Mostra white page",
  "Shows the campaign white page (the page bots get) instead of an offer. Put it in a Default stream with no filters to send visitors that no other stream accepts to the white page instead of the target URL.": "Mostra la white page della campagna (la pagina che vedono i bot) invece di un'offerta. Usala in uno stream Default senza filtri per inviare alla white page, invece che all'URL di destinazione, i visitatori che nessun altro stream accetta.",
  "Transparent mode fetches the page from our server, so the visitor IP and cookies never reach it. Use it only for your own landing pages, not for affiliate offer links, or conversions may not be counted.": "La modalità trasparente carica la pagina dal nostro server, quindi l'IP e i cookie del visitatore non la raggiungono mai. Usala solo per le tue landing page, non per i link delle offerte di affiliazione, altrimenti le conversioni potrebbero non essere conteggiate.",
  "Check failed": "Controllo non riuscito",
  "Can be shown in iframe mode": "Può essere mostrata in modalità iframe",
  "Blocked: visitors will see an empty screen in iframe mode": "Bloccata: in modalità iframe i visitatori vedranno una schermata vuota",
  "Could not confirm: test it on a real phone before launch": "Impossibile confermare: testala su un telefono reale prima del lancio",
  "Check that the page allows framing. Paste the final offer or landing URL your streams send visitors to.": "Verifica che la pagina consenta il framing. Incolla l'URL finale dell'offerta o della landing page a cui i tuoi stream inviano i visitatori.",
  "Checking…": "Controllo in corso…",
  "Check framing": "Controlla il framing",
};

export default it;
